import './ProcurementTracker.css';
import {Context} from '../Context';
import React, { useContext, useEffect, useState, useRef, useMemo, useCallback} from 'react';
import ProcurementTrackerService from '../Services/ProcurementTrackerService';
import PROCORE_LOGO from '../refs/procore.png';
import { FaFileUpload } from "react-icons/fa";
import { MdAdd, MdEdit, MdClose, MdContentCopy } from "react-icons/md";
import { IoSettings, IoArrowBack } from "react-icons/io5";
import { LuWorkflow, LuUser } from "react-icons/lu";

const baseRoutePath = 'https://cornerstoneinc.io/PTViewer/';

const branchList = {
    '02': {
        name: 'Construction (DEC) - Hartselle, AL',
    },
    '04': {
        name: 'Electronics (SEC) - Montgomery, AL',
    },
    '09': {
        name: 'Precast / Modular - KOP, PA',
    }
};

const getAllProjects = async (apiToken, setProjects, setVendorMap, setFailure, setTimestamp) => {
    try {
        const response = await ProcurementTrackerService.getAllProjects(apiToken);
        if (response.status > 199 && response.status < 300) {
            setProjects(response.data.projectMap);
            setVendorMap(response.data.vendorMap);
            setTimestamp(new Date().toISOString());
        } else {
            console.error('Error fetching projects:', response);
            setFailure(`Error: Received status code ${response.status}`);
        }
    } catch (error) {
        console.error('Error fetching projects:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const getProjectSubmittals = async (projectId, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.getProjectSubmittals(projectId, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error fetching project submittals:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error fetching project submittals:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const getVendors = async (apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.getVendors(apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error fetching vendors:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error fetching vendors:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const getSubmittalStatuses = async (apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.getSubmittalStatuses(apiToken);
        if (response.status > 199 && response.status < 300) {
            console.log(response.data)
            setSuccess(response.data);
        } else {
            console.error('Error fetching submittal statuses:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error fetching submittal statuses:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const getAllProcurementWorkflows = async (apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.getAllWorkflows(apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error fetching procurement workflows:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error fetching procurement workflows:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const createProcurementWorkflow = async (workflowData, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.createNewWorkflow(workflowData, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error creating procurement workflow:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error creating procurement workflow:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const updateProcurementWorkflow = async (workflowId, workflowData, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.updateWorkflow(workflowId, workflowData, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error updating procurement workflow:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error updating procurement workflow:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const deleteProcurementWorkflow = async (workflowId, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.deleteWorkflow(workflowId, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error deleting procurement workflow:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error deleting procurement workflow:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const getAllProcurementRoles = async (apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.getAllRoles(apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error fetching procurement roles:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error fetching procurement roles:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const createProcurementRole = async (roleData, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.createNewRole(roleData, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error creating procurement role:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error creating procurement role:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const editProcurementRole = async (roleId, roleData, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.updateRole(roleId, roleData, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error updating procurement role:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error updating procurement role:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const deleteProcurementRole = async (roleId, roleData, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.deleteRole(roleId, roleData, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error deleting procurement role:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error deleting procurement role:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const getAllProjectLineItems = async (projectId, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.getProjectLineItems(projectId, apiToken);
        if (response.status > 199 && response.status < 300) {
            console.log(`Fetched line items for project ${projectId}:`, response.data);
            setSuccess(response.data);
        } else {
            console.error('Error fetching project line items:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error fetching project line items:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const createProjectLineItem = async (lineItemData, apiToken, setSuccess, setFailure) => {
    console.log('creating project line item')
    try {
        const response = await ProcurementTrackerService.createNewLineItem(lineItemData, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error creating project line item:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error creating project line item:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const updateProjectLineItem = async (lineItemData, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.updateLineItem(lineItemData, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
            console.log(response.data);
        } else {
            console.error('Error updating project line item:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error updating project line item:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const deleteProjectLineItem = async (lineItemId, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.deleteLineItem(lineItemId, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error deleting project line item:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error deleting project line item:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const syncProcoreStatus = async (projectId, projectNumber, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.syncProcoreSubmittalStatuses(projectId, projectNumber, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error syncing Procore status:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error syncing Procore status:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const syncProjectSchedule = async (projectNumber, projectSchedule, apiToken, setSuccess, setFailure) => {
    try {
        const response = await ProcurementTrackerService.syncProjectSchedule(projectNumber, projectSchedule, apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error syncing project schedule:', response);
            setFailure(`Error: Received status code ${response.status}`);
        };
    } catch (error) {
        console.error('Error syncing project schedule:', error);
        setFailure(`Error: ${error.message}`);
    };
};

// API CALLS ABOVE THIS POINT

// Format date to MM/DD/YY
const formatTimestamp = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
};

const normalizeCurrencyInput = (value) => {
    const sanitized = String(value ?? '').replace(/[^0-9.]/g, '');
    const [whole, ...fractionParts] = sanitized.split('.');

    if (fractionParts.length === 0) {
        return whole;
    }

    return `${whole}.${fractionParts.join('').slice(0, 2)}`;
};

const formatCurrencyInput = (value) => {
    const normalized = normalizeCurrencyInput(value);
    if (!normalized) return '';

    const [whole, fraction] = normalized.split('.');
    const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return fraction !== undefined ? `${formattedWhole}.${fraction}` : formattedWhole;
};

const parseCurrencyNumber = (value) => {
    const normalized = normalizeCurrencyInput(value);
    if (!normalized) return null;

    return Number.parseFloat(normalized);
};

const US_STATES = [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' }
];

const normalizeZipCodeInput = (value) => String(value ?? '').replace(/\D/g, '').slice(0, 5);

const isValidZipCode = (value) => /^\d{5}$/.test(String(value ?? ''));

const normalizePhoneInput = (value) => String(value ?? '').replace(/\D/g, '').slice(0, 10);

const formatPhoneInput = (value) => {
    const digits = normalizePhoneInput(value);
    if (!digits) return '';

    if (digits.length < 4) {
        return `(${digits}`;
    }

    if (digits.length < 7) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }

    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const ProjectDetails = ({apiToken, userName, workflows, refreshData, selectedProject, closeProjectDetails, projectSubmittals, vendors}) => {
    const tableScrollRef = useRef(null);
    const scrollbarHelperRef = useRef(null);
    const [scrollbarContentWidth, setScrollbarContentWidth] = useState(0);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [createModalSelection, setCreateModalSelection] = useState(null);

    const [formattedSubmittals, setFormattedSubmittals] = useState([]);
    const [selectedSubmittal, setSelectedSubmittal] = useState(null);
    const [submittalSearch, setSubmittalSearch] = useState('');
    const [showSubmittalDropdown, setShowSubmittalDropdown] = useState(false);
    const [filteredSubmittals, setFilteredSubmittals] = useState([]);

    const [selectedVendor, setSelectedVendor] = useState(null);
    const [vendorSearch, setVendorSearch] = useState('');
    const [showVendorDropdown, setShowVendorDropdown] = useState(false);
    const [filteredVendors, setFilteredVendors] = useState([]);

    const [workflowId, setWorkflowId] = useState('');
    const [submittalId, setSubmittalId] = useState(null);
    const [submittalName, setSubmittalName] = useState(null);
    const [specId, setSpecId] = useState(null);
    const [specName, setSpecName] = useState(null);
    const [description, setDescription] = useState(null);
    const [locationId, setLocationId] = useState(null);
    const [locationName, setLocationName] = useState(null);
    const [poNumber, setPoNumber] = useState(null);
    const [vendorId, setVendorId] = useState(null);
    const [vendorName, setVendorName] = useState(null);
    const [workflow, setWorkflow] = useState(null);
    const [scheduleId, setScheduleId] = useState(null);
    const [requestedDate, setRequestedDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [updatedBy, setUpdatedBy] = useState(null);
    const [projectNumber, setProjectNumber] = useState(selectedProject?.project_number ? selectedProject.project_number : null);
    const [projectId, setProjectId] = useState(selectedProject?.id ? selectedProject.id : null);
    const [division, setDivision] = useState(null);
    const [amount, setAmount] = useState(null);
    const [projectManager, setProjectManager] = useState(null);
    const [projectEngineer, setProjectEngineer] = useState(null);
    const [externalOrderNumber, setExternalOrderNumber] = useState(null);
    const [externalReleaseNumber, setExternalReleaseNumber] = useState(null);
    const [externalProjectManager, setExternalProjectManager] = useState(null);
    const [externalProjectEngineer, setExternalProjectEngineer] = useState(null);
    const [externalOffsiteStorage, setExternalOffsiteStorage] = useState(null);
    const [externalNotes, setExternalNotes] = useState(null);
    const [notes, setNotes] = useState(null);
    const [controlNotes, setControlNotes] = useState(null);
    const [shippingAddress, setShippingAddress] = useState(null);
    const [shippingContact, setShippingContact] = useState(null);
    const [issues, setIssues] = useState([]);
    const [newIssueText, setNewIssueText] = useState('');
    const [editingIssueId, setEditingIssueId] = useState(null);
    const [editingIssueText, setEditingIssueText] = useState('');
    const [showHistoricIssues, setShowHistoricIssues] = useState(false);

    // Shipping Address fields
    const [address, setAddress] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState('USA');
    const [shippingAddressDiffersFromProject, setShippingAddressDiffersFromProject] = useState(false);
    
    // Shipping Contact fields
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [extension, setExtension] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [contactTitle, setContactTitle] = useState('');
    const [showShippingContactDropdown, setShowShippingContactDropdown] = useState(false);
    const [shippingContactSelectionLocked, setShippingContactSelectionLocked] = useState(false);
    const [selectedShippingContactId, setSelectedShippingContactId] = useState(null);
    const [shippingContactSearchField, setShippingContactSearchField] = useState('firstName');
    const [showProjectManagerDropdown, setShowProjectManagerDropdown] = useState(false);
    const [showProjectEngineerDropdown, setShowProjectEngineerDropdown] = useState(false);
    const [projectManagerSelectionLocked, setProjectManagerSelectionLocked] = useState(false);
    const [projectEngineerSelectionLocked, setProjectEngineerSelectionLocked] = useState(false);
    const [schedule, setSchedule] = useState('');
    const [showWorkflowPreview, setShowWorkflowPreview] = useState(false);

    const [projectLineItems, setProjectLineItems] = useState([]);
    const [projectLineItemsError, setProjectLineItemsError] = useState(null);
    const [selectedProjectLineItem, setSelectedProjectLineItem] = useState(null);
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [hoveredRow, setHoveredRow] = useState(null);
    const [editingLineItem, setEditingLineItem] = useState(null);
    const [inlineEditingId, setInlineEditingId] = useState(null);
    const [editedSteps, setEditedSteps] = useState([]);
    const [originalShippingAddress, setOriginalShippingAddress] = useState(null);
    const [originalShippingContact, setOriginalShippingContact] = useState(null);

    const [lineItemSearch, setLineItemSearch] = useState('');
    const [filteredLineItems, setFilteredLineItems] = useState([]);
    const [statusFilter, setStatusFilter] = useState([]);
    const [showStatusFilter, setShowStatusFilter] = useState(false);
    const [vendorFilter, setVendorFilter] = useState([]);
    const [showVendorFilter, setShowVendorFilter] = useState(false);
    const [ballInCourtFilter, setBallInCourtFilter] = useState([]);
    const [showBallInCourtFilter, setShowBallInCourtFilter] = useState(false);
    const [nextStepFilter, setNextStepFilter] = useState([]);
    const [showNextStepFilter, setShowNextStepFilter] = useState(false);
    const [daysRemainingMin, setDaysRemainingMin] = useState('');
    const [daysRemainingMax, setDaysRemainingMax] = useState('');
    const [daysRemainingSort, setDaysRemainingSort] = useState(null); // 'asc' or 'desc'
    const [showDaysRemainingFilter, setShowDaysRemainingFilter] = useState(false);
    const [projectedCompleteFrom, setProjectedCompleteFrom] = useState('');
    const [projectedCompleteTo, setProjectedCompleteTo] = useState('');
    const [projectedCompleteSort, setProjectedCompleteSort] = useState(null); // 'asc' or 'desc'
    const [showProjectedCompleteFilter, setShowProjectedCompleteFilter] = useState(false);
    const [expectedCompleteFrom, setExpectedCompleteFrom] = useState('');
    const [expectedCompleteTo, setExpectedCompleteTo] = useState('');
    const [expectedCompleteSort, setExpectedCompleteSort] = useState(null); // 'asc' or 'desc'
    const [showExpectedCompleteFilter, setShowExpectedCompleteFilter] = useState(false);

    const [procoreProjectSyncLoading, setProcoreProjectSyncLoading] = useState(false);
    const [procoreProjectSyncError, setProcoreProjectSyncError] = useState(null);
    const [projectScheduleSyncLoading, setProjectScheduleSyncLoading] = useState(false);
    const [projectScheduleSyncError, setProjectScheduleSyncError] = useState(null);

    const [projectScheduleModalOpen, setProjectScheduleModalOpen] = useState(false);
    const [projectSchedule, setProjectSchedule] = useState(null);
    const [projectScheduleFile, setProjectScheduleFile] = useState(null);

    useEffect(() => {
        console.log(projectLineItems);
    }, [projectLineItems]);

    const handleProcoreProjectSync = () => {
        setProcoreProjectSyncLoading(true);
        setProcoreProjectSyncError(null);
        syncProcoreStatus(selectedProject.id, selectedProject.project_number, apiToken, refreshData, setProcoreProjectSyncError)
            .finally(() => {
                setProcoreProjectSyncLoading(false);
                refreshData();
            });
    };

    const handleProjectScheduleModalOpen = () => {
        setProjectScheduleModalOpen(true);
    };

    const handleProjectScheduleModalClose = () => {
        setProjectScheduleModalOpen(false);
        setProjectSchedule(null);
        setProjectScheduleFile(null);
        setProjectScheduleSyncError(null);
    };

    const handleProjectScheduleSync = () => {
        if (!projectSchedule) {
            setProjectScheduleSyncError('Please upload a CSV file first');
            return;
        }
        setProjectScheduleSyncLoading(true);
        setProjectScheduleSyncError(null);
        syncProjectSchedule(selectedProject.project_number, projectSchedule, apiToken, refreshData, setProjectScheduleSyncError)
            .finally(() => {
                setProjectScheduleSyncLoading(false);
                if (!projectScheduleSyncError) {
                    handleProjectScheduleModalClose();
                    refreshData();
                }
            });
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        
        if (!file.name.endsWith('.csv')) {
            setProjectScheduleSyncError('Please upload a CSV file');
            return;
        }
        
        setProjectScheduleFile(file);
        setProjectScheduleSyncError(null);
        
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const text = e.target.result;
                
                // Helper function to clean and parse a line
                const cleanLine = (line) => {
                    // Remove outer quotes if the entire line is wrapped
                    let cleaned = line.trim();
                    if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                        cleaned = cleaned.slice(1, -1);
                    }
                    return cleaned;
                };
                
                // Helper function to remove quotes from individual values
                const cleanValue = (value) => {
                    if (!value) return value;
                    let cleaned = value.trim();
                    // Remove surrounding quotes
                    while (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                        cleaned = cleaned.slice(1, -1).trim();
                    }
                    return cleaned;
                };
                
                const lines = text.split('\n').filter(line => line.trim());
                
                // Parse header line
                const headerLine = cleanLine(lines[0]);
                const headers = headerLine.split(',').map(h => cleanValue(h));
                
                // Parse data lines
                const data = lines.slice(1).map(line => {
                    const cleanedLine = cleanLine(line);
                    const values = cleanedLine.split(',').map(v => cleanValue(v));
                    const row = {};
                    headers.forEach((header, index) => {
                        let value = values[index] || '';
                        // Strip '%' from percentage values and convert to number
                        if (value.endsWith('%')) {
                            value = parseFloat(value.slice(0, -1).trim());
                        }
                        // Cast Unique_ID to integer
                        else if (header === 'Unique_ID' && value) {
                            value = parseInt(value, 10);
                        }
                        row[header] = value;
                    });
                    return row;
                });
                
                setProjectSchedule(data);
            } catch (error) {
                setProjectScheduleSyncError('Error parsing CSV file: ' + error.message);
                setProjectScheduleFile(null);
                setProjectSchedule(null);
            }
        };
        reader.onerror = () => {
            setProjectScheduleSyncError('Error reading file');
            setProjectScheduleFile(null);
            setProjectSchedule(null);
        };
        reader.readAsText(file);
    };

    useEffect(() => {
        getAllProjectLineItems(selectedProject.project_number, apiToken, setProjectLineItems, setProjectLineItemsError);
    }, [selectedProject]);

    useEffect(() => {
        let filtered = projectLineItems;
        
        // Apply search filter
        if(lineItemSearch !== '') {
            const searchLower = lineItemSearch.toLowerCase();
            filtered = filtered.filter(lineItem => 
                lineItem.submittalName?.toLowerCase().includes(searchLower) ||
                lineItem.specName?.toLowerCase().includes(searchLower) ||
                lineItem.description?.toLowerCase().includes(searchLower) ||
                lineItem.vendorName?.toLowerCase().includes(searchLower) ||
                lineItem.ballInCourt?.type?.toLowerCase().includes(searchLower) ||
                lineItem.ballInCourt?.roleName?.toLowerCase().includes(searchLower) ||
                lineItem.nextStep?.name?.toLowerCase().includes(searchLower)
            );
        }
        
        // Apply status filter
        if(statusFilter.length > 0) {
            filtered = filtered.filter(lineItem => 
                statusFilter.includes(lineItem.status) || 
                (statusFilter.includes('No Status') && !lineItem.status)
            );
        }
        
        // Apply Vendor filter
        if(vendorFilter.length > 0) {
            filtered = filtered.filter(lineItem => 
                vendorFilter.includes(lineItem.vendorName) || 
                (vendorFilter.includes('No Vendor') && !lineItem.vendorName)
            );
        }
        
        // Apply Ball in Court filter
        if(ballInCourtFilter.length > 0) {
            filtered = filtered.filter(lineItem => {
                const ballInCourtKey = lineItem.ballInCourt 
                    ? `${lineItem.ballInCourt.type} - ${lineItem.ballInCourt.roleName}`
                    : 'No Ball in Court';
                return ballInCourtFilter.includes(ballInCourtKey);
            });
        }
        
        // Apply Next Step filter
        if(nextStepFilter.length > 0) {
            filtered = filtered.filter(lineItem => 
                nextStepFilter.includes(lineItem.nextStep?.name) || 
                (nextStepFilter.includes('No Next Step') && !lineItem.nextStep)
            );
        }
        
        // Apply Days Remaining filter
        if(daysRemainingMin !== '' || daysRemainingMax !== '') {
            filtered = filtered.filter(lineItem => {
                const days = lineItem.leadtime;
                if (days === null || days === undefined) return false;
                
                const min = daysRemainingMin === '' ? -Infinity : parseFloat(daysRemainingMin);
                const max = daysRemainingMax === '' ? Infinity : parseFloat(daysRemainingMax);
                
                return days >= min && days <= max;
            });
        }
        
        // Apply Days Remaining sort
        if(daysRemainingSort) {
            filtered = [...filtered].sort((a, b) => {
                const aVal = a.leadtime ?? Infinity;
                const bVal = b.leadtime ?? Infinity;
                return daysRemainingSort === 'asc' ? aVal - bVal : bVal - aVal;
            });
        }
        
        // Apply Projected Complete date filter
        if(projectedCompleteFrom !== '' || projectedCompleteTo !== '') {
            filtered = filtered.filter(lineItem => {
                if (!lineItem.expectedCompletionDate) return false;
                const itemDate = new Date(lineItem.expectedCompletionDate);
                const fromDate = projectedCompleteFrom ? new Date(projectedCompleteFrom) : new Date(-8640000000000000);
                const toDate = projectedCompleteTo ? new Date(projectedCompleteTo) : new Date(8640000000000000);
                return itemDate >= fromDate && itemDate <= toDate;
            });
        }
        
        // Apply Projected Complete sort
        if(projectedCompleteSort) {
            filtered = [...filtered].sort((a, b) => {
                const aDate = a.expectedCompletionDate ? new Date(a.expectedCompletionDate).getTime() : Infinity;
                const bDate = b.expectedCompletionDate ? new Date(b.expectedCompletionDate).getTime() : Infinity;
                return projectedCompleteSort === 'asc' ? aDate - bDate : bDate - aDate;
            });
        }
        
        // Apply Expected Complete date filter
        if(expectedCompleteFrom !== '' || expectedCompleteTo !== '') {
            filtered = filtered.filter(lineItem => {
                if (!lineItem.requestDate) return false;
                const itemDate = new Date(lineItem.requestDate);
                const fromDate = expectedCompleteFrom ? new Date(expectedCompleteFrom) : new Date(-8640000000000000);
                const toDate = expectedCompleteTo ? new Date(expectedCompleteTo) : new Date(8640000000000000);
                return itemDate >= fromDate && itemDate <= toDate;
            });
        }
        
        // Apply Expected Complete sort
        if(expectedCompleteSort) {
            filtered = [...filtered].sort((a, b) => {
                const aDate = a.requestDate ? new Date(a.requestDate).getTime() : Infinity;
                const bDate = b.requestDate ? new Date(b.requestDate).getTime() : Infinity;
                return expectedCompleteSort === 'asc' ? aDate - bDate : bDate - aDate;
            });
        }
        
        setFilteredLineItems(filtered);
    }, [lineItemSearch, projectLineItems, statusFilter, vendorFilter, ballInCourtFilter, nextStepFilter, daysRemainingMin, daysRemainingMax, daysRemainingSort, projectedCompleteFrom, projectedCompleteTo, projectedCompleteSort, expectedCompleteFrom, expectedCompleteTo, expectedCompleteSort]);

    useEffect(() => {
        if(createModalSelection === 'submittals') {
            setFilteredSubmittals(
                formattedSubmittals.filter(submittal => {
                    const searchLower = submittalSearch.toLowerCase();
                    return (
                        submittal.name?.toLowerCase().includes(searchLower) ||
                        submittal.formattedNumber?.toLowerCase().includes(searchLower) ||
                        submittal.specName?.toLowerCase().includes(searchLower) ||
                        submittal.type?.toLowerCase().includes(searchLower) ||
                        submittal.vendorName?.toLowerCase().includes(searchLower)
                    );
                })
            )
        }
        else if(createModalSelection === 'manual') {
            console.log(vendorSearch)
            setFilteredVendors(
                vendors?.filter(vendor => {
                    const searchLower = vendorSearch.toLowerCase();
                    return (
                        vendor.name?.toLowerCase().includes(searchLower) ||
                        vendor.address?.toLowerCase().includes(searchLower) ||
                        vendor.city?.toLowerCase().includes(searchLower) ||
                        vendor.state?.toLowerCase().includes(searchLower) ||
                        vendor.zip?.toLowerCase().includes(searchLower)
                    );
                })
            )
        }
    }, [submittalSearch, vendorSearch, vendors, formattedSubmittals, createModalSelection]);

    useEffect(() => {
        if(!projectSubmittals) return;
        let formatted = [];
        projectSubmittals.forEach(element => {
            const temporaryObject = {
                id: element.id,
                name: element.title,
                formattedNumber: element.formatted_number,
                specId: element.specification_section.id,
                specRevId: element.specification_section.current_revision_id,
                specName: element.specification_section.label,
                type: element.type.name,
                status: element.status.name,
                vendorId: element.responsible_contractor.id,
                vendorName: element.responsible_contractor.name
            };
            //if(temporaryObject.vendorName !== 'Cornerstone Detention Products Inc.') formatted.push(temporaryObject);
            formatted.push(temporaryObject);
        });
        setFormattedSubmittals(formatted);
    }, [projectSubmittals]);

    const handleMainScroll = (e) => {
        if (scrollbarHelperRef.current && scrollbarHelperRef.current.scrollLeft !== e.target.scrollLeft) {
            scrollbarHelperRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const handleHelperScroll = (e) => {
        if (tableScrollRef.current && tableScrollRef.current.scrollLeft !== e.target.scrollLeft) {
            tableScrollRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const closeCreateModal = useCallback(() => {
        setShowCreateModal(false);
        setCreateModalSelection(null);
        setSelectedSubmittal(null);
        setSubmittalSearch('');
        setShowSubmittalDropdown(false);
        setSelectedVendor(null);
        setVendorSearch('');
        setShowVendorDropdown(false);
        setWorkflowId('');
        setWorkflow(null);
        setAddress('');
        setAddress2('');
        setCity('');
        setState('');
        setZip('');
        setCountry('USA');
        setShippingAddressDiffersFromProject(false);
        setFirstName('');
        setLastName('');
        setContactNumber('');
        setExtension('');
        setContactEmail('');
        setContactTitle('');
        setShowShippingContactDropdown(false);
        setShippingContactSelectionLocked(false);
        setSelectedShippingContactId(null);
        setShippingContactSearchField('firstName');
        setShowProjectManagerDropdown(false);
        setShowProjectEngineerDropdown(false);
        setProjectManagerSelectionLocked(false);
        setProjectEngineerSelectionLocked(false);
        setDescription(null);
        setProjectManager(null);
        setProjectEngineer(null);
        setPoNumber(null);
        setNotes(null);
        setVendorName(null);
        setShowWorkflowPreview(false);
        setEditingLineItem(null);
    }, []);

    const applyProjectAddressDefaults = useCallback(() => {
        setAddress(selectedProject?.address || '');
        setAddress2('');
        setCity(selectedProject?.city || '');
        setState(selectedProject?.state || '');
        setZip(normalizeZipCodeInput(selectedProject?.zip || ''));
        setCountry('USA');
    }, [selectedProject]);

    const handleCreateModeSelection = useCallback((mode) => {
        setCreateModalSelection(mode);
        if (mode === 'submittals' || mode === 'manual') {
            setShippingAddressDiffersFromProject(false);
            setShowShippingContactDropdown(false);
            setShippingContactSelectionLocked(false);
            setSelectedShippingContactId(null);
            setShippingContactSearchField('firstName');
            setShowProjectManagerDropdown(false);
            setShowProjectEngineerDropdown(false);
            setProjectManagerSelectionLocked(false);
            setProjectEngineerSelectionLocked(false);
            applyProjectAddressDefaults();
        }
    }, [applyProjectAddressDefaults]);

    const hasCreateModalInput = useMemo(() => {
        const hasTextInput = [
            submittalSearch,
            vendorSearch,
            description,
            projectManager,
            projectEngineer,
            poNumber,
            notes,
            address,
            address2,
            city,
            state,
            zip,
            firstName,
            lastName,
            contactNumber,
            extension,
            contactEmail,
            contactTitle
        ].some((value) => typeof value === 'string' && value.trim() !== '');

        return (
            hasTextInput ||
            Boolean(selectedSubmittal) ||
            Boolean(selectedVendor) ||
            Boolean(workflow) ||
            Boolean(workflowId) ||
            country !== 'USA'
        );
    }, [
        submittalSearch,
        vendorSearch,
        description,
        projectManager,
        projectEngineer,
        poNumber,
        notes,
        address,
        address2,
        city,
        state,
        zip,
        firstName,
        lastName,
        contactNumber,
        extension,
        contactEmail,
        contactTitle,
        selectedSubmittal,
        selectedVendor,
        workflow,
        workflowId,
        country
    ]);

    const handleCloseCreateModalAttempt = useCallback(() => {
        if (hasCreateModalInput) {
            const shouldClose = window.confirm('You have unsaved input. Are you sure you want to close this window?');
            if (!shouldClose) return;
        }

        closeCreateModal();
    }, [hasCreateModalInput, closeCreateModal]);

    const createNewLineItemObject = () => {
        return {
            submittalId,
            submittalName,
            specId,
            specName,
            description,
            locationId,
            locationName,
            poNumber,
            vendorId,
            vendorName,
            workflowId: workflow.id,
            scheduleId,
            requestedDate,
            updatedBy,
            projectNumber,
            projectId,
            division,
            amount,
            projectManager,
            projectEngineer,
            notes,
            shippingAddress,
            shippingContact,
            updatedBy: userName
        };
    };

    const handleSuccessfulUpdate = useCallback(() => {
        refreshData();
        getAllProjectLineItems(selectedProject.project_number, apiToken, setProjectLineItems, setProjectLineItemsError);
        closeCreateModal();
    }, [refreshData, closeCreateModal, selectedProject, apiToken]);

    const handleUpdateError = useCallback((error) => {
        console.error(error);
    }, []);

    const createNewLineItem = useCallback(() => {
        console.log(description)
        const newLineItem = createNewLineItemObject();
        createProjectLineItem(newLineItem,apiToken, () => {
            handleSuccessfulUpdate();
        }, (error) => {
            handleUpdateError(error);
        });
    }, [apiToken, createNewLineItemObject, handleSuccessfulUpdate, handleUpdateError]);

    const handleRowClick = (lineItem) => {
        setSelectedProjectLineItem({
            ...lineItem,
            projectDisplayName: selectedProject?.displayName
        });
    };

    const toggleStatusFilter = (status) => {
        setStatusFilter(prev => 
            prev.includes(status) 
                ? prev.filter(s => s !== status)
                : [...prev, status]
        );
    };

    const clearStatusFilter = () => {
        setStatusFilter([]);
    };

    const toggleVendorFilter = (vendor) => {
        setVendorFilter(prev => 
            prev.includes(vendor) 
                ? prev.filter(v => v !== vendor)
                : [...prev, vendor]
        );
    };

    const clearVendorFilter = () => {
        setVendorFilter([]);
    };

    const toggleBallInCourtFilter = (ballInCourt) => {
        setBallInCourtFilter(prev => 
            prev.includes(ballInCourt) 
                ? prev.filter(b => b !== ballInCourt)
                : [...prev, ballInCourt]
        );
    };

    const clearBallInCourtFilter = () => {
        setBallInCourtFilter([]);
    };

    const toggleNextStepFilter = (nextStep) => {
        setNextStepFilter(prev => 
            prev.includes(nextStep) 
                ? prev.filter(n => n !== nextStep)
                : [...prev, nextStep]
        );
    };

    const clearNextStepFilter = () => {
        setNextStepFilter([]);
    };

    const clearDaysRemainingFilter = () => {
        setDaysRemainingMin('');
        setDaysRemainingMax('');
        setDaysRemainingSort(null);
    };

    const clearProjectedCompleteFilter = () => {
        setProjectedCompleteFrom('');
        setProjectedCompleteTo('');
        setProjectedCompleteSort(null);
    };

    const clearExpectedCompleteFilter = () => {
        setExpectedCompleteFrom('');
        setExpectedCompleteTo('');
        setExpectedCompleteSort(null);
    };

    const handleDaysRemainingSort = (direction) => {
        setDaysRemainingSort(direction);
    };

    const handleProjectedCompleteSort = (direction) => {
        setProjectedCompleteSort(direction);
    };

    const handleExpectedCompleteSort = (direction) => {
        setExpectedCompleteSort(direction);
    };

    const uniqueStatuses = useMemo(() => {
        const statuses = new Set();
        projectLineItems.forEach(item => {
            if (item.status) {
                statuses.add(item.status);
            } else {
                statuses.add('No Status');
            }
        });
        return Array.from(statuses).sort();
    }, [projectLineItems]);

    const uniqueVendors = useMemo(() => {
        const vendors = new Set();
        projectLineItems.forEach(item => {
            if (item.vendorName) {
                vendors.add(item.vendorName);
            } else {
                vendors.add('No Vendor');
            }
        });
        return Array.from(vendors).sort();
    }, [projectLineItems]);

    const uniqueBallInCourt = useMemo(() => {
        const ballInCourts = new Set();
        projectLineItems.forEach(item => {
            if (item.ballInCourt) {
                ballInCourts.add(`${item.ballInCourt.type} - ${item.ballInCourt.roleName}`);
            } else {
                ballInCourts.add('No Ball in Court');
            }
        });
        return Array.from(ballInCourts).sort();
    }, [projectLineItems]);

    const uniqueNextSteps = useMemo(() => {
        const nextSteps = new Set();
        projectLineItems.forEach(item => {
            if (item.nextStep) {
                nextSteps.add(item.nextStep.name);
            } else {
                nextSteps.add('No Next Step');
            }
        });
        return Array.from(nextSteps).sort();
    }, [projectLineItems]);

    const previouslyUsedShippingContacts = useMemo(() => {
        const contactMap = new Map();

        projectLineItems.forEach((lineItem) => {
            const shippingContactRecord = lineItem?.shippingContact;
            if (!shippingContactRecord) return;

            const shippingContactFirstName = String(shippingContactRecord.firstName ?? shippingContactRecord.first_name ?? '').trim();
            const shippingContactLastName = String(shippingContactRecord.lastName ?? shippingContactRecord.last_name ?? '').trim();
            const shippingContactTitle = String(shippingContactRecord.title ?? '').trim();
            const shippingContactEmail = String(shippingContactRecord.email ?? '').trim();
            const shippingContactPhone = normalizePhoneInput(shippingContactRecord.phone ?? shippingContactRecord.number ?? '');
            const shippingContactExtension = String(shippingContactRecord.extension ?? '').trim();

            if (!shippingContactFirstName && !shippingContactLastName && !shippingContactTitle && !shippingContactEmail && !shippingContactPhone && !shippingContactExtension) {
                return;
            }

            const contactKey = [
                shippingContactFirstName.toLowerCase(),
                shippingContactLastName.toLowerCase(),
                shippingContactTitle.toLowerCase(),
                shippingContactEmail.toLowerCase(),
                shippingContactPhone,
                shippingContactExtension.toLowerCase()
            ].join('|');

            if (!contactMap.has(contactKey)) {
                contactMap.set(contactKey, {
                    id: shippingContactRecord.id || null,
                    firstName: shippingContactFirstName,
                    lastName: shippingContactLastName,
                    title: shippingContactTitle,
                    email: shippingContactEmail,
                    phone: shippingContactPhone,
                    extension: shippingContactExtension
                });
            }
        });

        return Array.from(contactMap.values()).sort((contactA, contactB) => {
            const firstNameCompare = contactA.firstName.localeCompare(contactB.firstName, undefined, { sensitivity: 'base' });
            if (firstNameCompare !== 0) return firstNameCompare;
            return contactA.lastName.localeCompare(contactB.lastName, undefined, { sensitivity: 'base' });
        });
    }, [projectLineItems]);

    const previouslyUsedProjectManagers = useMemo(() => {
        const managerSet = new Set();

        projectLineItems.forEach((lineItem) => {
            const managerName = String(lineItem?.projectManager ?? '').trim();
            if (managerName) {
                managerSet.add(managerName);
            }
        });

        return Array.from(managerSet).sort((managerA, managerB) => managerA.localeCompare(managerB, undefined, { sensitivity: 'base' }));
    }, [projectLineItems]);

    const previouslyUsedProjectEngineers = useMemo(() => {
        const engineerSet = new Set();

        projectLineItems.forEach((lineItem) => {
            const engineerName = String(lineItem?.projectEngineer ?? '').trim();
            if (engineerName) {
                engineerSet.add(engineerName);
            }
        });

        return Array.from(engineerSet).sort((engineerA, engineerB) => engineerA.localeCompare(engineerB, undefined, { sensitivity: 'base' }));
    }, [projectLineItems]);

    const handleMinimizeClick = (e, lineItemId) => {
        e.stopPropagation();
        setExpandedRows(prev => {
            const newSet = new Set(prev);
            newSet.delete(lineItemId);
            return newSet;
        });
    };

    const handleEditClick = (e, lineItem) => {
        e.stopPropagation();
        setInlineEditingId(lineItem.id);
        setShowShippingContactDropdown(false);
        setShowProjectManagerDropdown(false);
        setShowProjectEngineerDropdown(false);
        setShippingContactSelectionLocked(false);
        setProjectManagerSelectionLocked(false);
        setProjectEngineerSelectionLocked(false);
        setSelectedShippingContactId(null);
        
        // Initialize edited steps with current statuses
        if (lineItem.steps && lineItem.steps.length > 0) {
            const stepsWithStatus = lineItem.steps.map(stepArray => ({
                ...stepArray[0],
                status: stepArray[0].status || 'Not Started'
            }));
            setEditedSteps(stepsWithStatus);
        };
        
        // Prepopulate states for inline editing
        setSubmittalId(lineItem.submittalId);
        setSubmittalName(lineItem.submittalName);
        setSpecId(lineItem.specId);
        setSpecName(lineItem.specName);
        setDescription(lineItem.description || '');
        setPoNumber(lineItem.poNumber || '');
        setAmount(lineItem.amount || '');
        setExternalOrderNumber(lineItem.externalOrderNumber || '');
        setExternalOffsiteStorage(
            lineItem.externalOffsiteStorage === true ? 'Yes' : 
            lineItem.externalOffsiteStorage === false ? 'No' : ''
        );
        setNotes(lineItem.notes || '');
        setExternalNotes(lineItem.externalNotes || '');
        setControlNotes(lineItem.controlNotes || '');
        setProjectManager(lineItem.projectManager || '');
        setProjectEngineer(lineItem.projectEngineer || '');
        setExternalProjectManager(lineItem.externalProjectManager || '');
        setExternalProjectEngineer(lineItem.externalProjectEngineer || '');
        setRequestedDate(lineItem.requestDate ? new Date(lineItem.requestDate).toISOString().split('T')[0] : '');
        setStartDate(lineItem.startDate ? new Date(lineItem.startDate).toISOString().split('T')[0] : '');
        
        // Store original shipping data for comparison
        setOriginalShippingAddress(lineItem.shippingAddress);
        setOriginalShippingContact(lineItem.shippingContact);
        
        // Parse shipping address if it exists
        if (lineItem.shippingAddress) {
            setAddress(lineItem.shippingAddress.address || '');
            setAddress2(lineItem.shippingAddress.address2 || '');
            setCity(lineItem.shippingAddress.city || '');
            setState(lineItem.shippingAddress.state || '');
            setZip(normalizeZipCodeInput(lineItem.shippingAddress.zip || ''));
            setCountry(lineItem.shippingAddress.country || 'USA');
        } else {
            setAddress('');
            setAddress2('');
            setCity('');
            setState('');
            setZip('');
            setCountry('USA');
        }
        
        // Parse shipping contact if it exists
        if (lineItem.shippingContact) {
            setFirstName(lineItem.shippingContact.firstName || '');
            setLastName(lineItem.shippingContact.lastName || '');
            setContactNumber(normalizePhoneInput(lineItem.shippingContact.phone || ''));
            setExtension(lineItem.shippingContact.extension || '');
            setContactEmail(lineItem.shippingContact.email || '');
            setContactTitle(lineItem.shippingContact.title || '');
        } else {
            setFirstName('');
            setLastName('');
            setContactNumber('');
            setExtension('');
            setContactEmail('');
            setContactTitle('');
        }
        
        // Set schedule
        setSchedule(lineItem.schedule || '');
        
        // Set issues array
        setIssues(lineItem.issues || []);
        setNewIssueText('');
        setEditingIssueId(null);
        setEditingIssueText('');
        setShowHistoricIssues(false);
        
        // Set vendor for form
        if (lineItem.vendorId && vendors) {
            const matchingVendor = vendors.find(v => v.id === lineItem.vendorId);
            if (matchingVendor) {
                setSelectedVendor(matchingVendor);
                setVendorSearch(matchingVendor.name);
            }
        }
        
        // Find and set the workflow
        if (lineItem.workflowId && workflows) {
            const matchingWorkflow = workflows.find(w => w.id === lineItem.workflowId);
            if (matchingWorkflow) {
                setWorkflow(matchingWorkflow);
                setWorkflowId(String(lineItem.workflowId));
            }
        }
        
        setProjectNumber(lineItem.projectNumber);
        setProjectId(lineItem.projectId);
        setVendorId(lineItem.vendorId);
        setVendorName(lineItem.vendorName);
    };

    // Issue management functions
    const handleAddIssue = () => {
        if (!newIssueText.trim()) return;
        const newIssue = {
            issue: newIssueText,
            active: true
        };
        setIssues([...issues, newIssue]);
        setNewIssueText('');
    };

    const handleEditIssue = (issueId) => {
        const issueToEdit = issues.find(i => i.id === issueId);
        if (issueToEdit) {
            setEditingIssueId(issueId);
            setEditingIssueText(issueToEdit.issue);
        }
    };

    const handleSaveEditIssue = () => {
        if (!editingIssueText.trim()) return;
        setIssues(issues.map(i => 
            i.id === editingIssueId 
                ? { ...i, issue: editingIssueText, edited: true }
                : i
        ));
        setEditingIssueId(null);
        setEditingIssueText('');
    };

    const handleCancelEditIssue = () => {
        setEditingIssueId(null);
        setEditingIssueText('');
    };

    const handleCloseIssue = (issueId) => {
        setIssues(issues.map(i => 
            i.id === issueId 
                ? { ...i, closed: true, active: false }
                : i
        ));
    };

    const handleUpdateLineItem = useCallback(() => {
        const updatedLineItem = {
            ...createNewLineItemObject(),
            id: editingLineItem.id
        };
        updateProjectLineItem(updatedLineItem, apiToken, () => {
            handleSuccessfulUpdate();
            setEditingLineItem(null);
        }, handleUpdateError);
    }, [apiToken, editingLineItem, createNewLineItemObject, handleSuccessfulUpdate, handleUpdateError]);

    const handleInlineSave = useCallback((lineItemId) => {
        if (zip && !isValidZipCode(zip)) {
            alert('Please enter a valid 5-digit ZIP code.');
            return;
        }

        // Check if shipping address was changed
        const shippingAddressChanged = originalShippingAddress ? (
            originalShippingAddress.address !== address ||
            originalShippingAddress.address2 !== address2 ||
            originalShippingAddress.city !== city ||
            originalShippingAddress.state !== state ||
            originalShippingAddress.zip !== zip ||
            originalShippingAddress.country !== country
        ) : (address || city || state || zip);
        
        // Build shipping address object
        const shippingAddressObj = (address || city || state || zip) ? {
            ...(originalShippingAddress?.id && { id: originalShippingAddress.id }),
            address,
            address2,
            city,
            state,
            zip,
            country,
            ...(shippingAddressChanged && { edited: true })
        } : null;
        
        // Check if shipping contact was changed
        const shippingContactChanged = originalShippingContact ? (
            originalShippingContact.firstName !== firstName ||
            originalShippingContact.lastName !== lastName ||
            originalShippingContact.phone !== contactNumber ||
            originalShippingContact.extension !== extension ||
            originalShippingContact.email !== contactEmail ||
            originalShippingContact.title !== contactTitle
        ) : (firstName || lastName || contactNumber || contactEmail);
        
        // Build shipping contact object
        const shippingContactObj = (firstName || lastName || contactNumber || contactEmail) ? {
            ...(originalShippingContact?.id && { id: originalShippingContact.id }),
            firstName: firstName,
            lastName: lastName,
            phone: contactNumber,
            extension,
            email: contactEmail,
            title: contactTitle,
            ...(shippingContactChanged && { edited: true })
        } : null;
        
        const updatedLineItem = {
            id: lineItemId,
            projectId,
            projectNumber,
            submittalId,
            submittalName,
            specId,
            specName,
            description,
            poNumber,
            vendorId,
            vendorName,
            amount: parseCurrencyNumber(amount),
            externalOrderNumber,
            externalOffsiteStorage: externalOffsiteStorage === 'Yes' ? true : externalOffsiteStorage === 'No' ? false : null,
            notes,
            externalNotes,
            controlNotes,
            projectManager,
            projectEngineer,
            externalProjectManager,
            externalProjectEngineer,
            requestDate: requestedDate || null,
            startDate: startDate || null,
            schedule: schedule || null,
            issues: issues || [],
            shippingAddress: shippingAddressObj,
            shippingContact: shippingContactObj,
            steps: editedSteps.length > 0 ? editedSteps : undefined,
            updatedBy: userName
        };
        
        updateProjectLineItem(updatedLineItem, apiToken, () => {
            getAllProjectLineItems(selectedProject.project_number, apiToken, setProjectLineItems, setProjectLineItemsError);
            setInlineEditingId(null);
        }, (error) => {
            console.error('Error updating line item:', error);
            alert('Failed to update line item');
        });
    }, [apiToken, projectId, projectNumber, submittalId, submittalName, specId, specName, description, poNumber, vendorId, vendorName, amount, externalOrderNumber, externalOffsiteStorage, notes, externalNotes, controlNotes, projectManager, projectEngineer, externalProjectManager, externalProjectEngineer, requestedDate, startDate, schedule, issues, address, address2, city, state, zip, country, firstName, lastName, contactNumber, extension, contactEmail, contactTitle, userName, selectedProject, editedSteps, originalShippingAddress, originalShippingContact]);

    const handleInlineCancel = useCallback(() => {
        setInlineEditingId(null);
        setEditedSteps([]);
        setOriginalShippingAddress(null);
        setOriginalShippingContact(null);
        // Clear all states
        setDescription('');
        setPoNumber('');
        setAmount('');
        setExternalOrderNumber('');
        setExternalOffsiteStorage('');
        setNotes('');
        setExternalNotes('');
        setControlNotes('');
        setProjectManager('');
        setProjectEngineer('');
        setExternalProjectManager('');
        setExternalProjectEngineer('');
        setRequestedDate('');
        setStartDate('');
        setAddress('');
        setAddress2('');
        setCity('');
        setState('');
        setZip('');
        setCountry('USA');
        setFirstName('');
        setLastName('');
        setContactNumber('');
        setExtension('');
        setContactEmail('');
        setContactTitle('');
        setSchedule('');
        setIssues([]);
        setNewIssueText('');
        setEditingIssueId(null);
        setEditingIssueText('');
        setShowHistoricIssues(false);
    }, []);

    const NewLineItemWindow = useMemo(() => {
        const handleSubmittalSelect = (submittal) => {
            console.log(submittal);
            setSelectedSubmittal(submittal);
            setSubmittalId(submittal.id);
            setSubmittalName(submittal.name);
            setSpecId(submittal.specId);
            setSpecName(submittal.specName);
            setVendorId(submittal.vendorId);
            setVendorName(submittal.vendorName);
            setDescription(submittal.specName);
            setShowSubmittalDropdown(false);
            setSubmittalSearch(submittal.name);
        };

        const handleVendorSelect = (vendor) => {
            setSelectedVendor(vendor);
            setVendorId(vendor.id);
            setVendorName(vendor.name);
            setShowVendorDropdown(false);
            setVendorSearch(vendor.name);
        };

        const handleShippingContactFieldFocus = (fieldName) => {
            if (editingLineItem || shippingContactSelectionLocked) return;
            setShippingContactSearchField(fieldName);
            if (previouslyUsedShippingContacts.length > 0) {
                setShowShippingContactDropdown(true);
            }
        };

        const handleShippingContactSelect = (shippingContactRecord) => {
            setFirstName(shippingContactRecord.firstName || '');
            setLastName(shippingContactRecord.lastName || '');
            setContactTitle(shippingContactRecord.title || '');
            setContactEmail(shippingContactRecord.email || '');
            setContactNumber(shippingContactRecord.phone || '');
            setExtension(shippingContactRecord.extension || '');
            setSelectedShippingContactId(shippingContactRecord.id || null);
            setShippingContactSelectionLocked(true);
            setShowShippingContactDropdown(false);
        };

        const handleChangeShippingContact = () => {
            setFirstName('');
            setLastName('');
            setContactTitle('');
            setContactEmail('');
            setContactNumber('');
            setExtension('');
            setSelectedShippingContactId(null);
            setShippingContactSelectionLocked(false);
            setShowShippingContactDropdown(false);
        };

        const formatShippingContactDropdownPhone = (shippingContactRecord) => {
            const formattedPhone = shippingContactRecord.phone ? formatPhoneInput(shippingContactRecord.phone) : '';
            if (formattedPhone && shippingContactRecord.extension) {
                return `${formattedPhone} x${shippingContactRecord.extension}`;
            }
            if (formattedPhone) return formattedPhone;
            if (shippingContactRecord.extension) return `Ext ${shippingContactRecord.extension}`;
            return '';
        };

        const shippingContactSearchValue = (shippingContactSearchField === 'lastName' ? lastName : firstName).trim().toLowerCase();
        const filteredShippingContacts = previouslyUsedShippingContacts.filter((shippingContactRecord) => {
            if (!shippingContactSearchValue) return true;

            const formattedPhone = formatShippingContactDropdownPhone(shippingContactRecord);
            const searchableContactString = [
                shippingContactRecord.firstName,
                shippingContactRecord.lastName,
                shippingContactRecord.title,
                shippingContactRecord.email,
                shippingContactRecord.phone,
                shippingContactRecord.extension,
                formattedPhone
            ]
                .filter(Boolean)
                .join(' ')
                .toLowerCase();

            return searchableContactString.includes(shippingContactSearchValue);
        });

        const handleProjectManagerFieldFocus = () => {
            if (editingLineItem || projectManagerSelectionLocked) return;
            setShowProjectEngineerDropdown(false);
            if (previouslyUsedProjectManagers.length > 0) {
                setShowProjectManagerDropdown(true);
            }
        };

        const handleProjectEngineerFieldFocus = () => {
            if (editingLineItem || projectEngineerSelectionLocked) return;
            setShowProjectManagerDropdown(false);
            if (previouslyUsedProjectEngineers.length > 0) {
                setShowProjectEngineerDropdown(true);
            }
        };

        const filteredProjectManagers = previouslyUsedProjectManagers.filter((managerName) => {
            const managerSearchValue = String(projectManager ?? '').trim().toLowerCase();
            if (!managerSearchValue) return true;
            return managerName.toLowerCase().includes(managerSearchValue);
        });

        const filteredProjectEngineers = previouslyUsedProjectEngineers.filter((engineerName) => {
            const engineerSearchValue = String(projectEngineer ?? '').trim().toLowerCase();
            if (!engineerSearchValue) return true;
            return engineerName.toLowerCase().includes(engineerSearchValue);
        });

        const handleProjectManagerSelect = (managerName) => {
            setProjectManager(managerName);
            setProjectManagerSelectionLocked(true);
            setShowProjectManagerDropdown(false);
        };

        const handleProjectEngineerSelect = (engineerName) => {
            setProjectEngineer(engineerName);
            setProjectEngineerSelectionLocked(true);
            setShowProjectEngineerDropdown(false);
        };

        const handleChangeProjectManager = () => {
            setProjectManager('');
            setProjectManagerSelectionLocked(false);
            setShowProjectManagerDropdown(false);
        };

        const handleChangeProjectEngineer = () => {
            setProjectEngineer('');
            setProjectEngineerSelectionLocked(false);
            setShowProjectEngineerDropdown(false);
        };

        const isFormValid = () => {
            // For submittals mode, require submittal selection
            if (createModalSelection === 'submittals' && !selectedSubmittal) return false;
            // For manual mode, require vendor selection
            if (createModalSelection === 'manual' && !selectedVendor) return false;
            
            if (!description || !description.trim()) return false;
            if (!workflow) return false;
            
            // Check if user has started entering shipping address
            const hasStartedAddress = shippingAddressDiffersFromProject && (address || address2 || city || state || zip || country !== 'USA');
            if (hasStartedAddress) {
                // If started, require the mandatory fields
                if (!address || !city || !state || !zip) return false;
                if (!isValidZipCode(zip)) return false;
            }
            
            // Check if user has started entering shipping contact
            const hasStartedContact = firstName || lastName || contactNumber || extension || contactEmail || contactTitle;
            if (hasStartedContact) {
                // If started, require the mandatory fields
                if (!firstName || !lastName) return false;
                if (!contactNumber && !contactEmail) return false;
            }
            
            return true;
        };

        const handleSubmit = () => {
            if (!isFormValid()) return;

            const normalizeAddressPart = (value) => String(value ?? '').trim().toLowerCase();
            const projectAddressMatchId = (!editingLineItem && !shippingAddressDiffersFromProject)
                ? (projectLineItems.find((lineItem) => {
                    const existingAddress = lineItem?.shippingAddress;
                    if (!existingAddress?.id) return false;

                    return (
                        normalizeAddressPart(existingAddress.address) === normalizeAddressPart(selectedProject?.address) &&
                        normalizeAddressPart(existingAddress.city) === normalizeAddressPart(selectedProject?.city) &&
                        normalizeAddressPart(existingAddress.state) === normalizeAddressPart(selectedProject?.state) &&
                        normalizeZipCodeInput(existingAddress.zip || '') === normalizeZipCodeInput(selectedProject?.zip || '')
                    );
                })?.shippingAddress?.id ?? null)
                : null;
            
            // Build shipping address object
            const shippingAddressObj = {
                ...(projectAddressMatchId ? { id: projectAddressMatchId } : {}),
                address,
                address2,
                city,
                state,
                zip,
                country
            };
            setShippingAddress(shippingAddressObj);
            
            // Build shipping contact object
            const shippingContactObj = {
                ...(selectedShippingContactId ? { id: selectedShippingContactId } : {}),
                first_name: firstName,
                last_name: lastName,
                number: contactNumber,
                extension,
                email: contactEmail,
                title: contactTitle
            };
            setShippingContact(shippingContactObj);
            
            // Set project info
            setProjectId(selectedProject.id);
            setProjectNumber(selectedProject.project_number);
            
            // Call update or create based on whether we're editing
            if (editingLineItem) {
                handleUpdateLineItem();
            } else {
                const newLineItem = {
                    ...createNewLineItemObject(),
                    shippingAddress: shippingAddressObj,
                    shippingContact: shippingContactObj
                };

                createProjectLineItem(newLineItem, apiToken, () => {
                    handleSuccessfulUpdate();
                }, (error) => {
                    handleUpdateError(error);
                });
            }
        };

        const isShippingAddressComplete = address && city && state && zip;
        const isShippingContactComplete = firstName && lastName && (contactNumber || contactEmail);
        const isShippingAddressLockedToProject = !editingLineItem && !shippingAddressDiffersFromProject;

        return(
            <>
            {   createModalSelection === 'submittals' && 
                <div className='new-line-item-form'>
                    {/* Step 1: Select Submittal */}
                    <div className={`new-line-item-form-step ${!selectedSubmittal ? 'active' : 'completed'}`}>
                        <div className='form-step-header'>
                            <div className='form-step-number'>{selectedSubmittal ? '' : '1'}</div>
                            <div className='form-step-title'>
                                <h3>Select Submittal</h3>
                                <p>Search and select a submittal from Procore to create a line item</p>
                            </div>
                        </div>
                        <div className='form-step-content'>
                            <div className='form-section'>
                                <label className='form-label'>Search Submittals *</label>
                                <div className='submittal-search-container'>
                                    <input
                                        type='text'
                                        className='submittal-search-input'
                                        placeholder='Search by name, spec, type, or vendor...'
                                        value={submittalSearch}
                                        onChange={(e) => {
                                            setSubmittalSearch(e.target.value);
                                            setShowSubmittalDropdown(true);
                                        }}
                                        onFocus={() => setShowSubmittalDropdown(true)}
                                        autoComplete='off'
                                    />
                                    <div className='submittal-dropdown' style={{
                                        display: showSubmittalDropdown && filteredSubmittals.length > 0 && !selectedSubmittal ? 'block' : 'none'
                                    }}>
                                        {filteredSubmittals.map(submittal => (
                                            <div
                                                key={submittal.id}
                                                className='submittal-dropdown-item'
                                                onClick={() => handleSubmittalSelect(submittal)}
                                            >
                                                <div className='submittal-item-name'>{submittal.name}</div>
                                                <div className='submittal-item-details'>
                                                    {`${submittal.formattedNumber || ''} | ${submittal.type || ''} | ${submittal.vendorName || ''}`}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            {selectedSubmittal && (
                                <div className='form-section' style={{marginTop: '16px', padding: '16px', background: '#f0fdf4', borderRadius: '8px', border: '2px solid #10b981'}}>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px'}}>
                                        <span style={{fontSize: '20px', color: '#10b981'}}>✓</span>
                                        <strong style={{color: '#065f46', fontSize: '15px'}}>Selected:</strong>
                                    </div>
                                    <div style={{color: '#065f46', fontSize: '14px', lineHeight: '1.6'}}>
                                        <div style={{fontWeight: '600', marginBottom: '4px'}}>{selectedSubmittal.name}</div>
                                        <div style={{fontSize: '13px'}}>{`${selectedSubmittal.formattedNumber || ''} | ${selectedSubmittal.type || ''} | ${selectedSubmittal.vendorName || ''}`}</div>
                                    </div>
                                    <button 
                                        onClick={() => {
                                            setSelectedSubmittal(null);
                                            setSubmittalSearch('');
                                        }}
                                        style={{
                                            marginTop: '12px',
                                            padding: '6px 12px',
                                            background: 'white',
                                            border: '1px solid #10b981',
                                            borderRadius: '6px',
                                            color: '#065f46',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Change Selection
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Step 2: Line Item Details */}
                    {selectedSubmittal && (
                        <div className={`new-line-item-form-step ${selectedSubmittal ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-number'>2</div>
                                <div className='form-step-title'>
                                    <h3>Line Item Details</h3>
                                    <p>Provide additional information about this procurement item</p>
                                </div>
                            </div>
                            <div className='form-step-content'>
                                <div className='form-section'>
                                    <label className='form-label'>Description</label>
                                    <textarea
                                        className='form-textarea'
                                        value={description || ''}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder='Describe this line item...'
                                        rows={3}
                                    />
                                </div>

                                <div className='form-row'>
                                    <div className='form-section shipping-contact-dropdown-anchor'>
                                        <div className='form-label-with-action'>
                                            <label className='form-label'>Project Manager</label>
                                            {projectManagerSelectionLocked && (
                                                <button
                                                    type='button'
                                                    className='form-input-change-btn'
                                                    onClick={handleChangeProjectManager}
                                                >
                                                    Change
                                                </button>
                                            )}
                                        </div>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Enter project manager name'
                                            value={projectManager || ''}
                                            onChange={(e) => {
                                                setProjectManager(e.target.value);
                                                if (!projectManagerSelectionLocked) {
                                                    setShowProjectManagerDropdown(true);
                                                }
                                            }}
                                            onFocus={handleProjectManagerFieldFocus}
                                            onBlur={() => setTimeout(() => setShowProjectManagerDropdown(false), 150)}
                                            disabled={projectManagerSelectionLocked}
                                        />
                                        {!editingLineItem && showProjectManagerDropdown && filteredProjectManagers.length > 0 && (
                                            <div className='shipping-contact-dropdown' onMouseDown={(e) => e.preventDefault()}>
                                                {filteredProjectManagers.map((managerName, managerIndex) => (
                                                    <div
                                                        key={`${managerName}-${managerIndex}`}
                                                        className='shipping-contact-dropdown-item'
                                                        onClick={() => handleProjectManagerSelect(managerName)}
                                                    >
                                                        {managerName}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='form-section shipping-contact-dropdown-anchor'>
                                        <div className='form-label-with-action'>
                                            <label className='form-label'>Project Engineer</label>
                                            {projectEngineerSelectionLocked && (
                                                <button
                                                    type='button'
                                                    className='form-input-change-btn'
                                                    onClick={handleChangeProjectEngineer}
                                                >
                                                    Change
                                                </button>
                                            )}
                                        </div>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Enter project engineer name'
                                            value={projectEngineer || ''}
                                            onChange={(e) => {
                                                setProjectEngineer(e.target.value);
                                                if (!projectEngineerSelectionLocked) {
                                                    setShowProjectEngineerDropdown(true);
                                                }
                                            }}
                                            onFocus={handleProjectEngineerFieldFocus}
                                            onBlur={() => setTimeout(() => setShowProjectEngineerDropdown(false), 150)}
                                            disabled={projectEngineerSelectionLocked}
                                        />
                                        {!editingLineItem && showProjectEngineerDropdown && filteredProjectEngineers.length > 0 && (
                                            <div className='shipping-contact-dropdown' onMouseDown={(e) => e.preventDefault()}>
                                                {filteredProjectEngineers.map((engineerName, engineerIndex) => (
                                                    <div
                                                        key={`${engineerName}-${engineerIndex}`}
                                                        className='shipping-contact-dropdown-item'
                                                        onClick={() => handleProjectEngineerSelect(engineerName)}
                                                    >
                                                        {engineerName}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>PO Number</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Enter purchase order number'
                                        value={poNumber || ''}
                                        onChange={(e) => setPoNumber(e.target.value)}
                                    />
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Notes</label>
                                    <textarea
                                        className='form-textarea'
                                        value={notes || ''}
                                        onChange={(e) => setNotes(e.target.value)}
                                        placeholder='Add any additional notes...'
                                        rows={3}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Step 3: Workflow Selection */}
                    {selectedSubmittal && (
                        <div className={`new-line-item-form-step ${workflow ? 'completed' : selectedSubmittal ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-number'>{workflow ? '' : '3'}</div>
                                <div className='form-step-title'>
                                    <h3>Select Workflow</h3>
                                    <p>Choose a procurement workflow for this line item</p>
                                </div>
                            </div>
                            <div className='form-step-content'>
                                <div className='form-section'>
                                    <label className='form-label'>Workflow *</label>
                                    <select
                                        className='form-input'
                                        value={workflowId || ''}
                                        onChange={(e) => {
                                            const selectedId = e.target.value;
                                            setWorkflowId(selectedId);
                                            const selectedWorkflow = workflows?.find(w => w.id === parseInt(selectedId));
                                            setWorkflow(selectedWorkflow || null);
                                        }}
                                    >
                                        <option value=''>Select a workflow...</option>
                                        {workflows && workflows.filter(w => w.active).map(workflow => (
                                            <option key={workflow.id} value={workflow.id}>
                                                {workflow.name} ({workflow.stepCount} steps)
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {workflow && (
                                    <div className='form-section' style={{marginTop: '16px'}}>
                                        <button
                                            type='button'
                                            onClick={() => setShowWorkflowPreview(!showWorkflowPreview)}
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                background: '#f9fafb',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                transition: 'all 0.2s ease'
                                            }}
                                        >
                                            <span>Preview Workflow Steps</span>
                                            <span style={{
                                                transform: showWorkflowPreview ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.2s ease',
                                                fontSize: '16px'
                                            }}>▼</span>
                                        </button>
                                        {showWorkflowPreview && (
                                            <div style={{
                                                marginTop: '12px',
                                                padding: '16px',
                                                background: 'linear-gradient(135deg, rgba(6, 89, 67, 0.03) 0%, #ffffff 100%)',
                                                border: '2px solid var(--primary-color)',
                                                borderRadius: '8px',
                                                fontSize: '13px'
                                            }}>
                                                <div style={{fontWeight: '700', marginBottom: '12px', color: 'var(--primary-color)', fontSize: '15px'}}>
                                                    {workflow.name} - {workflow.stepCount} Steps
                                                </div>
                                                {workflow.steps && workflow.steps.map((step, index) => (
                                                    <div key={step.id} style={{
                                                        padding: '10px 12px',
                                                        color: '#6b7280',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '12px',
                                                        background: 'white',
                                                        borderRadius: '6px',
                                                        marginBottom: index < workflow.steps.length - 1 ? '8px' : '0',
                                                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                                                    }}>
                                                        <span style={{
                                                            fontWeight: '700',
                                                            color: 'white',
                                                            background: 'var(--primary-color)',
                                                            minWidth: '28px',
                                                            height: '28px',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '13px'
                                                        }}>
                                                            {index + 1}
                                                        </span>
                                                        <span style={{flex: 1, fontWeight: '600', color: '#111827'}}>{step.name}</span>
                                                        <span style={{
                                                            fontSize: '11px',
                                                            background: '#e5e7eb',
                                                            padding: '4px 10px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600',
                                                            color: '#374151'
                                                        }}>
                                                            {step.role?.name || 'No role'}
                                                        </span>
                                                        <span style={{
                                                            fontSize: '11px',
                                                            color: '#9ca3af',
                                                            fontWeight: '600',
                                                            whiteSpace: 'nowrap'
                                                        }}>
                                                            {step.leadtime} days
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Step 4: Shipping Address */}
                    {selectedSubmittal && (
                        <div className={`new-line-item-form-step ${isShippingAddressComplete ? 'completed' : selectedSubmittal ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-header-main'>
                                    <div className='form-step-number'>{isShippingAddressComplete ? '' : '4'}</div>
                                    <div className='form-step-title'>
                                        <h3>Shipping Address</h3>
                                        <p>Where should this item be delivered?</p>
                                    </div>
                                </div>
                                {!editingLineItem && (
                                    <button
                                        type='button'
                                        className={`shipping-address-toggle-btn ${shippingAddressDiffersFromProject ? 'active' : ''}`}
                                        onClick={() => setShippingAddressDiffersFromProject((previousValue) => !previousValue)}
                                        aria-pressed={shippingAddressDiffersFromProject}
                                    >
                                        Shipping Address Differs from Project Address
                                    </button>
                                )}
                            </div>
                            <div className='form-step-content'>
                                <div className='form-section'>
                                    <label className='form-label'>Address Line 1 *</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Street address, P.O. box'
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        disabled={isShippingAddressLockedToProject}
                                    />
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Address Line 2</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Apartment, suite, unit, building, floor, etc.'
                                        value={address2}
                                        onChange={(e) => setAddress2(e.target.value)}
                                        disabled={isShippingAddressLockedToProject}
                                    />
                                </div>

                                <div className='form-row'>
                                    <div className='form-section'>
                                        <label className='form-label'>City *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='City'
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            disabled={isShippingAddressLockedToProject}
                                        />
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>State *</label>
                                        <select
                                            className='form-input'
                                            value={state}
                                            onChange={(e) => setState(e.target.value)}
                                            disabled={isShippingAddressLockedToProject}
                                        >
                                            <option value=''>Select state</option>
                                            {US_STATES.map((stateOption) => (
                                                <option key={stateOption.code} value={stateOption.code}>
                                                    {stateOption.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className='form-row'>
                                    <div className='form-section'>
                                        <label className='form-label'>ZIP Code *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='ZIP Code'
                                            value={zip}
                                            onChange={(e) => setZip(normalizeZipCodeInput(e.target.value))}
                                            inputMode='numeric'
                                            maxLength={5}
                                            disabled={isShippingAddressLockedToProject}
                                        />
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>Country</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Country'
                                            value={country}
                                            onChange={(e) => setCountry(e.target.value)}
                                            disabled={isShippingAddressLockedToProject}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Step 5: Shipping Contact */}
                    {selectedSubmittal && (
                        <div className={`new-line-item-form-step ${isShippingContactComplete ? 'completed' : selectedSubmittal ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-header-main'>
                                    <div className='form-step-number'>{isShippingContactComplete ? '' : '5'}</div>
                                    <div className='form-step-title'>
                                        <h3>Shipping Contact</h3>
                                        <p>Who should be contacted regarding this shipment?</p>
                                    </div>
                                </div>
                                {!editingLineItem && shippingContactSelectionLocked && (
                                    <button
                                        type='button'
                                        className='shipping-address-toggle-btn'
                                        onClick={handleChangeShippingContact}
                                    >
                                        Change Shipping Contact
                                    </button>
                                )}
                            </div>
                            <div className='form-step-content'>
                                <div className='form-row'>
                                    <div className='form-section shipping-contact-dropdown-anchor'>
                                        <label className='form-label'>First Name *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='First name'
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            onFocus={() => handleShippingContactFieldFocus('firstName')}
                                            onBlur={() => setTimeout(() => setShowShippingContactDropdown(false), 150)}
                                            disabled={shippingContactSelectionLocked}
                                        />
                                        {!editingLineItem && showShippingContactDropdown && filteredShippingContacts.length > 0 && (
                                            <div className='shipping-contact-dropdown' onMouseDown={(e) => e.preventDefault()}>
                                                {filteredShippingContacts.map((shippingContactRecord, shippingContactIndex) => (
                                                    <div
                                                        key={`${shippingContactRecord.firstName}-${shippingContactRecord.lastName}-${shippingContactRecord.email}-${shippingContactIndex}`}
                                                        className='shipping-contact-dropdown-item'
                                                        onClick={() => handleShippingContactSelect(shippingContactRecord)}
                                                    >
                                                        {`${shippingContactRecord.firstName || '-'} ${shippingContactRecord.lastName || '-'} | ${shippingContactRecord.title || '-'} | ${shippingContactRecord.email || '-'} | ${formatShippingContactDropdownPhone(shippingContactRecord) || '-'}`}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>Last Name *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Last name'
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            onFocus={() => handleShippingContactFieldFocus('lastName')}
                                            onBlur={() => setTimeout(() => setShowShippingContactDropdown(false), 150)}
                                            disabled={shippingContactSelectionLocked}
                                        />
                                    </div>
                                </div>

                                <div className='form-row'>
                                    <div className='form-section'>
                                        <label className='form-label'>Phone Number {!contactEmail && '*'}</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='(555) 555-5555'
                                            value={formatPhoneInput(contactNumber)}
                                            onChange={(e) => setContactNumber(normalizePhoneInput(e.target.value))}
                                            inputMode='numeric'
                                            disabled={shippingContactSelectionLocked}
                                        />
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>Extension</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Ext.'
                                            value={extension}
                                            onChange={(e) => setExtension(e.target.value)}
                                            disabled={shippingContactSelectionLocked}
                                        />
                                    </div>
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Email {!contactNumber && '*'}</label>
                                    <input
                                        type='email'
                                        className='form-input'
                                        placeholder='email@example.com'
                                        value={contactEmail}
                                        onChange={(e) => setContactEmail(e.target.value)}
                                        disabled={shippingContactSelectionLocked}
                                    />
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Title</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Job title'
                                        value={contactTitle}
                                        onChange={(e) => setContactTitle(e.target.value)}
                                        disabled={shippingContactSelectionLocked}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Validation Summary */}
                    {selectedSubmittal && !isFormValid() && (() => {
                        const hasStartedAddress = address || address2 || city || state || zip || country !== 'USA';
                        const hasStartedContact = firstName || lastName || contactNumber || extension || contactEmail || contactTitle;
                        const missingFields = [];
                        
                        if (!description || !description.trim()) {
                            missingFields.push(<li key="description"><strong>Description</strong></li>);
                        }
                        
                        if (!workflow) {
                            missingFields.push(<li key="workflow"><strong>Workflow</strong></li>);
                        }
                        
                        if (hasStartedAddress) {
                            if (!address) missingFields.push(<li key="address"><strong>Address Line 1</strong> (Shipping Address)</li>);
                            if (!city) missingFields.push(<li key="city"><strong>City</strong> (Shipping Address)</li>);
                            if (!state) missingFields.push(<li key="state"><strong>State</strong> (Shipping Address)</li>);
                            if (!zip) missingFields.push(<li key="zip"><strong>ZIP Code</strong> (Shipping Address)</li>);
                            if (zip && !isValidZipCode(zip)) missingFields.push(<li key="zipFormat"><strong>ZIP Code</strong> must be a valid 5-digit number</li>);
                        }
                        
                        if (hasStartedContact) {
                            if (!firstName) missingFields.push(<li key="firstName"><strong>First Name</strong> (Shipping Contact)</li>);
                            if (!lastName) missingFields.push(<li key="lastName"><strong>Last Name</strong> (Shipping Contact)</li>);
                            if (!contactNumber && !contactEmail) {
                                missingFields.push(<li key="contact"><strong>Phone Number or Email</strong> (Shipping Contact - at least one required)</li>);
                            }
                        }
                        
                        return (
                            <div style={{
                                background: '#fef3c7',
                                border: '2px solid #f59e0b',
                                borderRadius: '10px',
                                padding: '20px 24px',
                                marginTop: '8px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '12px'
                                }}>
                                    <span style={{fontSize: '24px'}}>⚠️</span>
                                    <strong style={{color: '#92400e', fontSize: '16px'}}>
                                        Please complete the following required fields:
                                    </strong>
                                </div>
                                <ul style={{
                                    margin: '0',
                                    paddingLeft: '20px',
                                    color: '#92400e',
                                    fontSize: '14px',
                                    lineHeight: '1.8'
                                }}>
                                    {missingFields}
                                </ul>
                            </div>
                        );
                    })()}

                    {/* Submit Button */}
                    {selectedSubmittal && (
                        <button 
                            className={`form-submit-btn ${!isFormValid() ? 'disabled' : ''}`}
                            onClick={handleSubmit}
                            disabled={!isFormValid()}
                        >
                            Create Line Item
                        </button>
                    )}
                </div>
            }
            {   createModalSelection === 'manual' && 
                <div className='new-line-item-form'>
                    {/* Step 1: Select Vendor */}
                    <div className={`new-line-item-form-step ${!selectedVendor ? 'active' : 'completed'}`}>
                        <div className='form-step-header'>
                            <div className='form-step-number'>{selectedVendor ? '✓' : '1'}</div>
                            <div className='form-step-title'>
                                <h3>Select Vendor</h3>
                                <p>Search and select a vendor for this line item</p>
                            </div>
                        </div>
                        <div className='form-step-content'>
                            <div className='form-section'>
                                <label className='form-label'>Search Vendors *</label>
                                <div className='submittal-search-container'>
                                    <input
                                        type='text'
                                        className='submittal-search-input'
                                        placeholder='Search by name, address, city, state, or zip...'
                                        value={vendorSearch}
                                        onChange={(e) => {
                                            setVendorSearch(e.target.value);
                                            setShowVendorDropdown(true);
                                        }}
                                        onFocus={() => setShowVendorDropdown(true)}
                                        autoComplete='off'
                                    />
                                    <div className='submittal-dropdown' style={{
                                        display: showVendorDropdown && filteredVendors.length > 0 && !selectedVendor ? 'block' : 'none'
                                    }}>
                                        {filteredVendors.map(vendor => (
                                            <div
                                                key={vendor.id}
                                                className='submittal-dropdown-item'
                                                onClick={() => handleVendorSelect(vendor)}
                                            >
                                                <div className='submittal-item-name'>{vendor.name}</div>
                                                <div className='submittal-item-details'>
                                                    {vendor.address && `${vendor.address}, `}
                                                    {vendor.city && `${vendor.city}, `}
                                                    {vendor.state} {vendor.zip}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            {selectedVendor && (
                                <div className='form-section' style={{marginTop: '16px', padding: '16px', background: '#f0fdf4', borderRadius: '8px', border: '2px solid #10b981'}}>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px'}}>
                                        <span style={{fontSize: '20px', color: '#10b981'}}>✓</span>
                                        <strong style={{color: '#065f46', fontSize: '15px'}}>Selected:</strong>
                                    </div>
                                    <div style={{color: '#065f46', fontSize: '14px', lineHeight: '1.6'}}>
                                        <div style={{fontWeight: '600', marginBottom: '4px'}}>{selectedVendor.name}</div>
                                        {selectedVendor.address && (
                                            <div style={{fontSize: '13px'}}>
                                                {selectedVendor.address}
                                                {(selectedVendor.city || selectedVendor.state || selectedVendor.zip) && <br />}
                                                {selectedVendor.city && `${selectedVendor.city}, `}
                                                {selectedVendor.state} {selectedVendor.zip}
                                            </div>
                                        )}
                                    </div>
                                    <button 
                                        onClick={() => {
                                            setSelectedVendor(null);
                                            setVendorSearch('');
                                        }}
                                        style={{
                                            marginTop: '12px',
                                            padding: '6px 12px',
                                            background: 'white',
                                            border: '1px solid #10b981',
                                            borderRadius: '6px',
                                            color: '#065f46',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Change Selection
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Step 2: Line Item Details */}
                    {selectedVendor && (
                        <div className={`new-line-item-form-step ${vendorName ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-number'>2</div>
                                <div className='form-step-title'>
                                    <h3>Line Item Details</h3>
                                    <p>Provide additional information about this procurement item</p>
                                </div>
                            </div>
                            <div className='form-step-content'>
                                <div className='form-section'>
                                    <label className='form-label'>Description *</label>
                                    <textarea
                                        className='form-textarea'
                                        value={description || ''}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder='Describe this line item...'
                                        rows={3}
                                    />
                                </div>

                                <div className='form-row'>
                                    <div className='form-section shipping-contact-dropdown-anchor'>
                                        <div className='form-label-with-action'>
                                            <label className='form-label'>Project Manager</label>
                                            {projectManagerSelectionLocked && (
                                                <button
                                                    type='button'
                                                    className='form-input-change-btn'
                                                    onClick={handleChangeProjectManager}
                                                >
                                                    Change
                                                </button>
                                            )}
                                        </div>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Enter project manager name'
                                            value={projectManager || ''}
                                            onChange={(e) => {
                                                setProjectManager(e.target.value);
                                                if (!projectManagerSelectionLocked) {
                                                    setShowProjectManagerDropdown(true);
                                                }
                                            }}
                                            onFocus={handleProjectManagerFieldFocus}
                                            onBlur={() => setTimeout(() => setShowProjectManagerDropdown(false), 150)}
                                            disabled={projectManagerSelectionLocked}
                                        />
                                        {!editingLineItem && showProjectManagerDropdown && filteredProjectManagers.length > 0 && (
                                            <div className='shipping-contact-dropdown' onMouseDown={(e) => e.preventDefault()}>
                                                {filteredProjectManagers.map((managerName, managerIndex) => (
                                                    <div
                                                        key={`${managerName}-${managerIndex}`}
                                                        className='shipping-contact-dropdown-item'
                                                        onClick={() => handleProjectManagerSelect(managerName)}
                                                    >
                                                        {managerName}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='form-section shipping-contact-dropdown-anchor'>
                                        <div className='form-label-with-action'>
                                            <label className='form-label'>Project Engineer</label>
                                            {projectEngineerSelectionLocked && (
                                                <button
                                                    type='button'
                                                    className='form-input-change-btn'
                                                    onClick={handleChangeProjectEngineer}
                                                >
                                                    Change
                                                </button>
                                            )}
                                        </div>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Enter project engineer name'
                                            value={projectEngineer || ''}
                                            onChange={(e) => {
                                                setProjectEngineer(e.target.value);
                                                if (!projectEngineerSelectionLocked) {
                                                    setShowProjectEngineerDropdown(true);
                                                }
                                            }}
                                            onFocus={handleProjectEngineerFieldFocus}
                                            onBlur={() => setTimeout(() => setShowProjectEngineerDropdown(false), 150)}
                                            disabled={projectEngineerSelectionLocked}
                                        />
                                        {!editingLineItem && showProjectEngineerDropdown && filteredProjectEngineers.length > 0 && (
                                            <div className='shipping-contact-dropdown' onMouseDown={(e) => e.preventDefault()}>
                                                {filteredProjectEngineers.map((engineerName, engineerIndex) => (
                                                    <div
                                                        key={`${engineerName}-${engineerIndex}`}
                                                        className='shipping-contact-dropdown-item'
                                                        onClick={() => handleProjectEngineerSelect(engineerName)}
                                                    >
                                                        {engineerName}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>PO Number</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Enter purchase order number'
                                        value={poNumber || ''}
                                        onChange={(e) => setPoNumber(e.target.value)}
                                    />
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Notes</label>
                                    <textarea
                                        className='form-textarea'
                                        value={notes || ''}
                                        onChange={(e) => setNotes(e.target.value)}
                                        placeholder='Add any additional notes...'
                                        rows={3}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Step 3: Workflow Selection */}
                    {selectedVendor && (
                        <div className={`new-line-item-form-step ${workflow ? 'completed' : selectedVendor ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-number'>{workflow ? '✓' : '3'}</div>
                                <div className='form-step-title'>
                                    <h3>Select Workflow</h3>
                                    <p>Choose a procurement workflow for this line item</p>
                                </div>
                            </div>
                            <div className='form-step-content'>
                                <div className='form-section'>
                                    <label className='form-label'>Workflow *</label>
                                    <select
                                        className='form-input'
                                        value={workflowId || ''}
                                        onChange={(e) => {
                                            const selectedId = e.target.value;
                                            setWorkflowId(selectedId);
                                            const selectedWorkflow = workflows?.find(w => w.id === parseInt(selectedId));
                                            setWorkflow(selectedWorkflow || null);
                                        }}
                                    >
                                        <option value=''>Select a workflow...</option>
                                        {workflows && workflows.filter(w => w.active).map(workflow => (
                                            <option key={workflow.id} value={workflow.id}>
                                                {workflow.name} ({workflow.stepCount} steps)
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {workflow && (
                                    <div className='form-section' style={{marginTop: '16px'}}>
                                        <button
                                            type='button'
                                            onClick={() => setShowWorkflowPreview(!showWorkflowPreview)}
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                background: '#f9fafb',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                transition: 'all 0.2s ease'
                                            }}
                                        >
                                            <span>Preview Workflow Steps</span>
                                            <span style={{
                                                transform: showWorkflowPreview ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.2s ease',
                                                fontSize: '16px'
                                            }}>▼</span>
                                        </button>
                                        {showWorkflowPreview && (
                                            <div style={{
                                                marginTop: '12px',
                                                padding: '16px',
                                                background: 'linear-gradient(135deg, rgba(6, 89, 67, 0.03) 0%, #ffffff 100%)',
                                                border: '2px solid var(--primary-color)',
                                                borderRadius: '8px',
                                                fontSize: '13px'
                                            }}>
                                                <div style={{fontWeight: '700', marginBottom: '12px', color: 'var(--primary-color)', fontSize: '15px'}}>
                                                    {workflow.name} - {workflow.stepCount} Steps
                                                </div>
                                                {workflow.steps && workflow.steps.map((step, index) => (
                                                    <div key={step.id} style={{
                                                        padding: '10px 12px',
                                                        color: '#6b7280',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '12px',
                                                        background: 'white',
                                                        borderRadius: '6px',
                                                        marginBottom: index < workflow.steps.length - 1 ? '8px' : '0',
                                                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                                                    }}>
                                                        <span style={{
                                                            fontWeight: '700',
                                                            color: 'white',
                                                            background: 'var(--primary-color)',
                                                            minWidth: '28px',
                                                            height: '28px',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '13px'
                                                        }}>
                                                            {index + 1}
                                                        </span>
                                                        <span style={{flex: 1, fontWeight: '600', color: '#111827'}}>{step.name}</span>
                                                        <span style={{
                                                            fontSize: '11px',
                                                            background: '#e5e7eb',
                                                            padding: '4px 10px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600',
                                                            color: '#374151'
                                                        }}>
                                                            {step.role?.name || 'No role'}
                                                        </span>
                                                        <span style={{
                                                            fontSize: '11px',
                                                            color: '#9ca3af',
                                                            fontWeight: '600',
                                                            whiteSpace: 'nowrap'
                                                        }}>
                                                            {step.leadtime} days
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Step 4: Shipping Address */}
                    {selectedVendor && (
                        <div className={`new-line-item-form-step ${isShippingAddressComplete ? 'completed' : selectedVendor ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-header-main'>
                                    <div className='form-step-number'>{isShippingAddressComplete ? '✓' : '4'}</div>
                                    <div className='form-step-title'>
                                        <h3>Shipping Address</h3>
                                        <p>Where should this item be delivered?</p>
                                    </div>
                                </div>
                                {!editingLineItem && (
                                    <button
                                        type='button'
                                        className={`shipping-address-toggle-btn ${shippingAddressDiffersFromProject ? 'active' : ''}`}
                                        onClick={() => setShippingAddressDiffersFromProject((previousValue) => !previousValue)}
                                        aria-pressed={shippingAddressDiffersFromProject}
                                    >
                                        Shipping Address Differs from Project Address
                                    </button>
                                )}
                            </div>
                            <div className='form-step-content'>
                                <div className='form-section'>
                                    <label className='form-label'>Address Line 1 *</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Street address, P.O. box'
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        disabled={isShippingAddressLockedToProject}
                                    />
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Address Line 2</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Apartment, suite, unit, building, floor, etc.'
                                        value={address2}
                                        onChange={(e) => setAddress2(e.target.value)}
                                        disabled={isShippingAddressLockedToProject}
                                    />
                                </div>

                                <div className='form-row'>
                                    <div className='form-section'>
                                        <label className='form-label'>City *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='City'
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            disabled={isShippingAddressLockedToProject}
                                        />
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>State *</label>
                                        <select
                                            className='form-input'
                                            value={state}
                                            onChange={(e) => setState(e.target.value)}
                                            disabled={isShippingAddressLockedToProject}
                                        >
                                            <option value=''>Select state</option>
                                            {US_STATES.map((stateOption) => (
                                                <option key={stateOption.code} value={stateOption.code}>
                                                    {stateOption.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className='form-row'>
                                    <div className='form-section'>
                                        <label className='form-label'>ZIP Code *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='ZIP Code'
                                            value={zip}
                                            onChange={(e) => setZip(normalizeZipCodeInput(e.target.value))}
                                            inputMode='numeric'
                                            maxLength={5}
                                            disabled={isShippingAddressLockedToProject}
                                        />
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>Country</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Country'
                                            value={country}
                                            onChange={(e) => setCountry(e.target.value)}
                                            disabled={isShippingAddressLockedToProject}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Step 5: Shipping Contact */}
                    {selectedVendor && (
                        <div className={`new-line-item-form-step ${isShippingContactComplete ? 'completed' : selectedVendor ? 'active' : ''}`}>
                            <div className='form-step-header'>
                                <div className='form-step-header-main'>
                                    <div className='form-step-number'>{isShippingContactComplete ? '✓' : '5'}</div>
                                    <div className='form-step-title'>
                                        <h3>Shipping Contact</h3>
                                        <p>Who should be contacted regarding this shipment?</p>
                                    </div>
                                </div>
                                {!editingLineItem && shippingContactSelectionLocked && (
                                    <button
                                        type='button'
                                        className='shipping-address-toggle-btn'
                                        onClick={handleChangeShippingContact}
                                    >
                                        Change Shipping Contact
                                    </button>
                                )}
                            </div>
                            <div className='form-step-content'>
                                <div className='form-row'>
                                    <div className='form-section shipping-contact-dropdown-anchor'>
                                        <label className='form-label'>First Name *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='First name'
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            onFocus={() => handleShippingContactFieldFocus('firstName')}
                                            onBlur={() => setTimeout(() => setShowShippingContactDropdown(false), 150)}
                                            disabled={shippingContactSelectionLocked}
                                        />
                                        {!editingLineItem && showShippingContactDropdown && filteredShippingContacts.length > 0 && (
                                            <div className='shipping-contact-dropdown' onMouseDown={(e) => e.preventDefault()}>
                                                {filteredShippingContacts.map((shippingContactRecord, shippingContactIndex) => (
                                                    <div
                                                        key={`${shippingContactRecord.firstName}-${shippingContactRecord.lastName}-${shippingContactRecord.email}-${shippingContactIndex}`}
                                                        className='shipping-contact-dropdown-item'
                                                        onClick={() => handleShippingContactSelect(shippingContactRecord)}
                                                    >
                                                        {`${shippingContactRecord.firstName || '-'} ${shippingContactRecord.lastName || '-'} | ${shippingContactRecord.title || '-'} | ${shippingContactRecord.email || '-'} | ${formatShippingContactDropdownPhone(shippingContactRecord) || '-'}`}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>Last Name *</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Last name'
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            onFocus={() => handleShippingContactFieldFocus('lastName')}
                                            onBlur={() => setTimeout(() => setShowShippingContactDropdown(false), 150)}
                                            disabled={shippingContactSelectionLocked}
                                        />
                                    </div>
                                </div>

                                <div className='form-row'>
                                    <div className='form-section'>
                                        <label className='form-label'>Phone Number {!contactEmail && '*'}</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='(555) 555-5555'
                                            value={formatPhoneInput(contactNumber)}
                                            onChange={(e) => setContactNumber(normalizePhoneInput(e.target.value))}
                                            inputMode='numeric'
                                            disabled={shippingContactSelectionLocked}
                                        />
                                    </div>
                                    <div className='form-section'>
                                        <label className='form-label'>Extension</label>
                                        <input
                                            type='text'
                                            className='form-input'
                                            placeholder='Ext.'
                                            value={extension}
                                            onChange={(e) => setExtension(e.target.value)}
                                            disabled={shippingContactSelectionLocked}
                                        />
                                    </div>
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Email {!contactNumber && '*'}</label>
                                    <input
                                        type='email'
                                        className='form-input'
                                        placeholder='email@example.com'
                                        value={contactEmail}
                                        onChange={(e) => setContactEmail(e.target.value)}
                                        disabled={shippingContactSelectionLocked}
                                    />
                                </div>

                                <div className='form-section'>
                                    <label className='form-label'>Title</label>
                                    <input
                                        type='text'
                                        className='form-input'
                                        placeholder='Job title'
                                        value={contactTitle}
                                        onChange={(e) => setContactTitle(e.target.value)}
                                        disabled={shippingContactSelectionLocked}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Validation Summary */}
                    {selectedVendor && !isFormValid() && (() => {
                        const hasStartedAddress = address || address2 || city || state || zip || country !== 'USA';
                        const hasStartedContact = firstName || lastName || contactNumber || extension || contactEmail || contactTitle;
                        const missingFields = [];
                        
                        if (!description || !description.trim()) {
                            missingFields.push(<li key="description"><strong>Description</strong></li>);
                        }
                        
                        if (!workflow) {
                            missingFields.push(<li key="workflow"><strong>Workflow</strong></li>);
                        }
                        
                        if (hasStartedAddress) {
                            if (!address) missingFields.push(<li key="address"><strong>Address Line 1</strong> (Shipping Address)</li>);
                            if (!city) missingFields.push(<li key="city"><strong>City</strong> (Shipping Address)</li>);
                            if (!state) missingFields.push(<li key="state"><strong>State</strong> (Shipping Address)</li>);
                            if (!zip) missingFields.push(<li key="zip"><strong>ZIP Code</strong> (Shipping Address)</li>);
                            if (zip && !isValidZipCode(zip)) missingFields.push(<li key="zipFormat"><strong>ZIP Code</strong> must be a valid 5-digit number</li>);
                        }
                        
                        if (hasStartedContact) {
                            if (!firstName) missingFields.push(<li key="firstName"><strong>First Name</strong> (Shipping Contact)</li>);
                            if (!lastName) missingFields.push(<li key="lastName"><strong>Last Name</strong> (Shipping Contact)</li>);
                            if (!contactNumber && !contactEmail) {
                                missingFields.push(<li key="contact"><strong>Phone Number or Email</strong> (Shipping Contact - at least one required)</li>);
                            }
                        }
                        
                        return (
                            <div style={{
                                background: '#fef3c7',
                                border: '2px solid #f59e0b',
                                borderRadius: '10px',
                                padding: '20px 24px',
                                marginTop: '8px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '12px'
                                }}>
                                    <span style={{fontSize: '24px'}}>⚠️</span>
                                    <strong style={{color: '#92400e', fontSize: '16px'}}>
                                        Please complete the following required fields:
                                    </strong>
                                </div>
                                <ul style={{
                                    margin: '0',
                                    paddingLeft: '20px',
                                    color: '#92400e',
                                    fontSize: '14px',
                                    lineHeight: '1.8'
                                }}>
                                    {missingFields}
                                </ul>
                            </div>
                        );
                    })()}

                    {/* Submit Button */}
                    {selectedVendor && (
                        <button 
                            className={`form-submit-btn ${!isFormValid() ? 'disabled' : ''}`}
                            onClick={handleSubmit}
                            disabled={!isFormValid()}
                        >
                            {editingLineItem ? 'Update Line Item' : 'Create Line Item'}
                        </button>
                    )}
                </div>
            }
            {   createModalSelection === 'upload' && 
                <div>

                </div>
            }
            </>
        );
    }, [createModalSelection, selectedSubmittal, submittalSearch, showSubmittalDropdown, filteredSubmittals, selectedVendor, vendorSearch, showVendorDropdown, filteredVendors, workflowId, workflow, workflows, description, projectManager, projectEngineer, showProjectManagerDropdown, showProjectEngineerDropdown, projectManagerSelectionLocked, projectEngineerSelectionLocked, previouslyUsedProjectManagers, previouslyUsedProjectEngineers, poNumber, notes, address, address2, city, state, zip, country, firstName, lastName, contactNumber, extension, contactEmail, contactTitle, showShippingContactDropdown, shippingContactSelectionLocked, selectedShippingContactId, shippingContactSearchField, shippingAddressDiffersFromProject, previouslyUsedShippingContacts, projectLineItems, showWorkflowPreview, setSelectedSubmittal, setSubmittalSearch, setShowSubmittalDropdown, setSelectedVendor, setVendorSearch, setShowVendorDropdown, setWorkflowId, setWorkflow, setDescription, setProjectManager, setProjectEngineer, setShowProjectManagerDropdown, setShowProjectEngineerDropdown, setProjectManagerSelectionLocked, setProjectEngineerSelectionLocked, setPoNumber, setNotes, setAddress, setAddress2, setCity, setState, setZip, setCountry, setFirstName, setLastName, setContactNumber, setExtension, setContactEmail, setContactTitle, setShowShippingContactDropdown, setShippingContactSelectionLocked, setSelectedShippingContactId, setShippingContactSearchField, setShowWorkflowPreview, setSubmittalId, setSubmittalName, setSpecId, setSpecName, setVendorId, setVendorName, setShippingAddress, setShippingContact, setProjectId, setProjectNumber, createNewLineItem, handleUpdateLineItem, editingLineItem, selectedProject]);
    
    return(
        <div className="project-details-container">
            <div className="project-details-window" onClick={(e) => e.stopPropagation()}>
                <div className="project-details-header">
                    <h2>{selectedProject?.displayName}</h2>
                    <button className="close-button" onClick={closeProjectDetails}>×</button>
                </div>
                <div className="project-details-content">
                    <div className="project-details-toolbar">
                        <div className="project-details-toolbar-left">
                            <div className="project-details-toolbar-search">
                                <input 
                                    type="text" 
                                    placeholder="Search line items..." 
                                    value={lineItemSearch} 
                                    onChange={(e) => setLineItemSearch(e.target.value)} 
                                />
                            </div>
                        </div>
                        <div className="project-details-toolbar-right">
                            <div className="project-details-toolbar-info">
                                <div className="toolbar-info-item">
                                    <span className="toolbar-info-label">Last Schedule Sync:</span>
                                    <span className="toolbar-info-value">{selectedProject?.procurementData?.projectScheduleSyncDate ? formatTimestamp(selectedProject.procurementData.projectScheduleSyncDate.toLocaleString()) : 'Never'}</span>
                                </div>
                                <div className="toolbar-info-item">
                                    <span className="toolbar-info-label">Last Procore Sync:</span>
                                    <span className="toolbar-info-value">{selectedProject?.procurementData?.procoreRefreshDate ? formatTimestamp(selectedProject.procurementData.procoreRefreshDate.toLocaleString()) : 'Never'}</span>
                                </div>
                            </div>
                            <div className="project-details-toolbar-actions">
                                <button className="project-details-action-btn secondary" onClick={handleProjectScheduleModalOpen}>
                                    Sync Schedule
                                </button>
                                <button className="project-details-action-btn secondary" onClick={handleProcoreProjectSync}>
                                    Sync Procore
                                </button>
                                <button className="project-details-action-btn secondary" onClick={() => setShowCreateModal(true)}>
                                    + Add Line Item
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="project-details-table-container" ref={tableScrollRef} onScroll={handleMainScroll}>
                        <table className="project-details-table">
                            <thead>
                                <tr>
                                    <th>Submittal</th>
                                    <th>Spec</th>
                                    <th>Description</th>
                                    <th 
                                        className="filterable-header"
                                        onClick={() => setShowVendorFilter(!showVendorFilter)}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        Vendor {vendorFilter.length > 0 && `(${vendorFilter.length})`}
                                        {showVendorFilter && (
                                            <div 
                                                className="status-filter-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="status-filter-header">
                                                    <span>Filter by Vendor</span>
                                                    {vendorFilter.length > 0 && (
                                                        <button 
                                                            className="clear-filter-btn"
                                                            onClick={clearVendorFilter}
                                                        >
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="status-filter-options">
                                                    {uniqueVendors.map(vendor => (
                                                        <label key={vendor} className="status-filter-option">
                                                            <input
                                                                type="checkbox"
                                                                checked={vendorFilter.includes(vendor)}
                                                                onChange={() => toggleVendorFilter(vendor)}
                                                            />
                                                            <span>{vendor}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                    <th 
                                        className="filterable-header"
                                        onClick={() => setShowBallInCourtFilter(!showBallInCourtFilter)}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        Ball in Court {ballInCourtFilter.length > 0 && `(${ballInCourtFilter.length})`}
                                        {showBallInCourtFilter && (
                                            <div 
                                                className="status-filter-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="status-filter-header">
                                                    <span>Filter by Ball in Court</span>
                                                    {ballInCourtFilter.length > 0 && (
                                                        <button 
                                                            className="clear-filter-btn"
                                                            onClick={clearBallInCourtFilter}
                                                        >
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="status-filter-options">
                                                    {uniqueBallInCourt.map(ballInCourt => (
                                                        <label key={ballInCourt} className="status-filter-option">
                                                            <input
                                                                type="checkbox"
                                                                checked={ballInCourtFilter.includes(ballInCourt)}
                                                                onChange={() => toggleBallInCourtFilter(ballInCourt)}
                                                            />
                                                            <span>{ballInCourt}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                    <th 
                                        className="filterable-header"
                                        onClick={() => setShowNextStepFilter(!showNextStepFilter)}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        Next Step {nextStepFilter.length > 0 && `(${nextStepFilter.length})`}
                                        {showNextStepFilter && (
                                            <div 
                                                className="status-filter-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="status-filter-header">
                                                    <span>Filter by Next Step</span>
                                                    {nextStepFilter.length > 0 && (
                                                        <button 
                                                            className="clear-filter-btn"
                                                            onClick={clearNextStepFilter}
                                                        >
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="status-filter-options">
                                                    {uniqueNextSteps.map(nextStep => (
                                                        <label key={nextStep} className="status-filter-option">
                                                            <input
                                                                type="checkbox"
                                                                checked={nextStepFilter.includes(nextStep)}
                                                                onChange={() => toggleNextStepFilter(nextStep)}
                                                            />
                                                            <span>{nextStep}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                    <th 
                                        className="filterable-header"
                                        onClick={() => setShowDaysRemainingFilter(!showDaysRemainingFilter)}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        Days Remaining {((daysRemainingMin !== '' || daysRemainingMax !== '') || daysRemainingSort) && `(${(daysRemainingMin !== '' || daysRemainingMax !== '') ? `${daysRemainingMin || '∞'}-${daysRemainingMax || '∞'}` : ''}${daysRemainingSort ? ((daysRemainingMin !== '' || daysRemainingMax !== '') ? ',' : '') + (daysRemainingSort === 'asc' ? '↑' : '↓') : ''})`}
                                        {showDaysRemainingFilter && (
                                            <div 
                                                className="status-filter-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="status-filter-header">
                                                    <span>Days Remaining</span>
                                                    {((daysRemainingMin !== '' || daysRemainingMax !== '') || daysRemainingSort) && (
                                                        <button 
                                                            className="clear-filter-btn"
                                                            onClick={clearDaysRemainingFilter}
                                                        >
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="days-remaining-sort-section">
                                                    <div className="days-remaining-sort-label">Sort Order:</div>
                                                    <div className="days-remaining-sort-buttons">
                                                        <button 
                                                            className={`days-sort-btn ${daysRemainingSort === 'asc' ? 'active' : ''}`}
                                                            onClick={() => handleDaysRemainingSort('asc')}
                                                        >
                                                            ↑ Ascending
                                                        </button>
                                                        <button 
                                                            className={`days-sort-btn ${daysRemainingSort === 'desc' ? 'active' : ''}`}
                                                            onClick={() => handleDaysRemainingSort('desc')}
                                                        >
                                                            ↓ Descending
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="status-filter-header" style={{ borderTop: '1px solid #E5E7EB', marginTop: '8px', paddingTop: '8px' }}>
                                                    <span>Filter by Range:</span>
                                                </div>
                                                <div className="days-remaining-range-inputs">
                                                    <div className="days-range-input-group">
                                                        <input
                                                            type="number"
                                                            className="days-range-input"
                                                            placeholder="Min"
                                                            value={daysRemainingMin}
                                                            onChange={(e) => setDaysRemainingMin(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                        <span className="days-range-separator">-</span>
                                                        <input
                                                            type="number"
                                                            className="days-range-input"
                                                            placeholder="Max"
                                                            value={daysRemainingMax}
                                                            onChange={(e) => setDaysRemainingMax(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </div>
                                                    <div className="days-range-hint">Enter min and max days to filter (e.g., 0 to 5)</div>
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                    <th 
                                        className="filterable-header"
                                        onClick={() => setShowProjectedCompleteFilter(!showProjectedCompleteFilter)}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        Projected Complete {((projectedCompleteFrom !== '' || projectedCompleteTo !== '') || projectedCompleteSort) && `(${(projectedCompleteFrom !== '' || projectedCompleteTo !== '') ? `${projectedCompleteFrom || '∞'} - ${projectedCompleteTo || '∞'}` : ''}${projectedCompleteSort ? ((projectedCompleteFrom !== '' || projectedCompleteTo !== '') ? ',' : '') + (projectedCompleteSort === 'asc' ? '↑' : '↓') : ''})`}
                                        {showProjectedCompleteFilter && (
                                            <div 
                                                className="status-filter-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="status-filter-header">
                                                    <span>Projected Complete</span>
                                                    {((projectedCompleteFrom !== '' || projectedCompleteTo !== '') || projectedCompleteSort) && (
                                                        <button 
                                                            className="clear-filter-btn"
                                                            onClick={clearProjectedCompleteFilter}
                                                        >
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="days-remaining-sort-section">
                                                    <div className="days-remaining-sort-label">Sort Order:</div>
                                                    <div className="days-remaining-sort-buttons">
                                                        <button 
                                                            className={`days-sort-btn ${projectedCompleteSort === 'asc' ? 'active' : ''}`}
                                                            onClick={() => handleProjectedCompleteSort('asc')}
                                                        >
                                                            ↑ Ascending
                                                        </button>
                                                        <button 
                                                            className={`days-sort-btn ${projectedCompleteSort === 'desc' ? 'active' : ''}`}
                                                            onClick={() => handleProjectedCompleteSort('desc')}
                                                        >
                                                            ↓ Descending
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="status-filter-header" style={{ borderTop: '1px solid #E5E7EB', marginTop: '8px', paddingTop: '8px' }}>
                                                    <span>Filter by Date Range:</span>
                                                </div>
                                                <div className="days-remaining-range-inputs">
                                                    <div className="days-range-input-group">
                                                        <input
                                                            type="date"
                                                            className="days-range-input"
                                                            placeholder="From"
                                                            value={projectedCompleteFrom}
                                                            onChange={(e) => setProjectedCompleteFrom(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                        <span className="days-range-separator">-</span>
                                                        <input
                                                            type="date"
                                                            className="days-range-input"
                                                            placeholder="To"
                                                            value={projectedCompleteTo}
                                                            onChange={(e) => setProjectedCompleteTo(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </div>
                                                    <div className="days-range-hint">Select date range to filter</div>
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                    <th 
                                        className="filterable-header"
                                        onClick={() => setShowExpectedCompleteFilter(!showExpectedCompleteFilter)}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        Expected Complete {((expectedCompleteFrom !== '' || expectedCompleteTo !== '') || expectedCompleteSort) && `(${(expectedCompleteFrom !== '' || expectedCompleteTo !== '') ? `${expectedCompleteFrom || '∞'} - ${expectedCompleteTo || '∞'}` : ''}${expectedCompleteSort ? ((expectedCompleteFrom !== '' || expectedCompleteTo !== '') ? ',' : '') + (expectedCompleteSort === 'asc' ? '↑' : '↓') : ''})`}
                                        {showExpectedCompleteFilter && (
                                            <div 
                                                className="status-filter-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="status-filter-header">
                                                    <span>Expected Complete</span>
                                                    {((expectedCompleteFrom !== '' || expectedCompleteTo !== '') || expectedCompleteSort) && (
                                                        <button 
                                                            className="clear-filter-btn"
                                                            onClick={clearExpectedCompleteFilter}
                                                        >
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="days-remaining-sort-section">
                                                    <div className="days-remaining-sort-label">Sort Order:</div>
                                                    <div className="days-remaining-sort-buttons">
                                                        <button 
                                                            className={`days-sort-btn ${expectedCompleteSort === 'asc' ? 'active' : ''}`}
                                                            onClick={() => handleExpectedCompleteSort('asc')}
                                                        >
                                                            ↑ Ascending
                                                        </button>
                                                        <button 
                                                            className={`days-sort-btn ${expectedCompleteSort === 'desc' ? 'active' : ''}`}
                                                            onClick={() => handleExpectedCompleteSort('desc')}
                                                        >
                                                            ↓ Descending
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="status-filter-header" style={{ borderTop: '1px solid #E5E7EB', marginTop: '8px', paddingTop: '8px' }}>
                                                    <span>Filter by Date Range:</span>
                                                </div>
                                                <div className="days-remaining-range-inputs">
                                                    <div className="days-range-input-group">
                                                        <input
                                                            type="date"
                                                            className="days-range-input"
                                                            placeholder="From"
                                                            value={expectedCompleteFrom}
                                                            onChange={(e) => setExpectedCompleteFrom(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                        <span className="days-range-separator">-</span>
                                                        <input
                                                            type="date"
                                                            className="days-range-input"
                                                            placeholder="To"
                                                            value={expectedCompleteTo}
                                                            onChange={(e) => setExpectedCompleteTo(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </div>
                                                    <div className="days-range-hint">Select date range to filter</div>
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                    <th 
                                        className="filterable-header"
                                        onClick={() => setShowStatusFilter(!showStatusFilter)}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        Status {statusFilter.length > 0 && `(${statusFilter.length})`}
                                        {showStatusFilter && (
                                            <div 
                                                className="status-filter-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="status-filter-header">
                                                    <span>Filter by Status</span>
                                                    {statusFilter.length > 0 && (
                                                        <button 
                                                            className="clear-filter-btn"
                                                            onClick={clearStatusFilter}
                                                        >
                                                            Clear
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="status-filter-options">
                                                    {uniqueStatuses.map(status => (
                                                        <label key={status} className="status-filter-option">
                                                            <input
                                                                type="checkbox"
                                                                checked={statusFilter.includes(status)}
                                                                onChange={() => toggleStatusFilter(status)}
                                                            />
                                                            <span className={`status-badge status-${status.toLowerCase().replace(' ', '-')}`}>
                                                                {status}
                                                            </span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredLineItems.map((lineItem, index) => {
                                    const isExpanded = false;
                                    const isClicked = expandedRows.has(lineItem.id);
                                    
                                    // Check if this row is part of a spec group (same spec as previous or next row)
                                    const prevSpec = index > 0 ? filteredLineItems[index - 1].specName : null;
                                    const nextSpec = index < filteredLineItems.length - 1 ? filteredLineItems[index + 1].specName : null;
                                    const currentSpec = lineItem.specName;
                                    const isInSpecGroup = currentSpec && ((currentSpec === prevSpec) || (currentSpec === nextSpec));
                                    const isFirstInGroup = isInSpecGroup && currentSpec !== prevSpec;
                                    const isLastInGroup = isInSpecGroup && currentSpec !== nextSpec;
                                    
                                    return (
                                        <React.Fragment key={lineItem.id}>
                                            <tr 
                                                className={`line-item-row ${isExpanded ? 'expanded' : ''} ${isClicked ? 'clicked' : ''} ${isInSpecGroup ? 'spec-grouped' : ''} ${isFirstInGroup ? 'spec-group-first' : ''} ${isLastInGroup ? 'spec-group-last' : ''}`}
                                                onClick={() => handleRowClick(lineItem)}
                                            >
                                                <td>{lineItem.submittalName || '-'}</td>
                                                <td>{lineItem.specName || '-'}</td>
                                                <td>{lineItem.description || '-'}</td>
                                                <td>{lineItem.vendorName || '-'}</td>
                                                <td>
                                                    {lineItem.ballInCourt ? (
                                                        <span className={`ball-in-court-badge ${lineItem.ballInCourt.type === 'Internal' ? 'ball-in-court-internal' : 'ball-in-court-external'}`}>
                                                            {lineItem.ballInCourt.type === 'Internal' ? 'INT' : 'EXT'} - {lineItem.ballInCourt.roleName}
                                                        </span>
                                                    ) : '-'}
                                                </td>
                                                <td>
                                                    {lineItem.nextStep ? lineItem.nextStep.name : '-'}
                                                </td>
                                                <td>{lineItem.leadtime || '-'}</td>
                                                <td>{lineItem.expectedCompletionDate ? new Date(lineItem.expectedCompletionDate).toLocaleDateString() : '-'}</td>
                                                <td>{lineItem.requestDate ? new Date(lineItem.requestDate).toLocaleDateString() : '-'}</td>
                                                <td>
                                                    {lineItem.status ? (
                                                        <span className={`status-badge status-${lineItem.status.toLowerCase().replace(' ', '-')}`}>
                                                            {lineItem.status}
                                                        </span>
                                                    ) : '-'}
                                                </td>
                                            </tr>
                                            {isExpanded && (
                                                <tr className="line-item-expanded-details">
                                                    <td colSpan="10">
                                                        <div className="line-item-details-container">
                                                            {/* Row 1: Submittal Info */}
                                                            <div className="line-item-detail-row">
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Submittal Name</div>
                                                                    <div className="line-item-detail-value">{lineItem.submittalName || '-'}</div>
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Spec Name</div>
                                                                    <div className="line-item-detail-value">{lineItem.specName || '-'}</div>
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Description</div>
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <input
                                                                            type="text"
                                                                            className="line-item-edit-input"
                                                                            value={description}
                                                                            onChange={(e) => setDescription(e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <div className="line-item-detail-value">{lineItem.description || '-'}</div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Row 2: Vendor & Order Info */}
                                                            <div className="line-item-detail-row">
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Vendor Name</div>
                                                                    <div className="line-item-detail-value">{lineItem.vendorName || '-'}</div>
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">PO Number</div>
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <input
                                                                            type="text"
                                                                            className="line-item-edit-input"
                                                                            value={poNumber}
                                                                            onChange={(e) => setPoNumber(e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <div className="line-item-detail-value">{lineItem.poNumber || '-'}</div>
                                                                    )}
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Amount</div>
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <input
                                                                            type="text"
                                                                            className="line-item-edit-input"
                                                                            value={formatCurrencyInput(amount)}
                                                                            onChange={(e) => setAmount(normalizeCurrencyInput(e.target.value))}
                                                                            inputMode="decimal"
                                                                            placeholder="0.00"
                                                                        />
                                                                    ) : (
                                                                        <div className="line-item-detail-value">{lineItem.amount ? `$${lineItem.amount.toLocaleString()}` : '-'}</div>
                                                                    )}
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">External Order #</div>
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <input
                                                                            type="text"
                                                                            className="line-item-edit-input"
                                                                            value={externalOrderNumber}
                                                                            onChange={(e) => setExternalOrderNumber(e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <div className="line-item-detail-value">{lineItem.externalOrderNumber || '-'}</div>
                                                                    )}
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Offsite Storage</div>
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <select
                                                                            className="line-item-edit-input"
                                                                            value={externalOffsiteStorage || ''}
                                                                            onChange={(e) => setExternalOffsiteStorage(e.target.value)}
                                                                        >
                                                                            <option value="">-</option>
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    ) : (
                                                                        <div className="line-item-detail-value">
                                                                            {lineItem.externalOffsiteStorage === true ? 'Yes' : 
                                                                             lineItem.externalOffsiteStorage === false ? 'No' : '-'}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Row 3: Date Information */}
                                                            <div className="line-item-detail-row">
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Start Date</div>
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <input
                                                                            type="date"
                                                                            className="line-item-edit-input"
                                                                            value={startDate}
                                                                            onChange={(e) => setStartDate(e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <div className="line-item-detail-value">{lineItem.startDate ? new Date(lineItem.startDate).toLocaleDateString() : '-'}</div>
                                                                    )}
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Requested Completion Date</div>
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <input
                                                                            type="date"
                                                                            className="line-item-edit-input"
                                                                            value={requestedDate}
                                                                            onChange={(e) => setRequestedDate(e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <div className="line-item-detail-value">{lineItem.requestDate ? new Date(lineItem.requestDate).toLocaleDateString() : '-'}</div>
                                                                    )}
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Expected Completion Date</div>
                                                                    <div className="line-item-detail-value">{lineItem.expectedCompletionDate ? new Date(lineItem.expectedCompletionDate).toLocaleDateString() : '-'}</div>
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Procore Updated</div>
                                                                    <div className="line-item-detail-value">{lineItem.procoreRefreshDate ? new Date(lineItem.procoreRefreshDate).toLocaleDateString() : '-'}</div>
                                                                </div>
                                                                <div className="line-item-detail-group">
                                                                    <div className="line-item-detail-label">Project Schedule Updated</div>
                                                                    <div className="line-item-detail-value">{lineItem.projectScheduleSyncDate ? new Date(lineItem.projectScheduleSyncDate).toLocaleDateString() : '-'}</div>
                                                                </div>
                                                            </div>

                                                            {/* Row 4: Workflow & Steps */}
                                                            <div className="line-item-detail-row">
                                                                <div className="line-item-detail-group line-item-workflow-section">
                                                                    <div className="line-item-detail-label">Workflow: {lineItem.workflow || 'Not Set'}</div>
                                                                    {lineItem.steps && lineItem.steps.length > 0 && (
                                                                        <div className="line-item-workflow-steps">
                                                                            {(inlineEditingId === lineItem.id ? editedSteps : lineItem.steps.map(s => s[0])).map((step, idx) => {
                                                                                if (!step) return null;
                                                                                return (
                                                                                    <div key={idx} className="line-item-workflow-step">
                                                                                        <div className="line-item-workflow-step-number">{idx + 1}</div>
                                                                                        <div className="line-item-workflow-step-content">
                                                                                            <div className="line-item-workflow-step-name">{step.name}</div>
                                                                                            <div className="line-item-workflow-step-role">
                                                                                                {step.role ? (typeof step.role === 'object' ? step.role.name : step.role) : '-'}
                                                                                            </div>
                                                                                            <div className="line-item-workflow-step-leadtime">
                                                                                                {step.expectedLeadtime ? `${step.expectedLeadtime}d` : '-'}
                                                                                            </div>
                                                                                            <div className={`line-item-workflow-step-expected-date ${step.status === 'Completed' ? 'completed' : 'not-completed'}`}>
                                                                                                {step.status === 'Completed' 
                                                                                                    ? (step.date ? new Date(step.date).toLocaleDateString() : '-')
                                                                                                    : (step.expectedCompletionDate ? new Date(step.expectedCompletionDate).toLocaleDateString() : '-')
                                                                                                }
                                                                                            </div>
                                                                                            {inlineEditingId === lineItem.id ? (
                                                                                                <select
                                                                                                    className="line-item-workflow-step-status-select"
                                                                                                    value={step.status || 'Not Started'}
                                                                                                    onChange={(e) => {
                                                                                                        const newSteps = [...editedSteps];
                                                                                                        newSteps[idx] = { ...newSteps[idx], status: e.target.value, editted: true };
                                                                                                        setEditedSteps(newSteps);
                                                                                                    }}
                                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                                >
                                                                                                    <option value="Not Started">Not Started</option>
                                                                                                    <option value="In Progress">In Progress</option>
                                                                                                    <option value="On Hold">On Hold</option>
                                                                                                    <option value="Completed">Completed</option>
                                                                                                    <option value="N/A">N/A</option>
                                                                                                </select>
                                                                                            ) : (
                                                                                                <div className={`line-item-workflow-step-status status-${(step.status || 'Not Started').toLowerCase().replace(' ', '-')}`}>
                                                                                                    {step.status || 'Not Started'}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                        {idx < (inlineEditingId === lineItem.id ? editedSteps : lineItem.steps).length - 1 && (
                                                                                            <div className="line-item-workflow-step-arrow">→</div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Row 4: Notes */}
                                                            {(lineItem.notes || lineItem.externalNotes || lineItem.controlNotes || inlineEditingId === lineItem.id) && (
                                                                <div className="line-item-detail-row">
                                                                    {(lineItem.notes || inlineEditingId === lineItem.id) && (
                                                                        <div className="line-item-detail-group">
                                                                            <div className="line-item-detail-label">Notes</div>
                                                                            {inlineEditingId === lineItem.id ? (
                                                                                <textarea
                                                                                    className="line-item-edit-textarea"
                                                                                    value={notes}
                                                                                    onChange={(e) => setNotes(e.target.value)}
                                                                                    rows={3}
                                                                                />
                                                                            ) : (
                                                                                <div className="line-item-detail-value">{lineItem.notes}</div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {(lineItem.externalNotes || inlineEditingId === lineItem.id) && (
                                                                        <div className="line-item-detail-group">
                                                                            <div className="line-item-detail-label">External Notes</div>
                                                                            {inlineEditingId === lineItem.id ? (
                                                                                <textarea
                                                                                    className="line-item-edit-textarea"
                                                                                    value={externalNotes}
                                                                                    onChange={(e) => setExternalNotes(e.target.value)}
                                                                                    rows={3}
                                                                                />
                                                                            ) : (
                                                                                <div className="line-item-detail-value">{lineItem.externalNotes}</div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {(lineItem.controlNotes || inlineEditingId === lineItem.id) && (
                                                                        <div className="line-item-detail-group">
                                                                            <div className="line-item-detail-label">Control Notes</div>
                                                                            {inlineEditingId === lineItem.id ? (
                                                                                <textarea
                                                                                    className="line-item-edit-textarea"
                                                                                    value={controlNotes}
                                                                                    onChange={(e) => setControlNotes(e.target.value)}
                                                                                    rows={3}
                                                                                />
                                                                            ) : (
                                                                                <div className="line-item-detail-value">{lineItem.controlNotes}</div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* Row 5: Team & Shipping */}
                                                            <div className="line-item-detail-row">
                                                                {(lineItem.projectManager || inlineEditingId === lineItem.id) && (
                                                                    <div className="line-item-detail-group">
                                                                        <div className="line-item-detail-label">Project Manager</div>
                                                                        {inlineEditingId === lineItem.id ? (
                                                                            <input
                                                                                type="text"
                                                                                className="line-item-edit-input"
                                                                                value={projectManager}
                                                                                onChange={(e) => setProjectManager(e.target.value)}
                                                                            />
                                                                        ) : (
                                                                            <div className="line-item-detail-value">{lineItem.projectManager}</div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {(lineItem.projectEngineer || inlineEditingId === lineItem.id) && (
                                                                    <div className="line-item-detail-group">
                                                                        <div className="line-item-detail-label">Project Engineer</div>
                                                                        {inlineEditingId === lineItem.id ? (
                                                                            <input
                                                                                type="text"
                                                                                className="line-item-edit-input"
                                                                                value={projectEngineer}
                                                                                onChange={(e) => setProjectEngineer(e.target.value)}
                                                                            />
                                                                        ) : (
                                                                            <div className="line-item-detail-value">{lineItem.projectEngineer}</div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {(lineItem.externalProjectManager || inlineEditingId === lineItem.id) && (
                                                                    <div className="line-item-detail-group">
                                                                        <div className="line-item-detail-label">External PM</div>
                                                                        {inlineEditingId === lineItem.id ? (
                                                                            <input
                                                                                type="text"
                                                                                className="line-item-edit-input"
                                                                                value={externalProjectManager}
                                                                                onChange={(e) => setExternalProjectManager(e.target.value)}
                                                                            />
                                                                        ) : (
                                                                            <div className="line-item-detail-value">{lineItem.externalProjectManager}</div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {(lineItem.externalProjectEngineer || inlineEditingId === lineItem.id) && (
                                                                    <div className="line-item-detail-group">
                                                                        <div className="line-item-detail-label">External PE</div>
                                                                        {inlineEditingId === lineItem.id ? (
                                                                            <input
                                                                                type="text"
                                                                                className="line-item-edit-input"
                                                                                value={externalProjectEngineer}
                                                                                onChange={(e) => setExternalProjectEngineer(e.target.value)}
                                                                            />
                                                                        ) : (
                                                                            <div className="line-item-detail-value">{lineItem.externalProjectEngineer}</div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Row 6: Shipping Address */}
                                                            {(lineItem.shippingAddress || inlineEditingId === lineItem.id) && (
                                                                <div className="line-item-detail-row">
                                                                    <div className="line-item-detail-group">
                                                                        <div className="line-item-detail-label">Shipping Address</div>
                                                                        {inlineEditingId === lineItem.id ? (
                                                                            <div className="line-item-edit-shipping">
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} />
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="Address 2" value={address2} onChange={(e) => setAddress2(e.target.value)} />
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} />
                                                                                <select className="line-item-edit-input-small" value={state} onChange={(e) => setState(e.target.value)}>
                                                                                    <option value="">State</option>
                                                                                    {US_STATES.map((stateOption) => (
                                                                                        <option key={stateOption.code} value={stateOption.code}>{stateOption.name}</option>
                                                                                    ))}
                                                                                </select>
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="Zip" value={zip} onChange={(e) => setZip(normalizeZipCodeInput(e.target.value))} inputMode="numeric" maxLength={5} />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="line-item-detail-value">
                                                                                {lineItem.shippingAddress.address}
                                                                                {lineItem.shippingAddress.address2 && `, ${lineItem.shippingAddress.address2}`}
                                                                                <br />
                                                                                {lineItem.shippingAddress.city}, {lineItem.shippingAddress.state} {lineItem.shippingAddress.zip}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Row 7: Shipping Contact */}
                                                            {(lineItem.shippingContact || inlineEditingId === lineItem.id) && (
                                                                <div className="line-item-detail-row">
                                                                    <div className="line-item-detail-group">
                                                                        <div className="line-item-detail-label">Shipping Contact</div>
                                                                        {inlineEditingId === lineItem.id ? (
                                                                            <div className="line-item-edit-shipping">
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="Title" value={contactTitle} onChange={(e) => setContactTitle(e.target.value)} />
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="Phone" value={formatPhoneInput(contactNumber)} onChange={(e) => setContactNumber(normalizePhoneInput(e.target.value))} inputMode="numeric" />
                                                                                <input type="text" className="line-item-edit-input-small" placeholder="Ext" value={extension} onChange={(e) => setExtension(e.target.value)} />
                                                                                <input type="email" className="line-item-edit-input-small" placeholder="Email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="line-item-detail-value">
                                                                                {lineItem.shippingContact.firstName} {lineItem.shippingContact.lastName}
                                                                                {lineItem.shippingContact.title && ` - ${lineItem.shippingContact.title}`}
                                                                                {lineItem.shippingContact.phone && <><br />Phone: {formatPhoneInput(lineItem.shippingContact.phone)}{lineItem.shippingContact.extension && ` ext. ${lineItem.shippingContact.extension}`}</>}
                                                                                {lineItem.shippingContact.email && <><br />Email: {lineItem.shippingContact.email}</>}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Row 8: Schedule */}
                                                            {(lineItem.schedule || inlineEditingId === lineItem.id) && (
                                                                <div className="line-item-detail-row">
                                                                    <div className="line-item-detail-group">
                                                                        <div className="line-item-detail-label">Schedule UID</div>
                                                                        {inlineEditingId === lineItem.id ? (
                                                                            <input 
                                                                                type="text" 
                                                                                className="line-item-edit-input" 
                                                                                value={schedule} 
                                                                                style={{ width: "100px" }}
                                                                                onChange={(e) => setSchedule(e.target.value)} 
                                                                            />
                                                                        ) : (
                                                                            <div className="line-item-detail-value">
                                                                                {lineItem.schedule}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Row 9: Issues */}
                                                            {(inlineEditingId === lineItem.id || (lineItem.issues && lineItem.issues.length > 0)) && (
                                                                <div className="line-item-issues-section">
                                                                    <div className="line-item-detail-row">
                                                                        <div className="line-item-detail-group line-item-detail-full">
                                                                            <div className="line-item-detail-label">Issues</div>
                                                                            {inlineEditingId === lineItem.id && (
                                                                                <div className="line-item-add-issue">
                                                                                    <textarea
                                                                                        className="line-item-issue-input"
                                                                                        value={newIssueText}
                                                                                        onChange={(e) => setNewIssueText(e.target.value)}
                                                                                        placeholder="Describe the issue..."
                                                                                        rows={2}
                                                                                    />
                                                                                    <button
                                                                                        className="add-issue-btn"
                                                                                        onClick={handleAddIssue}
                                                                                        disabled={!newIssueText.trim()}
                                                                                    >
                                                                                        + Add Issue
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                            
                                                                            <div className="line-item-issues-list">
                                                                                {(inlineEditingId === lineItem.id ? issues : lineItem.issues || []).filter(issue => issue.active).length > 0 && (
                                                                                    <div className="issues-list-header">
                                                                                        <span className="issues-list-title">Active Issues</span>
                                                                                    </div>
                                                                                )}
                                                                        {(inlineEditingId === lineItem.id ? issues : lineItem.issues || [])
                                                                            .filter(issue => issue.active)
                                                                            .map((issue, idx) => (
                                                                                <div key={issue.id || idx} className="line-item-issue-item">
                                                                                    <div className="issue-item-header">
                                                                                        <span className="issue-status-badge active">Active</span>
                                                                                        {issue.createdDate && (
                                                                                            <span className="issue-date">
                                                                                                Created: {new Date(issue.createdDate).toLocaleDateString()} by {issue.createdBy || 'Unknown'}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                    
                                                                                    {inlineEditingId === lineItem.id && editingIssueId === issue.id ? (
                                                                                        <div className="issue-edit-container">
                                                                                            <textarea
                                                                                                className="line-item-issue-input"
                                                                                                value={editingIssueText}
                                                                                                onChange={(e) => setEditingIssueText(e.target.value)}
                                                                                                rows={3}
                                                                                            />
                                                                                            <div className="issue-edit-actions">
                                                                                                <button
                                                                                                    className="save-issue-btn"
                                                                                                    onClick={handleSaveEditIssue}
                                                                                                    disabled={!editingIssueText.trim()}
                                                                                                >
                                                                                                    Save
                                                                                                </button>
                                                                                                <button
                                                                                                    className="cancel-issue-btn"
                                                                                                    onClick={handleCancelEditIssue}
                                                                                                >
                                                                                                    Cancel
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="issue-content">
                                                                                            <p>{issue.issue}</p>
                                                                                            {inlineEditingId === lineItem.id && (
                                                                                                <div className="issue-actions">
                                                                                                    <button
                                                                                                        className="edit-issue-btn"
                                                                                                        onClick={() => handleEditIssue(issue.id)}
                                                                                                    >
                                                                                                        Edit
                                                                                                    </button>
                                                                                                    <button
                                                                                                        className="close-issue-btn"
                                                                                                        onClick={() => handleCloseIssue(issue.id)}
                                                                                                    >
                                                                                                        Close Issue
                                                                                                    </button>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                            </div>
                                                                            
                                                                            {/* Closed Issues Section */}
                                                                            {(inlineEditingId === lineItem.id ? issues : lineItem.issues || []).filter(issue => !issue.active).length > 0 && (
                                                                                <div className="line-item-closed-issues-section">
                                                                                    <div className="issues-list-header">
                                                                                        <span className="issues-list-title">Closed Issues</span>
                                                                                        <button
                                                                                            className="toggle-historic-issues-btn"
                                                                                            onClick={() => setShowHistoricIssues(!showHistoricIssues)}
                                                                                        >
                                                                                            {showHistoricIssues ? 'Hide' : 'Show'}
                                                                                        </button>
                                                                                    </div>
                                                                                    {showHistoricIssues && (
                                                                                        <div className="line-item-issues-list">
                                                                                            {(inlineEditingId === lineItem.id ? issues : lineItem.issues || [])
                                                                                                .filter(issue => !issue.active)
                                                                                                .map((issue, idx) => (
                                                                                                    <div key={issue.id || idx} className="line-item-issue-item closed">
                                                                                                        <div className="issue-item-header">
                                                                                                            <span className="issue-status-badge closed">
                                                                                                                Closed
                                                                                                            </span>
                                                                                                            {issue.createdDate && (
                                                                                                                <span className="issue-date">
                                                                                                                    Created: {new Date(issue.createdDate).toLocaleDateString()} by {issue.createdBy || 'Unknown'}
                                                                                                                </span>
                                                                                                            )}
                                                                                                            {issue.closedDate && (
                                                                                                                <span className="issue-date">
                                                                                                                    Closed: {new Date(issue.closedDate).toLocaleDateString()} by {issue.closedBy || 'Unknown'}
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <div className="issue-content">
                                                                                                            <p>{issue.issue}</p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                ))}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {isClicked && (
                                                                <div className="line-item-actions-expanded">
                                                                    {inlineEditingId === lineItem.id ? (
                                                                        <>
                                                                            <button 
                                                                                className="line-item-save-btn"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleInlineSave(lineItem.id);
                                                                                }}
                                                                                title="Save"
                                                                            >
                                                                                Save Changes
                                                                            </button>
                                                                            <button 
                                                                                className="line-item-cancel-btn"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleInlineCancel();
                                                                                }}
                                                                                title="Cancel"
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <button 
                                                                                className="line-item-edit-btn"
                                                                                onClick={(e) => handleEditClick(e, lineItem)}
                                                                                title="Edit"
                                                                            >
                                                                                <MdEdit /> Edit
                                                                            </button>
                                                                            <button 
                                                                                className="line-item-minimize-btn"
                                                                                onClick={(e) => handleMinimizeClick(e, lineItem.id)}
                                                                                title="Minimize"
                                                                            >
                                                                                <MdClose /> Close
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="project-details-scrollbar-helper" ref={scrollbarHelperRef} onScroll={handleHelperScroll}>
                        <div className="project-details-scrollbar-spacer" style={{ width: scrollbarContentWidth }}></div>
                    </div>

                    {showCreateModal && (
                        <div className="project-create-modal-overlay">
                            <div className="project-create-modal" onClick={(e) => e.stopPropagation()}>
                                <div className="project-create-modal-header">
                                    <div className="project-create-modal-title">{editingLineItem ? 'Edit Line Item' : 'Create Line Item'}</div>
                                    <button
                                        className="project-create-modal-close"
                                        onClick={handleCloseCreateModalAttempt}
                                        aria-label="Close"
                                    >
                                        ×
                                    </button>
                                </div>
                                {   !createModalSelection && !editingLineItem &&
                                    <div className="project-create-modal-content">
                                        <div className="project-create-option-btn" onClick={() => handleCreateModeSelection('submittals')}>
                                            <img src={PROCORE_LOGO} alt="Procore Logo" className="project-create-option-icon" />
                                            <div className='project-create-option-label'>
                                                Sync with Submittal
                                            </div>
                                            <div className='project-create-option-subtext'>
                                                Add a line item and sync it with a submittal in Procore
                                            </div>
                                        </div>

                                        <div className="project-create-option-btn" onClick={() => handleCreateModeSelection('manual')}>
                                            <MdAdd  className="project-create-option-icon"/>
                                            <div className='project-create-option-label'>
                                                Manual
                                            </div>
                                            <div className='project-create-option-subtext'>
                                                Manually add a line item without linking to a submittal in Procore.
                                            </div>
                                        </div>

                                        <div className="project-create-option-btn" onClick={() => setCreateModalSelection('upload')}>
                                            <FaFileUpload className="project-create-option-icon"/>
                                            <div className='project-create-option-label'>
                                                Upload Spreadsheet
                                            </div>
                                            <div className='project-create-option-subtext'>
                                                Upload a spreadsheet to bulk create line items.
                                            </div>
                                        </div>
                                    </div>
                                }
                                {   (createModalSelection || editingLineItem) &&
                                    <div className="project-create-modal-content">
                                        {NewLineItemWindow}
                                    </div>
                                }
                            </div>
                        </div>
                    )}
                    {projectScheduleModalOpen && (
                        <div className="project-schedule-modal-overlay" onClick={handleProjectScheduleModalClose}>
                            <div className="project-schedule-modal" onClick={(e) => e.stopPropagation()}>
                                <div className="project-create-modal-header">
                                    <h3>Upload Project Schedule</h3>
                                    <button className="project-create-modal-close" onClick={handleProjectScheduleModalClose}>×</button>
                                </div>
                                <div className="project-create-modal-content">
                                    <div className="project-schedule-upload-section">
                                        <div className="file-upload-area">
                                            <label htmlFor="schedule-file-upload" className="file-upload-label">
                                                <FaFileUpload size={48} />
                                                <p>{projectScheduleFile ? projectScheduleFile.name : 'Click to upload CSV file'}</p>
                                                <span className="file-upload-hint">CSV files only</span>
                                            </label>
                                            <input 
                                                id="schedule-file-upload"
                                                type="file" 
                                                accept=".csv"
                                                onChange={handleFileUpload}
                                                style={{ display: 'none' }}
                                            />
                                        </div>
                                        {projectSchedule && (
                                            <div className="file-upload-success">
                                                <p>✓ File uploaded successfully</p>
                                                <p className="file-details">{projectSchedule.length} rows parsed</p>
                                            </div>
                                        )}
                                        {projectScheduleSyncError && (
                                            <div className="project-schedule-error">
                                                {projectScheduleSyncError}
                                            </div>
                                        )}
                                        <div className="project-schedule-modal-actions">
                                            <button 
                                                className="modal-cancel-btn"
                                                onClick={handleProjectScheduleModalClose}
                                                disabled={projectScheduleSyncLoading}
                                            >
                                                Cancel
                                            </button>
                                            <button 
                                                className="modal-submit-btn"
                                                onClick={handleProjectScheduleSync}
                                                disabled={!projectSchedule || projectScheduleSyncLoading}
                                            >
                                                {projectScheduleSyncLoading ? 'Syncing...' : 'Submit'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {selectedProjectLineItem && (
                        <VendorLineItemsDetails 
                            apiToken={apiToken}
                            userName={userName}
                            workflows={workflows}
                            vendors={vendors}
                            selectedLineItem={selectedProjectLineItem}
                            closeModal={() => setSelectedProjectLineItem(null)}
                            refreshData={refreshData}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

const VendorLineItemsDetails = ({apiToken, userName, workflows, vendors, selectedLineItem, closeModal, refreshData}) => {
    const [editedSteps, setEditedSteps] = useState([]);
    const [originalShippingAddress, setOriginalShippingAddress] = useState(null);
    const [originalShippingContact, setOriginalShippingContact] = useState(null);
    
    // Form states
    const [description, setDescription] = useState('');
    const [poNumber, setPoNumber] = useState('');
    const [amount, setAmount] = useState('');
    const [externalOrderNumber, setExternalOrderNumber] = useState('');
    const [externalOffsiteStorage, setExternalOffsiteStorage] = useState('');
    const [notes, setNotes] = useState('');
    const [externalNotes, setExternalNotes] = useState('');
    const [controlNotes, setControlNotes] = useState('');
    const [projectManager, setProjectManager] = useState('');
    const [projectEngineer, setProjectEngineer] = useState('');
    const [externalProjectManager, setExternalProjectManager] = useState('');
    const [externalProjectEngineer, setExternalProjectEngineer] = useState('');
    const [requestedDate, setRequestedDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [address, setAddress] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState('USA');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [extension, setExtension] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [contactTitle, setContactTitle] = useState('');
    const [schedule, setSchedule] = useState('');
    const [issues, setIssues] = useState([]);
    const [newIssueText, setNewIssueText] = useState('');
    const [editingIssueId, setEditingIssueId] = useState(null);
    const [editingIssueText, setEditingIssueText] = useState('');
    const [showHistoricIssues, setShowHistoricIssues] = useState(false);
    
    useEffect(() => {
        if (selectedLineItem) {
            // Initialize form fields with selectedLineItem data
            setDescription(selectedLineItem.description || '');
            setPoNumber(selectedLineItem.poNumber || '');
            setAmount(selectedLineItem.amount || '');
            setExternalOrderNumber(selectedLineItem.externalOrderNumber || '');
            setExternalOffsiteStorage(
                selectedLineItem.externalOffsiteStorage === true ? 'Yes' : 
                selectedLineItem.externalOffsiteStorage === false ? 'No' : ''
            );
            setNotes(selectedLineItem.notes || '');
            setExternalNotes(selectedLineItem.externalNotes || '');
            setControlNotes(selectedLineItem.controlNotes || '');
            setProjectManager(selectedLineItem.projectManager || '');
            setProjectEngineer(selectedLineItem.projectEngineer || '');
            setExternalProjectManager(selectedLineItem.externalProjectManager || '');
            setExternalProjectEngineer(selectedLineItem.externalProjectEngineer || '');
            setRequestedDate(selectedLineItem.requestDate ? new Date(selectedLineItem.requestDate).toISOString().split('T')[0] : '');
            setStartDate(selectedLineItem.startDate ? new Date(selectedLineItem.startDate).toISOString().split('T')[0] : '');
            setSchedule(selectedLineItem.schedule || '');
            setIssues(selectedLineItem.issues || []);
            setNewIssueText('');
            setEditingIssueId(null);
            setEditingIssueText('');
            setShowHistoricIssues(false);
            
            // Store original shipping data
            setOriginalShippingAddress(selectedLineItem.shippingAddress);
            setOriginalShippingContact(selectedLineItem.shippingContact);
            
            // Initialize shipping address
            if (selectedLineItem.shippingAddress) {
                setAddress(selectedLineItem.shippingAddress.address || '');
                setAddress2(selectedLineItem.shippingAddress.address2 || '');
                setCity(selectedLineItem.shippingAddress.city || '');
                setState(selectedLineItem.shippingAddress.state || '');
                setZip(normalizeZipCodeInput(selectedLineItem.shippingAddress.zip || ''));
                setCountry(selectedLineItem.shippingAddress.country || 'USA');
            } else {
                setAddress('');
                setAddress2('');
                setCity('');
                setState('');
                setZip('');
                setCountry('USA');
            }
            
            // Initialize shipping contact
            if (selectedLineItem.shippingContact) {
                setFirstName(selectedLineItem.shippingContact.firstName || '');
                setLastName(selectedLineItem.shippingContact.lastName || '');
                setContactNumber(normalizePhoneInput(selectedLineItem.shippingContact.phone || ''));
                setExtension(selectedLineItem.shippingContact.extension || '');
                setContactEmail(selectedLineItem.shippingContact.email || '');
                setContactTitle(selectedLineItem.shippingContact.title || '');
            } else {
                setFirstName('');
                setLastName('');
                setContactNumber('');
                setExtension('');
                setContactEmail('');
                setContactTitle('');
            }
            
            // Initialize workflow steps
            if (selectedLineItem.steps && selectedLineItem.steps.length > 0) {
                const stepsWithStatus = selectedLineItem.steps.map(stepArray => ({
                    ...stepArray[0],
                    status: stepArray[0].status || 'Not Started'
                }));
                setEditedSteps(stepsWithStatus);
            }
        }
    }, [selectedLineItem]);
    
    // Issue management functions
    const handleAddIssue = () => {
        if (!newIssueText.trim()) return;
        const newIssue = {
            issue: newIssueText,
            active: true
        };
        setIssues([...issues, newIssue]);
        setNewIssueText('');
    };

    const handleEditIssue = (issueId) => {
        const issueToEdit = issues.find(i => i.id === issueId);
        if (issueToEdit) {
            setEditingIssueId(issueId);
            setEditingIssueText(issueToEdit.issue);
        }
    };

    const handleSaveEditIssue = () => {
        if (!editingIssueText.trim()) return;
        setIssues(issues.map(i => 
            i.id === editingIssueId 
                ? { ...i, issue: editingIssueText, edited: true }
                : i
        ));
        setEditingIssueId(null);
        setEditingIssueText('');
    };

    const handleCancelEditIssue = () => {
        setEditingIssueId(null);
        setEditingIssueText('');
    };

    const handleCloseIssue = (issueId) => {
        setIssues(issues.map(i => 
            i.id === issueId 
                ? { ...i, closed: true, active: false }
                : i
        ));
    };
    
    const handleSave = useCallback(() => {
        if (zip && !isValidZipCode(zip)) {
            alert('Please enter a valid 5-digit ZIP code.');
            return;
        }

        // Check if shipping address was changed
        const shippingAddressChanged = originalShippingAddress ? (
            originalShippingAddress.address !== address ||
            originalShippingAddress.address2 !== address2 ||
            originalShippingAddress.city !== city ||
            originalShippingAddress.state !== state ||
            originalShippingAddress.zip !== zip ||
            originalShippingAddress.country !== country
        ) : (address || city || state || zip);
        
        // Build shipping address object
        const shippingAddressObj = (address || city || state || zip) ? {
            ...(originalShippingAddress?.id && { id: originalShippingAddress.id }),
            address,
            address2,
            city,
            state,
            zip,
            country,
            ...(shippingAddressChanged && { edited: true })
        } : null;
        
        // Check if shipping contact was changed
        const shippingContactChanged = originalShippingContact ? (
            originalShippingContact.firstName !== firstName ||
            originalShippingContact.lastName !== lastName ||
            originalShippingContact.phone !== contactNumber ||
            originalShippingContact.extension !== extension ||
            originalShippingContact.email !== contactEmail ||
            originalShippingContact.title !== contactTitle
        ) : (firstName || lastName || contactNumber || contactEmail);
        
        // Build shipping contact object
        const shippingContactObj = (firstName || lastName || contactNumber || contactEmail) ? {
            ...(originalShippingContact?.id && { id: originalShippingContact.id }),
            firstName: firstName,
            lastName: lastName,
            phone: contactNumber,
            extension,
            email: contactEmail,
            title: contactTitle,
            ...(shippingContactChanged && { edited: true })
        } : null;
        
        const updatedLineItem = {
            id: selectedLineItem.id,
            projectId: selectedLineItem.projectId,
            projectNumber: selectedLineItem.projectNumber,
            submittalId: selectedLineItem.submittalId,
            submittalName: selectedLineItem.submittalName,
            specId: selectedLineItem.specId,
            specName: selectedLineItem.specName,
            description,
            poNumber,
            vendorId: selectedLineItem.vendorId,
            vendorName: selectedLineItem.vendorName,
            amount: parseCurrencyNumber(amount),
            externalOrderNumber,
            externalOffsiteStorage: externalOffsiteStorage === 'Yes' ? true : externalOffsiteStorage === 'No' ? false : null,
            notes,
            externalNotes,
            controlNotes,
            projectManager,
            projectEngineer,
            externalProjectManager,
            externalProjectEngineer,
            requestDate: requestedDate || null,
            startDate: startDate || null,
            schedule: schedule || null,
            issues: issues || [],
            shippingAddress: shippingAddressObj,
            shippingContact: shippingContactObj,
            steps: editedSteps.length > 0 ? editedSteps : undefined,
            updatedBy: userName
        };
        
        updateProjectLineItem(updatedLineItem, apiToken, () => {
            refreshData();
            closeModal();
        }, (error) => {
            console.error('Error updating line item:', error);
        });
    }, [apiToken, selectedLineItem, description, poNumber, amount, externalOrderNumber, externalOffsiteStorage, notes, externalNotes, controlNotes, projectManager, projectEngineer, externalProjectManager, externalProjectEngineer, requestedDate, startDate, schedule, issues, address, address2, city, state, zip, country, firstName, lastName, contactNumber, extension, contactEmail, contactTitle, userName, editedSteps, originalShippingAddress, originalShippingContact, refreshData, closeModal]);

    const handleDelete = useCallback(() => {
        if (!selectedLineItem?.id) return;

        const shouldDelete = window.confirm('Are you sure you want to delete this line item? This action cannot be undone.');
        if (!shouldDelete) return;

        deleteProjectLineItem(selectedLineItem.id, apiToken, () => {
            refreshData();
            closeModal();
        }, (error) => {
            console.error('Error deleting line item:', error);
        });
    }, [selectedLineItem, apiToken, refreshData, closeModal]);
    
    if (!selectedLineItem) return null;

    const vendorModalStatusClass = selectedLineItem.status
        ? `status-${selectedLineItem.status.toLowerCase().replace(/\s+/g, '-')}`
        : 'status-not-started';

    const formatVendorModalBannerDate = (value) => {
        if (!value) return 'N/A';
        const parsedDate = new Date(value);
        if (Number.isNaN(parsedDate.getTime())) return 'N/A';
        return parsedDate.toLocaleDateString('en-US');
    };

    const expectedDateText = formatVendorModalBannerDate(selectedLineItem.expectedDate || selectedLineItem.requestDate);
    const anticipatedDateText = formatVendorModalBannerDate(selectedLineItem.expectedCompletionDate);
    const activeIssueMessages = (issues || [])
        .filter((issueRecord) => issueRecord?.active)
        .map((issueRecord) => String(issueRecord?.issue ?? '').trim())
        .filter(Boolean);
    const issueBannerMessage = activeIssueMessages.join(' | ');
    const vendorVerificationStatuses = ['Overdue', 'Critical', 'High', 'Pending'];
    const showsVendorVerificationBanner = vendorVerificationStatuses.includes(selectedLineItem.status);
    const daysUnverified = Number.isFinite(Number(selectedLineItem?.daysUnverified))
        ? Number(selectedLineItem.daysUnverified)
        : 0;
    
    return (
        <div className="vendor-modal-overlay" onClick={closeModal}>
            <div className="vendor-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="vendor-modal-header">
                    <h2>
                        {selectedLineItem.status ? (
                            <span className={`status-badge ${vendorModalStatusClass}`}>{selectedLineItem.status}</span>
                        ) : (
                            <span>-</span>
                        )}
                        <span>{selectedLineItem.description || '-'}</span>
                    </h2>
                    <button className="close-button" onClick={closeModal}>×</button>
                </div>
                {selectedLineItem.status === 'At Risk' && (
                    <div className="vendor-modal-alert-banner at-risk">
                        The expected date is {expectedDateText} and the anticipated date is {anticipatedDateText}. This is at risk of being delayed.
                    </div>
                )}
                {selectedLineItem.status === 'Issue' && activeIssueMessages.length > 0 && (
                    <div className="vendor-modal-alert-banner issue">
                        {issueBannerMessage}
                    </div>
                )}
                {showsVendorVerificationBanner && (
                    <div className={`vendor-modal-alert-banner ${selectedLineItem.status.toLowerCase().replace(/\s+/g, '-')}`}>
                        This has not yet been verified by the vendor and we have been waiting <strong>{daysUnverified} days</strong>.
                    </div>
                )}
                <div className="vendor-modal-content">
                    <div className="line-item-details-container">
                        {/* Row 1: Submittal Info */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Submittal Name</div>
                                <div className="line-item-detail-value">{selectedLineItem.submittalName || '-'}</div>
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Spec Name</div>
                                <div className="line-item-detail-value">{selectedLineItem.specName || '-'}</div>
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Description</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Row 2: Vendor & Order Info */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Vendor Name</div>
                                <div className="line-item-detail-value">{selectedLineItem.vendorName || '-'}</div>
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">PO Number</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={poNumber}
                                    onChange={(e) => setPoNumber(e.target.value)}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Amount</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={formatCurrencyInput(amount)}
                                    onChange={(e) => setAmount(normalizeCurrencyInput(e.target.value))}
                                    inputMode="decimal"
                                    placeholder="0.00"
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">External Order #</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={externalOrderNumber}
                                    onChange={(e) => setExternalOrderNumber(e.target.value)}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Offsite Storage</div>
                                <select
                                    className="line-item-edit-input"
                                    value={externalOffsiteStorage || ''}
                                    onChange={(e) => setExternalOffsiteStorage(e.target.value)}
                                >
                                    <option value="">-</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>

                        {/* Row 3: Date Information */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Start Date</div>
                                <input
                                    type="date"
                                    className="line-item-edit-input"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Requested Completion Date</div>
                                <input
                                    type="date"
                                    className="line-item-edit-input"
                                    value={requestedDate}
                                    onChange={(e) => setRequestedDate(e.target.value)}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Expected Completion Date</div>
                                <div className="line-item-detail-value">{selectedLineItem.expectedCompletionDate ? new Date(selectedLineItem.expectedCompletionDate).toLocaleDateString() : '-'}</div>
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Procore Updated</div>
                                <div className="line-item-detail-value">{selectedLineItem.procoreRefreshDate ? new Date(selectedLineItem.procoreRefreshDate).toLocaleDateString() : '-'}</div>
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Project Schedule Updated</div>
                                <div className="line-item-detail-value">{selectedLineItem.projectScheduleSyncDate ? new Date(selectedLineItem.projectScheduleSyncDate).toLocaleDateString() : '-'}</div>
                            </div>
                        </div>

                        {/* Row 4: Workflow & Steps */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group line-item-workflow-section">
                                <div className="line-item-detail-label">Workflow: {selectedLineItem.workflow || 'Not Set'}</div>
                                {selectedLineItem.steps && selectedLineItem.steps.length > 0 && (
                                    <div className="line-item-workflow-steps">
                                        {editedSteps.map((step, idx) => {
                                            if (!step) return null;
                                            return (
                                                <div key={idx} className="line-item-workflow-step">
                                                    <div className="line-item-workflow-step-number">{idx + 1}</div>
                                                    <div className="line-item-workflow-step-content">
                                                        <div className="line-item-workflow-step-name">{step.name}</div>
                                                        <div className="line-item-workflow-step-role">
                                                            {step.role ? (typeof step.role === 'object' ? step.role.name : step.role) : '-'}
                                                        </div>
                                                        <div className="line-item-workflow-step-leadtime">
                                                            {step.expectedLeadtime ? `${step.expectedLeadtime}d` : '-'}
                                                        </div>
                                                        <div className={`line-item-workflow-step-expected-date ${step.status === 'Completed' ? 'completed' : 'not-completed'}`}>
                                                            {step.status === 'Completed' 
                                                                ? (step.date ? new Date(step.date).toLocaleDateString() : '-')
                                                                : (step.expectedCompletionDate ? new Date(step.expectedCompletionDate).toLocaleDateString() : '-')
                                                            }
                                                        </div>
                                                        <select
                                                            className="line-item-workflow-step-status-select"
                                                            value={step.status || 'Not Started'}
                                                            onChange={(e) => {
                                                                const newSteps = [...editedSteps];
                                                                newSteps[idx] = { ...newSteps[idx], status: e.target.value, editted: true };
                                                                setEditedSteps(newSteps);
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <option value="Not Started">Not Started</option>
                                                            <option value="In Progress">In Progress</option>
                                                            <option value="On Hold">On Hold</option>
                                                            <option value="Completed">Completed</option>
                                                            <option value="N/A">N/A</option>
                                                        </select>
                                                    </div>
                                                    {idx < editedSteps.length - 1 && (
                                                        <div className="line-item-workflow-step-arrow">→</div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Row 5: Notes */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Notes</div>
                                <textarea
                                    className="line-item-edit-textarea"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    rows={3}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">External Notes</div>
                                <textarea
                                    className="line-item-edit-textarea"
                                    value={externalNotes}
                                    onChange={(e) => setExternalNotes(e.target.value)}
                                    rows={3}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Control Notes</div>
                                <textarea
                                    className="line-item-edit-textarea"
                                    value={controlNotes}
                                    onChange={(e) => setControlNotes(e.target.value)}
                                    rows={3}
                                />
                            </div>
                        </div>

                        {/* Row 6: Team */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Project Manager</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={projectManager}
                                    onChange={(e) => setProjectManager(e.target.value)}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Project Engineer</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={projectEngineer}
                                    onChange={(e) => setProjectEngineer(e.target.value)}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">External PM</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={externalProjectManager}
                                    onChange={(e) => setExternalProjectManager(e.target.value)}
                                />
                            </div>
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">External PE</div>
                                <input
                                    type="text"
                                    className="line-item-edit-input"
                                    value={externalProjectEngineer}
                                    onChange={(e) => setExternalProjectEngineer(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Row 7: Shipping Address */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Shipping Address</div>
                                <div className="line-item-edit-shipping">
                                    <input type="text" className="line-item-edit-input-small" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} />
                                    <input type="text" className="line-item-edit-input-small" placeholder="Address 2" value={address2} onChange={(e) => setAddress2(e.target.value)} />
                                    <input type="text" className="line-item-edit-input-small" placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} />
                                    <select className="line-item-edit-input-small" value={state} onChange={(e) => setState(e.target.value)}>
                                        <option value="">State</option>
                                        {US_STATES.map((stateOption) => (
                                            <option key={stateOption.code} value={stateOption.code}>{stateOption.name}</option>
                                        ))}
                                    </select>
                                    <input type="text" className="line-item-edit-input-small" placeholder="Zip" value={zip} onChange={(e) => setZip(normalizeZipCodeInput(e.target.value))} inputMode="numeric" maxLength={5} />
                                </div>
                            </div>
                        </div>

                        {/* Row 8: Shipping Contact */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Shipping Contact</div>
                                <div className="line-item-edit-shipping">
                                    <input type="text" className="line-item-edit-input-small" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    <input type="text" className="line-item-edit-input-small" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                    <input type="text" className="line-item-edit-input-small" placeholder="Title" value={contactTitle} onChange={(e) => setContactTitle(e.target.value)} />
                                    <input type="text" className="line-item-edit-input-small" placeholder="Phone" value={formatPhoneInput(contactNumber)} onChange={(e) => setContactNumber(normalizePhoneInput(e.target.value))} inputMode="numeric" />
                                    <input type="text" className="line-item-edit-input-small" placeholder="Ext" value={extension} onChange={(e) => setExtension(e.target.value)} />
                                    <input type="email" className="line-item-edit-input-small" placeholder="Email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Row 9: Schedule */}
                        <div className="line-item-detail-row">
                            <div className="line-item-detail-group">
                                <div className="line-item-detail-label">Schedule UID</div>
                                <input 
                                    type="text" 
                                    className="line-item-edit-input" 
                                    value={schedule} 
                                    style={{ width: "100px" }}
                                    onChange={(e) => setSchedule(e.target.value)} 
                                />
                            </div>
                        </div>

                        {/* Row 10: Issues */}
                        <div className="line-item-issues-section">
                            <div className="line-item-detail-row">
                                <div className="line-item-detail-group line-item-detail-full">
                                    <div className="line-item-detail-label">Issues</div>
                                    
                                    <div className="line-item-add-issue">
                                        <textarea
                                            className="line-item-issue-input"
                                            value={newIssueText}
                                            onChange={(e) => setNewIssueText(e.target.value)}
                                            placeholder="Describe the issue..."
                                            rows={2}
                                        />
                                        <button
                                            className="add-issue-btn"
                                            onClick={handleAddIssue}
                                            disabled={!newIssueText.trim()}
                                        >
                                            + Add Issue
                                        </button>
                                    </div>
                                    
                                    <div className="line-item-issues-list">
                                        {issues.filter(issue => issue.active).length > 0 && (
                                            <div className="issues-list-header">
                                                <span className="issues-list-title">Active Issues</span>
                                            </div>
                                        )}
                                        {issues
                                            .filter(issue => issue.active)
                                            .map((issue, idx) => (
                                                <div key={issue.id || idx} className="line-item-issue-item">
                                                    <div className="issue-item-header">
                                                        <span className="issue-status-badge active">Active</span>
                                                        {issue.createdDate && (
                                                            <span className="issue-date">
                                                                Created: {new Date(issue.createdDate).toLocaleDateString()} by {issue.createdBy || 'Unknown'}
                                                            </span>
                                                        )}
                                                    </div>
                                                    
                                                    {editingIssueId === issue.id ? (
                                                        <div className="issue-edit-container">
                                                            <textarea
                                                                className="line-item-issue-input"
                                                                value={editingIssueText}
                                                                onChange={(e) => setEditingIssueText(e.target.value)}
                                                                rows={3}
                                                            />
                                                            <div className="issue-edit-actions">
                                                                <button
                                                                    className="save-issue-btn"
                                                                    onClick={handleSaveEditIssue}
                                                                    disabled={!editingIssueText.trim()}
                                                                >
                                                                    Save
                                                                </button>
                                                                <button
                                                                    className="cancel-issue-btn"
                                                                    onClick={handleCancelEditIssue}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="issue-content">
                                                            <p>{issue.issue}</p>
                                                            <div className="issue-actions">
                                                                <button
                                                                    className="edit-issue-btn"
                                                                    onClick={() => handleEditIssue(issue.id)}
                                                                >
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    className="close-issue-btn"
                                                                    onClick={() => handleCloseIssue(issue.id)}
                                                                >
                                                                    Close Issue
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                    </div>
                                    
                                    {issues.filter(issue => !issue.active).length > 0 && (
                                        <div className="line-item-closed-issues-section">
                                            <div className="issues-list-header">
                                                <span className="issues-list-title">Closed Issues</span>
                                                <button
                                                    className="toggle-historic-issues-btn"
                                                    onClick={() => setShowHistoricIssues(!showHistoricIssues)}
                                                >
                                                    {showHistoricIssues ? 'Hide' : 'Show'}
                                                </button>
                                            </div>
                                            {showHistoricIssues && (
                                                <div className="line-item-issues-list">
                                                    {issues
                                                        .filter(issue => !issue.active)
                                                        .map((issue, idx) => (
                                                            <div key={issue.id || idx} className="line-item-issue-item closed">
                                                                <div className="issue-item-header">
                                                                    <span className="issue-status-badge closed">Closed</span>
                                                                    {issue.createdDate && (
                                                                        <span className="issue-date">
                                                                            Created: {new Date(issue.createdDate).toLocaleDateString()} by {issue.createdBy || 'Unknown'}
                                                                        </span>
                                                                    )}
                                                                    {issue.closedDate && (
                                                                        <span className="issue-date">
                                                                            Closed: {new Date(issue.closedDate).toLocaleDateString()} by {issue.closedBy || 'Unknown'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <div className="issue-content">
                                                                    <p>{issue.issue}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="line-item-actions-expanded">
                            <button 
                                className="line-item-cancel-btn"
                                onClick={closeModal}
                                title="Cancel"
                            >
                                Cancel
                            </button>
                            <button 
                                className="line-item-delete-btn"
                                onClick={handleDelete}
                                title="Delete"
                            >
                                Delete
                            </button>
                            <button 
                                className="line-item-save-btn"
                                onClick={handleSave}
                                title="Save"
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ProjectsDisplay = ({apiToken, filteredProjects, filteredVendors, projectsError, setSelectedProject, branchFilters, viewMode, stepTypeFilter, statusFilter, workflows, vendors, userName, refreshData}) => {
    const [collapsedBranches, setCollapsedBranches] = useState({});
    const [collapsedVendors, setCollapsedVendors] = useState({});
    const [collapsedVendorProjects, setCollapsedVendorProjects] = useState({});
    const [hoveredProject, setHoveredProject] = useState(null);
    const [selectedVendorLineItem, setSelectedVendorLineItem] = useState(null);

    const toggleBranchCollapse = (branch) => {
        setCollapsedBranches(prev => ({
            ...prev,
            [branch]: !prev[branch]
        }));
    };

    const toggleVendorCollapse = (vendorName) => {
        setCollapsedVendors(prev => ({
            ...prev,
            [vendorName]: !prev[vendorName]
        }));
    };

    const toggleVendorProjectCollapse = (vendorName, projectNumber) => {
        const key = `${vendorName}-${projectNumber}`;
        setCollapsedVendorProjects(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    if (projectsError) {
        return (
            <div className="projects-display">
                <div className="projects-display-error">
                    <div className="error-icon">⚠</div>
                    <h3>Unable to Load Projects</h3>
                    <p>{projectsError}</p>
                </div>
            </div>
        );
    };

    if (viewMode === 'Project' && !filteredProjects) {
        return (
            <div className="projects-display">
                <div className="projects-display-loading">
                    <div className="pt-loading-spinner"></div>
                    <p>Loading projects...</p>
                </div>
            </div>
        );
    };

    if (viewMode === 'Vendor' && !filteredVendors) {
        return (
            <div className="projects-display">
                <div className="projects-display-loading">
                    <div className="pt-loading-spinner"></div>
                    <p>Loading vendors...</p>
                </div>
            </div>
        );
    };

    // Vendor View
    if (viewMode === 'Vendor' && filteredVendors) {
        const sortedVendors = Object.keys(filteredVendors).sort((a, b) => a.localeCompare(b));

        return (
            <div className="projects-display">
                {sortedVendors.map(vendorName => {
                    const vendorProjects = filteredVendors[vendorName];
                    
                    // Count total items for this vendor (filtered by stepType and status)
                    let totalItems = 0;
                    Object.values(vendorProjects).forEach(projectItems => {
                        if (Array.isArray(projectItems)) {
                            let filtered = stepTypeFilter === 'Both' 
                                ? projectItems 
                                : projectItems.filter(item => item.stepType === stepTypeFilter);
                            
                            if (statusFilter.length > 0) {
                                filtered = filtered.filter(item => statusFilter.includes(item.status));
                            }
                            
                            totalItems += filtered.length;
                        }
                    });

                    if (totalItems === 0) return null;
                    
                    const vendorLink = vendorProjects.vendorLink?.link;

                    const handleCopyLink = (e) => {
                        e.stopPropagation();
                        if (vendorLink) {
                            navigator.clipboard.writeText(vendorLink).then(() => {
                                // Optional: Add visual feedback
                                console.log('Link copied:', vendorLink);
                            }).catch(err => {
                                console.error('Failed to copy link:', err);
                            });
                        }
                    };

                    return (
                        <div key={vendorName} className="branch-section">
                            <div 
                                className="pt-branch-header" 
                                onClick={() => toggleVendorCollapse(vendorName)}
                                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="pt-branch-collapse-icon">
                                        {collapsedVendors[vendorName] ? '▶' : '▼'}
                                    </span>
                                    {vendorName} ({totalItems} items)
                                </div>
                                {vendorLink && (
                                    <button
                                        onClick={handleCopyLink}
                                        style={{
                                            background: 'rgba(255, 255, 255, 0.1)',
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            borderRadius: '4px',
                                            padding: '4px 8px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            fontSize: '12px',
                                            color: '#ffffff',
                                            marginRight: '8px',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                        }}
                                        title="Copy vendor link"
                                    >
                                        <MdContentCopy size={14} />
                                        Copy Vendor Link
                                    </button>
                                )}
                            </div>
                            {!collapsedVendors[vendorName] && (
                                <div className="pt-projects-list vendor-view">
                                    {Object.keys(vendorProjects).sort().map(projectNumber => {
                                        const items = vendorProjects[projectNumber];
                                        if (!Array.isArray(items) || items.length === 0) return null;

                                        // Filter items by stepType and status
                                        let filteredItems = stepTypeFilter === 'Both' 
                                            ? items 
                                            : items.filter(item => item.stepType === stepTypeFilter);

                                        if (statusFilter.length > 0) {
                                            filteredItems = filteredItems.filter(item => statusFilter.includes(item.status));
                                        }

                                        if (filteredItems.length === 0) return null;

                                        const projectKey = `${vendorName}-${projectNumber}`;
                                        const isProjectCollapsed = collapsedVendorProjects[projectKey];
                                        
                                        // Get project display name from first item
                                        const projectDisplayName = filteredItems[0]?.projectDisplayName || 
                                                                  `${projectNumber} - ${filteredItems[0]?.projectName || 'Unknown Project'}`;

                                        return (
                                            <div key={projectNumber} className="vendor-project-section">
                                                <div 
                                                    className="vendor-project-header"
                                                    onClick={() => toggleVendorProjectCollapse(vendorName, projectNumber)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span className="vendor-project-collapse-icon">
                                                        {isProjectCollapsed ? '▶' : '▼'}
                                                    </span>
                                                    {projectDisplayName} ({filteredItems.length} {filteredItems.length === 1 ? 'item' : 'items'})
                                                </div>
                                                {!isProjectCollapsed && (
                                                    <div className="vendor-line-items-list">
                                                        {filteredItems.map((item, index) => (
                                                            <div 
                                                                key={`${projectNumber}-${item.submittalId || index}`}
                                                                className="vendor-line-item-row"
                                                                onClick={() => setSelectedVendorLineItem(item)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {/* Row 1: Status, Next Step, Ball in Court, and Expected Completion */}
                                                                <div className="vendor-line-item-row-section">
                                                                    <div className="vendor-line-item-field">
                                                                        <span className="vendor-field-value">
                                                                            {item.status ? (
                                                                                <span className={`status-badge status-${item.status.toLowerCase().replace(' ', '-')}`}>
                                                                                    {item.status}
                                                                                </span>
                                                                            ) : '-'}
                                                                        </span>
                                                                    </div>
                                                                    {item.nextStep && (
                                                                        <>
                                                                            <div className="vendor-line-item-field">
                                                                                <span className="vendor-field-label">Next Step</span>
                                                                                <span className="vendor-field-value">{item.nextStep.name || '-'}</span>
                                                                            </div>
                                                                            <div className="vendor-line-item-field">
                                                                                <span className="vendor-field-label">Ball in Court</span>
                                                                                <span className="vendor-field-value">
                                                                                    {item.nextStep.role ? (
                                                                                        <span className={`ball-in-court-badge ${
                                                                                            item.nextStep.role.type === 'Internal' 
                                                                                                ? 'ball-in-court-internal' 
                                                                                                : 'ball-in-court-external'
                                                                                        }`}>
                                                                                            {item.nextStep.role.type === 'Internal' ? 'INT' : 'EXT'} - {item.nextStep.role.name}
                                                                                        </span>
                                                                                    ) : '-'}
                                                                                </span>
                                                                            </div>
                                                                            {item.nextStep.expectedCompletionDate && (
                                                                                <div className="vendor-line-item-field">
                                                                                    <span className="vendor-field-label">Expected Step Completion</span>
                                                                                    <span className="vendor-field-value">
                                                                                        {new Date(item.nextStep.expectedCompletionDate).toLocaleDateString()}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {item.expectedCompletionDate && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">Estimated Completion</span>
                                                                            <span className="vendor-field-value">
                                                                                {new Date(item.expectedCompletionDate).toLocaleDateString()}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                    {item.requestDate && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">Expected Completion</span>
                                                                            <span className="vendor-field-value">
                                                                                {new Date(item.requestDate).toLocaleDateString()}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* Row 3: Submittal, Spec, External Order, PO Number, and Team */}
                                                                <div className="vendor-line-item-row-section">
                                                                    {item.description && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">Description</span>
                                                                            <span className="vendor-field-value">{item.description}</span>
                                                                        </div>
                                                                    )}
                                                                    <div className="vendor-line-item-field">
                                                                        <span className="vendor-field-label">Submittal</span>
                                                                        <span className="vendor-field-value">{item.submittalName || '-'}</span>
                                                                    </div>
                                                                    <div className="vendor-line-item-field">
                                                                        <span className="vendor-field-label">Spec</span>
                                                                        <span className="vendor-field-value">{item.specName || '-'}</span>
                                                                    </div>
                                                                    {item.externalOrderNumber && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">External Order #</span>
                                                                            <span className="vendor-field-value">{item.externalOrderNumber}</span>
                                                                        </div>
                                                                    )}
                                                                    {item.poNumber && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">PO Number</span>
                                                                            <span className="vendor-field-value">{item.poNumber}</span>
                                                                        </div>
                                                                    )}
                                                                    {item.projectManager && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">Project Manager</span>
                                                                            <span className="vendor-field-value">{item.projectManager}</span>
                                                                        </div>
                                                                    )}
                                                                    {item.projectEngineer && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">Project Engineer</span>
                                                                            <span className="vendor-field-value">{item.projectEngineer}</span>
                                                                        </div>
                                                                    )}
                                                                    {item.externalProjectManager && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">External PM</span>
                                                                            <span className="vendor-field-value">{item.externalProjectManager}</span>
                                                                        </div>
                                                                    )}
                                                                    {item.externalProjectEngineer && (
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-label">External PE</span>
                                                                            <span className="vendor-field-value">{item.externalProjectEngineer}</span>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* Row 5: Issue and Issue Note */}
                                                                {item.issue && (
                                                                    <div className="vendor-line-item-row-section">
                                                                        <div className="vendor-line-item-field">
                                                                            <span className="vendor-field-value vendor-issue-icon">⚠️</span>
                                                                        </div>
                                                                        {item.issueNote && (
                                                                            <div className="vendor-line-item-field">
                                                                                <span className="vendor-field-label">Issue Note</span>
                                                                                <span className="vendor-field-value">{item.issueNote}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                {/* Row 6: Notes */}
                                                                {(item.externalNotes || item.notes || item.controlNotes) && (
                                                                    <div className="vendor-line-item-row-section">
                                                                        {item.externalNotes && (
                                                                            <div className="vendor-line-item-field">
                                                                                <span className="vendor-field-label">External Notes</span>
                                                                                <span className="vendor-field-value">{item.externalNotes}</span>
                                                                            </div>
                                                                        )}
                                                                        {item.notes && (
                                                                            <div className="vendor-line-item-field">
                                                                                <span className="vendor-field-label">Notes</span>
                                                                                <span className="vendor-field-value">{item.notes}</span>
                                                                            </div>
                                                                        )}
                                                                        {item.controlNotes && (
                                                                            <div className="vendor-line-item-field">
                                                                                <span className="vendor-field-label">Control Notes</span>
                                                                                <span className="vendor-field-value">{item.controlNotes}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
                
                {/* Vendor Line Item Details Modal */}
                {selectedVendorLineItem && (
                    <VendorLineItemsDetails 
                        apiToken={apiToken}
                        userName={userName}
                        workflows={workflows}
                        vendors={vendors}
                        selectedLineItem={selectedVendorLineItem}
                        closeModal={() => setSelectedVendorLineItem(null)}
                        refreshData={refreshData}
                    />
                )}
            </div>
        );
    }

    // Project View (existing logic)
    // Get sorted branch keys (02, 09, etc.)
    let sortedBranches = Object.keys(filteredProjects).sort((a, b) => parseInt(a) - parseInt(b));
    
    // Apply branch filters if any are selected
    if (branchFilters.length > 0) {
        sortedBranches = sortedBranches.filter(branch => branchFilters.includes(branch));
    }

    return (
        <div className="projects-display">
            {sortedBranches.map(branch => {
                // Only show branch if it has projects
                if (!filteredProjects[branch] || filteredProjects[branch].length === 0) {
                    return null;
                }
                
                return (
                <div key={branch} className="branch-section">
                    <div 
                        className="pt-branch-header" 
                        onClick={() => toggleBranchCollapse(branch)}
                        style={{ cursor: 'pointer' }}
                    >
                        <span className="pt-branch-collapse-icon">
                            {collapsedBranches[branch] ? '▶' : '▼'}
                        </span>
                        {branch} - {branchList[branch]?.name || ''}
                    </div>
                    {!collapsedBranches[branch] && (
                        <div className="pt-projects-list">
                        {filteredProjects[branch].map((project, index) => (
                            <div 
                                key={project.project_number || index} 
                                className="pt-project-item" 
                                onClick={() => setSelectedProject(project)}
                                onMouseEnter={() => setHoveredProject(project.project_number || index)}
                                onMouseLeave={() => setHoveredProject(null)}
                            >
                                <div className="pt-project-item-header">
                                    {project.displayName}
                                </div>
                                {project.statistics && (
                                    <div className="pt-project-item-summary">
                                        {/* Statistics breakdown */}
                                        {project.statistics.totalLineItems > 0 ? (
                                            <>
                                                <div className="pt-project-summary-bars">
                                                    <div className="pt-project-summary-bar-container">
                                                        {project.statistics.completedLineItems > 0 && (
                                                            <div 
                                                                className="pt-project-summary-bar pt-bar-completed" 
                                                                style={{ width: `${(project.statistics.completedLineItems / project.statistics.totalLineItems) * 100}%` }}
                                                                title={`Completed: ${project.statistics.completedLineItems}`}
                                                            ></div>
                                                        )}
                                                        {project.statistics.inProgressLineItems > 0 && (
                                                            <div 
                                                                className="pt-project-summary-bar pt-bar-in-progress" 
                                                                style={{ width: `${(project.statistics.inProgressLineItems / project.statistics.totalLineItems) * 100}%` }}
                                                                title={`In Progress: ${project.statistics.inProgressLineItems}`}
                                                            ></div>
                                                        )}
                                                        {project.statistics.atRiskLineItems > 0 && (
                                                            <div 
                                                                className="pt-project-summary-bar pt-bar-at-risk" 
                                                                style={{ width: `${(project.statistics.atRiskLineItems / project.statistics.totalLineItems) * 100}%` }}
                                                                title={`At Risk: ${project.statistics.atRiskLineItems}`}
                                                            ></div>
                                                        )}
                                                        {project.statistics.issueLineItems > 0 && (
                                                            <div 
                                                                className="pt-project-summary-bar pt-bar-issue" 
                                                                style={{ width: `${(project.statistics.issueLineItems / project.statistics.totalLineItems) * 100}%` }}
                                                                title={`Issue: ${project.statistics.issueLineItems}`}
                                                            ></div>
                                                        )}
                                                        {project.statistics.notStartedLineItems > 0 && (
                                                            <div 
                                                                className="pt-project-summary-bar pt-bar-not-started" 
                                                                style={{ width: `${(project.statistics.notStartedLineItems / project.statistics.totalLineItems) * 100}%` }}
                                                                title={`Not Started: ${project.statistics.notStartedLineItems}`}
                                                            ></div>
                                                        )}
                                                    </div>
                                                    <div className="pt-project-summary-total">{project.statistics.totalLineItems}</div>
                                                </div>
                                                <div className="pt-statistics-details">
                                                    {project.statistics.percentComplete !== null && (
                                                        <span className="pt-stat-item pt-stat-percent">
                                                            {project.statistics.percentComplete}% Complete
                                                        </span>
                                                    )}
                                                    {project.statistics.completedLineItems > 0 && (
                                                        <span className="pt-stat-item pt-stat-completed">
                                                            ✓ {project.statistics.completedLineItems}
                                                        </span>
                                                    )}
                                                    {project.statistics.inProgressLineItems > 0 && (
                                                        <span className="pt-stat-item pt-stat-in-progress">
                                                            ⟳ {project.statistics.inProgressLineItems}
                                                        </span>
                                                    )}
                                                    {project.statistics.atRiskLineItems > 0 && (
                                                        <span className="pt-stat-item pt-stat-at-risk">
                                                            ⚠ {project.statistics.atRiskLineItems}
                                                        </span>
                                                    )}
                                                    {project.statistics.issueLineItems > 0 && (
                                                        <span className="pt-stat-item pt-stat-issue">
                                                            ✖ {project.statistics.issueLineItems}
                                                        </span>
                                                    )}
                                                    {project.statistics.notStartedLineItems > 0 && (
                                                        <span className="pt-stat-item pt-stat-not-started">
                                                            ○ {project.statistics.notStartedLineItems}
                                                        </span>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            <div className="pt-project-no-items">No line items</div>
                                        )}
                                    </div>
                                )}
                            </div>
                            ))}
                        </div>
                    )}
                </div>
                );
            })}
        </div>
    );

};

const ProcurementTrackerHeader = ({apiToken, search, setSearch, refreshProjectsList, timestamp, setAdminMode, viewMode, setViewMode, stepTypeFilter, setStepTypeFilter, statusFilter, setStatusFilter, vendorMap}) => {
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const statusDropdownRef = useRef(null);

    const formatTimestamp = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const clearAllFilters = () => {
        setSearch('');
        setStatusFilter([]);
    };

    // Get unique statuses from vendorMap
    const getUniqueStatuses = () => {
        if (!vendorMap) return [];
        const statuses = new Set();
        Object.values(vendorMap).forEach(vendorProjects => {
            Object.values(vendorProjects).forEach(items => {
                if (Array.isArray(items)) {
                    items.forEach(item => {
                        if (item.status) statuses.add(item.status);
                    });
                }
            });
        });
        return Array.from(statuses).sort();
    };

    const toggleStatusFilter = (status) => {
        setStatusFilter(prev => 
            prev.includes(status) 
                ? prev.filter(s => s !== status)
                : [...prev, status]
        );
    };

    const hasFilters = search || statusFilter.length > 0;

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setShowStatusDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return(
        <div className="procurement-tracker-header">
            <div className="procurement-tracker-header-search">
                <input 
                    type="text" 
                    className="procurement-tracker-header-search-input" 
                    placeholder={viewMode === 'Project' ? 'Search Projects...' : 'Search Vendors...'} 
                    value={search}
                    onChange={(e) => setSearch(e.target.value)} 
                />
                {hasFilters && (
                    <button 
                        className="procurement-tracker-clear-filters-btn"
                        onClick={clearAllFilters}
                        title="Clear all filters"
                    >
                        Clear Filters
                    </button>
                )}
            </div>
            <div className="procurement-tracker-header-filters">
                <div className="view-mode-toggle">
                    <button
                        className={`view-mode-btn ${viewMode === 'Project' ? 'active' : ''}`}
                        onClick={() => setViewMode('Project')}
                    >
                        Project
                    </button>
                    <button
                        className={`view-mode-btn ${viewMode === 'Vendor' ? 'active' : ''}`}
                        onClick={() => setViewMode('Vendor')}
                    >
                        Vendor
                    </button>
                </div>
                {viewMode === 'Vendor' && (
                    <>
                        <div className="view-mode-toggle">
                            <button
                                className={`view-mode-btn ${stepTypeFilter === 'Both' ? 'active' : ''}`}
                                onClick={() => setStepTypeFilter('Both')}
                            >
                                Both
                            </button>
                            <button
                                className={`view-mode-btn ${stepTypeFilter === 'Internal' ? 'active' : ''}`}
                                onClick={() => setStepTypeFilter('Internal')}
                            >
                                Internal
                            </button>
                            <button
                                className={`view-mode-btn ${stepTypeFilter === 'External' ? 'active' : ''}`}
                                onClick={() => setStepTypeFilter('External')}
                            >
                                External
                            </button>
                        </div>
                        <div className="status-filter-container" ref={statusDropdownRef}>
                            <button
                                className={`status-filter-btn ${statusFilter.length > 0 ? 'has-selection' : ''}`}
                                onClick={() => setShowStatusDropdown(!showStatusDropdown)}
                            >
                                Status {statusFilter.length > 0 && `(${statusFilter.length})`}
                                <span className="dropdown-arrow">{showStatusDropdown ? '▲' : '▼'}</span>
                            </button>
                            {showStatusDropdown && (
                                <div className="status-filter-dropdown-list">
                                    {getUniqueStatuses().map(status => (
                                        <label key={status} className="status-filter-option">
                                            <input
                                                type="checkbox"
                                                checked={statusFilter.includes(status)}
                                                onChange={() => toggleStatusFilter(status)}
                                            />
                                            <span className={`status-badge status-${status.toLowerCase().replace(' ', '-')}`}>
                                                {status}
                                            </span>
                                        </label>
                                    ))}
                                    {statusFilter.length > 0 && (
                                        <button
                                            className="clear-status-filter-btn"
                                            onClick={() => setStatusFilter([])}
                                        >
                                            Clear All
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>

            {timestamp && (
                <div className="procurement-tracker-timestamp">
                    {formatTimestamp(timestamp)}
                </div>
            )}
            <button
                className="procurement-tracker-refresh-btn"
                onClick={refreshProjectsList}
                title="Refresh projects list"
            >
                ↻
            </button>
            <button
                className="procurement-tracker-admin-btn"
                onClick={() => setAdminMode(true)}
                title="Admin mode"
            >
                <IoSettings />
            </button>
        </div>
    )
};

const AdminPanel = ({apiToken, user, closeAdminPanel}) => {
    const navigationOptions = ['Home', 'Workflows', 'Roles'];
    const [navigationSelection, setNavigationSelection] = useState('Home');
    const [showAdminNavDropdown, setShowAdminNavDropdown] = useState(false);
    const [workflows, setWorkflows] = useState(null);
    const [workflowsError, setWorkflowsError] = useState(null);
    const [roles, setRoles] = useState(null);
    const [rolesError, setRolesError] = useState(null);

    const refreshProcurementRoles = () => {
        setRoles(null);
        setRolesError(null);
        getAllProcurementRoles(apiToken, setRoles, setRolesError);
    };

    useEffect(() => {
        getAllProcurementWorkflows(apiToken, setWorkflows, setWorkflowsError);
        getAllProcurementRoles(apiToken, setRoles, setRolesError);
    }, [apiToken]);

    const AdminHeader = () => {
        return (
            <div className="admin-panel-header">
                <div className="admin-panel-header-left">
                    <div className="admin-panel-title">Admin Panel - {navigationSelection}</div>
                </div>
                <div className="admin-panel-header-right">
                    <div className="admin-nav-dropdown-container">
                        <button
                            className="admin-nav-dropdown-btn"
                            onClick={() => setShowAdminNavDropdown(!showAdminNavDropdown)}
                            aria-haspopup="listbox"
                            aria-expanded={showAdminNavDropdown}
                        >
                            {navigationSelection}
                            <span className="dropdown-arrow">{showAdminNavDropdown ? '▲' : '▼'}</span>
                        </button>
                        {showAdminNavDropdown && (
                            <div className="admin-nav-dropdown-menu" role="listbox">
                                {navigationOptions.map(opt => (
                                    <div
                                        key={opt}
                                        role="option"
                                        aria-selected={navigationSelection === opt}
                                        className={`admin-nav-dropdown-item ${navigationSelection === opt ? 'selected' : ''}`}
                                        onClick={() => { setNavigationSelection(opt); setShowAdminNavDropdown(false); }}
                                    >
                                        {opt}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <button
                        className="admin-back-btn"
                        onClick={closeAdminPanel}
                        title="Back"
                    >
                        <IoArrowBack />
                    </button>
                </div>
            </div>
        );
    };

    const AdminHome = () => {
        return (
            <div className="admin-panel-content-home">

                <div className="admin-panel-welcome">
                    <h2>Welcome to the Procurement Tracker Admin Panel</h2>
                    <p>Select an option from the navigation menu to get started.</p>
                </div>

                <div className='admin-panel-navigation-pane'>

                    <div className='admin-panel-navigation-option' onClick={() => setNavigationSelection('Workflows')}>
                        <LuWorkflow />
                        <div className='admin-panel-navigation-option-label'>
                            Workflows
                        </div>
                        <div className='admin-panel-navigation-option-subtext'>
                            Add and edit procurement workflows.
                        </div>
                    </div>

                    <div className='admin-panel-navigation-option' onClick={() => setNavigationSelection('Roles')}>
                        <LuUser />
                        <div className='admin-panel-navigation-option-label'>
                            Roles
                        </div>
                        <div className='admin-panel-navigation-option-subtext'>
                            Add and edit workflow roles.
                        </div>
                    </div>
                </div>

            </div>
        );
    };

    const AdminWorkflows = () => {
        const [showCreateWorkflowModal, setShowCreateWorkflowModal] = useState(false);
        const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
        const [showDeleteWorkflowModal, setShowDeleteWorkflowModal] = useState(false);
        const [selectedWorkflow, setSelectedWorkflow] = useState(null);
        const [workflowName, setWorkflowName] = useState('');
        const [tempWorkflowName, setTempWorkflowName] = useState(null);
        const [workflowNameError, setWorkflowNameError] = useState(null);
        const [workflowSteps, setWorkflowSteps] = useState([]);
        const [selectedStepIndex, setSelectedStepIndex] = useState(null);
        const [nextStepId, setNextStepId] = useState(1);
        const [isSaving, setIsSaving] = useState(false);
        const [saveMessage, setSaveMessage] = useState(null); // { type: 'success' | 'error', text: string }
        const [editingWorkflowId, setEditingWorkflowId] = useState(null);
        const [submittingDelete, setSubmittingDelete] = useState(false);
        const [deleteError, setDeleteError] = useState(null);
        const [procoreStatuses, setProcoreStatuses] = useState([]);
        const [procoreStatusesError, setProcoreStatusesError] = useState(null);

        useEffect(() => {
            getSubmittalStatuses(apiToken, setProcoreStatuses, setProcoreStatusesError);
        }, []);

        const handleCloseAttempt = () => {
            if (workflowName) {
                setShowCloseConfirmation(true);
            } else {
                closeCreateWorkflowModal();
            }
        };

        const closeCreateWorkflowModal = () => {
            setShowCreateWorkflowModal(false);
            setShowCloseConfirmation(false);
            setWorkflowName('');
            setTempWorkflowName(null);
            setWorkflowNameError(null);
            setWorkflowSteps([]);
            setSelectedStepIndex(null);
            setNextStepId(1);
            setIsSaving(false);
            setSaveMessage(null);
            setEditingWorkflowId(null);
        };

        const cancelClose = () => {
            setShowCloseConfirmation(false);
        };

        const openEditWorkflowModal = (workflow) => {
            setEditingWorkflowId(workflow.id);
            setWorkflowName(workflow.name);
            setTempWorkflowName(null);
            
            // Convert workflow steps to the format used in the editor
            const steps = workflow.steps.map((step, index) => ({
                id: index + 1,
                name: step.name,
                role: typeof step.role === 'object' ? step.role.id : step.role,
                leadTime: step.leadtime || step.leadTime || '',
                procoreCompletionStatus: Array.isArray(step.procoreCompletionStatus) 
                    ? step.procoreCompletionStatus 
                    : (step.procoreCompletionStatus || step.procore_completion_status ? [step.procoreCompletionStatus || step.procore_completion_status] : [])
            }));
            
            setWorkflowSteps(steps);
            setNextStepId(steps.length + 1);
            setSelectedStepIndex(null);
            setShowCreateWorkflowModal(true);
        };

        const setWorkflowNameFromTemp = () => {
            if (tempWorkflowName !== null && tempWorkflowName.trim()) {
                const trimmedName = tempWorkflowName.trim();
                
                // Check for duplicate names only when creating new workflow (not editing)
                if (!editingWorkflowId && workflows) {
                    const isDuplicate = workflows.some(
                        w => w.name.toLowerCase() === trimmedName.toLowerCase() && w.active
                    );
                    
                    if (isDuplicate) {
                        setWorkflowNameError('A workflow with this name already exists');
                        return;
                    }
                }
                
                setWorkflowName(trimmedName);
                setTempWorkflowName(null);
                setWorkflowNameError(null);
            }
        };

        const addNewStep = () => {
            const newStep = {
                id: nextStepId,
                name: `Step ${nextStepId}`,
                role: '',
                leadTime: '',
                procoreCompletionStatus: []
            };
            setWorkflowSteps([...workflowSteps, newStep]);
            setSelectedStepIndex(workflowSteps.length);
            setNextStepId(nextStepId + 1);
        };

        const updateStepField = (index, field, value) => {
            const updatedSteps = [...workflowSteps];
            updatedSteps[index] = { ...updatedSteps[index], [field]: value };
            setWorkflowSteps(updatedSteps);
        };

        const deleteStep = (index) => {
            const updatedSteps = workflowSteps.filter((_, i) => i !== index);
            setWorkflowSteps(updatedSteps);
            if (selectedStepIndex === index) {
                setSelectedStepIndex(null);
            } else if (selectedStepIndex > index) {
                setSelectedStepIndex(selectedStepIndex - 1);
            }
        };

        const moveStepUp = (index) => {
            if (index === 0) return;
            const updatedSteps = [...workflowSteps];
            [updatedSteps[index - 1], updatedSteps[index]] = [updatedSteps[index], updatedSteps[index - 1]];
            setWorkflowSteps(updatedSteps);
            if (selectedStepIndex === index) {
                setSelectedStepIndex(index - 1);
            } else if (selectedStepIndex === index - 1) {
                setSelectedStepIndex(index);
            }
        };

        const moveStepDown = (index) => {
            if (index === workflowSteps.length - 1) return;
            const updatedSteps = [...workflowSteps];
            [updatedSteps[index], updatedSteps[index + 1]] = [updatedSteps[index + 1], updatedSteps[index]];
            setWorkflowSteps(updatedSteps);
            if (selectedStepIndex === index) {
                setSelectedStepIndex(index + 1);
            } else if (selectedStepIndex === index + 1) {
                setSelectedStepIndex(index);
            }
        };

        const isWorkflowValid = () => {
            if (!workflowName || workflowSteps.length === 0) return false;
            return workflowSteps.every(step => step.name && step.name.trim() && step.role);
        };

        const handleSaveWorkflow = () => {
            if (!isWorkflowValid()) return;
            
            // Check for duplicate names when creating new workflow
            if (!editingWorkflowId && workflows) {
                const isDuplicate = workflows.some(
                    w => w.name.toLowerCase() === workflowName.toLowerCase() && w.active
                );
                
                if (isDuplicate) {
                    setSaveMessage({ 
                        type: 'error', 
                        text: 'A workflow with this name already exists' 
                    });
                    setTimeout(() => {
                        setSaveMessage(null);
                    }, 3000);
                    return;
                }
            }
            
            setIsSaving(true);
            setSaveMessage(null);
            
            const workflowData = {
                name: workflowName,
                steps: workflowSteps.map(step => ({
                    name: step.name,
                    role: step.role,
                    leadtime: step.leadTime || null,
                    procoreCompletionStatus: (Array.isArray(step.procoreCompletionStatus) && step.procoreCompletionStatus.length > 0) ? step.procoreCompletionStatus : null
                })),
                [editingWorkflowId ? 'updatedBy' : 'createdBy']: user.name
            };
            
            const apiCall = editingWorkflowId 
                ? (data, token, success, failure) => updateProcurementWorkflow(editingWorkflowId, data, token, success, failure)
                : createProcurementWorkflow;
            
            apiCall(workflowData, apiToken, 
                (success) => {
                    setIsSaving(false);
                    setSaveMessage({ 
                        type: 'success', 
                        text: editingWorkflowId ? 'Workflow updated successfully!' : 'Workflow created successfully!' 
                    });
                    setTimeout(() => {
                        setSaveMessage(null);
                        closeCreateWorkflowModal();
                        // Refresh workflows list
                        getAllProcurementWorkflows(apiToken, setWorkflows, setWorkflowsError);
                    }, 3000);
                },
                (error) => {
                    setIsSaving(false);
                    setSaveMessage({ 
                        type: 'error', 
                        text: error || `Failed to ${editingWorkflowId ? 'update' : 'create'} workflow` 
                    });
                    setTimeout(() => {
                        setSaveMessage(null);
                    }, 3000);
                }
            );
        };

        const openDeleteWorkflowModal = (workflow) => {
            setSelectedWorkflow(workflow);
            setShowDeleteWorkflowModal(true);
        };

        const closeDeleteWorkflowModal = () => {
            setShowDeleteWorkflowModal(false);
            setSelectedWorkflow(null);
            setDeleteError(null);
        };

        const handleDeleteWorkflow = () => {
            setSubmittingDelete(true);
            setDeleteError(null);
            const workflowData = { deletedBy: user.name };
            deleteProcurementWorkflow(selectedWorkflow.id, apiToken, 
                (success) => {
                    setSubmittingDelete(false);
                    closeDeleteWorkflowModal();
                    // Refresh workflows list
                    getAllProcurementWorkflows(apiToken, setWorkflows, setWorkflowsError);
                },
                (failure) => {
                    setSubmittingDelete(false);
                    setDeleteError(failure || 'Failed to delete workflow');
                }
            );
        };

        return (
            <div className="admin-panel-content-workflows">
                <div className='admin-panel-content-workflows-toolbar'>
                    <div className='admin-panel-content-workflows-title'>Procurement Workflows</div>
                    <div className='admin-panel-content-workflows-instructions'>
                        Create and manage procurement workflows for companies and projects to define approval steps and responsibilities.
                    </div>
                    <button className='admin-panel-content-workflows-create-btn' onClick={() => setShowCreateWorkflowModal(true)}>Create Workflow</button>
                </div>
                <div className='admin-panel-content-workflows-list'>
                    {   workflowsError &&
                        <div className="admin-panel-error-message">
                            <div className="error-icon">⚠</div>
                            <h3>Unable to Load Workflows</h3>
                            <p>{workflowsError}</p>
                        </div>
                    }
                    {   !workflows && !workflowsError &&
                        <div className="admin-panel-loading-message">
                            <div className="pt-loading-spinner"></div>
                            <p>Loading workflows...</p>
                        </div>
                    }
                    {   workflows && workflows.length === 0 &&
                        <div className="admin-panel-no-data-message">
                            <p>No workflows found. Click "Create Workflow" to add your first workflow.</p>
                        </div>
                    }
                    {   workflows && workflows.length > 0 &&
                        <table className='admin-panel-workflows-table'>
                            <thead>
                                <tr>
                                    <th>Workflow Name</th>
                                    <th>Step Count</th>
                                    <th>Created By</th>
                                    <th>Created Date</th>
                                    <th>Updated By</th>
                                    <th>Updated Date</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {workflows.map(workflow => (
                                    <tr key={workflow.id} className={!workflow.active ? 'deleted-workflow' : ''}>
                                        <td>{workflow.name}</td>
                                        <td>{workflow.stepCount || 0}</td>
                                        <td>{workflow.createdBy || '-'}</td>
                                        <td>{workflow.createdDate ? new Date(workflow.createdDate).toLocaleDateString() : '-'}</td>
                                        <td>{workflow.updatedBy || '-'}</td>
                                        <td>{workflow.updatedDate ? new Date(workflow.updatedDate).toLocaleDateString() : '-'}</td>
                                        <td>
                                            {workflow.active ? (
                                                <span className="workflow-status-active">Active</span>
                                            ) : (
                                                <span className="workflow-status-deleted">Deleted</span>
                                            )}
                                        </td>
                                        <td>
                                            <button 
                                                className='admin-panel-workflows-edit-btn'
                                                disabled={!workflow.active}
                                                onClick={() => openEditWorkflowModal(workflow)}
                                            >
                                                Edit
                                            </button>
                                            <button 
                                                className='admin-panel-workflows-delete-btn'
                                                disabled={!workflow.active}
                                                onClick={() => openDeleteWorkflowModal(workflow)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                </div>

                {showCreateWorkflowModal && (
                    <div className="workflow-create-modal-overlay">
                        <div className="workflow-create-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="workflow-create-modal-header">
                                <div className="workflow-create-modal-title">
                                    {editingWorkflowId ? 'Edit Workflow' : (workflowName || 'New Workflow')}
                                </div>
                                <div className="workflow-create-modal-header-actions">
                                    {saveMessage && (
                                        <div className={`workflow-save-message workflow-save-message-${saveMessage.type}`}>
                                            {saveMessage.text}
                                        </div>
                                    )}
                                    {workflowName && workflowSteps.length > 0 && (
                                        <button
                                            className="workflow-save-btn"
                                            onClick={handleSaveWorkflow}
                                            disabled={!isWorkflowValid() || isSaving}
                                        >
                                            {isSaving ? (
                                                <>
                                                    <div className="pt-loading-spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }}></div>
                                                    <span>Saving...</span>
                                                </>
                                            ) : (
                                                'Save Workflow'
                                            )}
                                        </button>
                                    )}
                                    <button
                                        className="workflow-create-modal-close"
                                        onClick={handleCloseAttempt}
                                        aria-label="Close"
                                        disabled={isSaving}
                                    >
                                        ×
                                    </button>
                                </div>
                            </div>
                            <div className="workflow-create-modal-content">
                                <div className="workflow-create-modal-content-workflow" onClick={(e) => {
                                    if (workflowName && !e.target.closest('.workflow-step-box') && !e.target.closest('.workflow-add-step-btn') && !e.target.closest('.workflow-add-first-step')) {
                                        setSelectedStepIndex(null);
                                    }
                                }}>
                                    {!workflowName ? (
                                        <div className="workflow-name-input-container">
                                            <div className="workflow-name-input-title">Name Your Workflow</div>
                                            <div className="workflow-name-input-subtitle">Enter a descriptive name for this workflow to get started</div>
                                            <input
                                                type="text"
                                                className="workflow-name-input"
                                                placeholder="e.g., Standard Procurement Approval"
                                                value={tempWorkflowName || ''}
                                                onChange={(e) => {
                                                    setTempWorkflowName(e.target.value);
                                                    setWorkflowNameError(null);
                                                }}
                                                onKeyPress={(e) => e.key === 'Enter' && setWorkflowNameFromTemp()}
                                                autoFocus
                                            />
                                            {workflowNameError && (
                                                <div className="workflow-name-error">
                                                    {workflowNameError}
                                                </div>
                                            )}
                                            <button
                                                className="workflow-name-set-btn"
                                                onClick={setWorkflowNameFromTemp}
                                                disabled={!tempWorkflowName || !tempWorkflowName.trim()}
                                            >
                                                Set Workflow Name
                                            </button>
                                        </div>
                                    ) : workflowSteps.length === 0 ? (
                                        <div className="workflow-add-first-step" onClick={addNewStep}>
                                            <div className="workflow-add-icon">+</div>
                                            <div className="workflow-add-text">Add First Step</div>
                                        </div>
                                    ) : (
                                        <div className="workflow-steps-container">
                                            {workflowSteps.map((step, index) => (
                                                <div key={step.id} className="workflow-step-wrapper">
                                                    <div 
                                                        className={`workflow-step-box ${selectedStepIndex === index ? 'selected' : ''}`}
                                                        onClick={() => setSelectedStepIndex(index)}
                                                    >
                                                        <div className="workflow-step-number">Step {index + 1}</div>
                                                        <div className="workflow-step-name">{step.name}</div>
                                                        {step.role && (
                                                            <div className="workflow-step-role">
                                                                {roles?.find(r => r.id === parseInt(step.role))?.name || 'Unknown Role'}
                                                                {(() => {
                                                                    const role = roles?.find(r => r.id === parseInt(step.role));
                                                                    if (role) {
                                                                        return (
                                                                            <span style={{
                                                                                marginLeft: '6px',
                                                                                padding: '2px 6px',
                                                                                borderRadius: '4px',
                                                                                fontSize: '10px',
                                                                                fontWeight: 'bold',
                                                                                backgroundColor: role.type === 'Internal' ? 'var(--primary-color)' : '#ccc',
                                                                                color: role.type === 'Internal' ? 'white' : 'black'
                                                                            }}>
                                                                                {role.type === 'Internal' ? 'INT' : 'EXT'}
                                                                            </span>
                                                                        );
                                                                    }
                                                                })()}
                                                            </div>
                                                        )}
                                                        {step.leadTime && (
                                                            <div className="workflow-step-leadtime-badge">
                                                                {step.leadTime} days
                                                            </div>
                                                        )}
                                                    </div>
                                                    {index < workflowSteps.length - 1 && (
                                                        <div className="workflow-step-connector">↓</div>
                                                    )}
                                                </div>
                                            ))}
                                            <div className="workflow-add-step-btn" onClick={addNewStep}>
                                                <div className="workflow-add-icon-small">+</div>
                                                <div className="workflow-add-text-small">Add Step</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="workflow-create-modal-content-toolbar">
                                    {selectedStepIndex !== null && workflowSteps[selectedStepIndex] ? (
                                        <div className="workflow-toolbar-content">
                                            <div className="workflow-toolbar-title">Step Details</div>
                                            
                                            <div className="workflow-toolbar-field">
                                                <label className="workflow-toolbar-label">Step Name <span className="required-field">*</span></label>
                                                <input
                                                    type="text"
                                                    className="workflow-toolbar-input"
                                                    placeholder="Enter step name..."
                                                    value={workflowSteps[selectedStepIndex].name}
                                                    onChange={(e) => updateStepField(selectedStepIndex, 'name', e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="workflow-toolbar-field">
                                                <label className="workflow-toolbar-label">Role <span className="required-field">*</span></label>
                                                <select
                                                    className="workflow-toolbar-select"
                                                    value={workflowSteps[selectedStepIndex].role}
                                                    onChange={(e) => updateStepField(selectedStepIndex, 'role', e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select a role...</option>
                                                    {roles && roles.filter(r => r.active).map(role => (
                                                        <option key={role.id} value={role.id}>
                                                            {role.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="workflow-toolbar-field">
                                                <label className="workflow-toolbar-label">Estimated Lead Time (days)</label>
                                                <input
                                                    type="number"
                                                    className="workflow-toolbar-input"
                                                    placeholder="Enter lead time..."
                                                    value={workflowSteps[selectedStepIndex].leadTime}
                                                    onChange={(e) => updateStepField(selectedStepIndex, 'leadTime', e.target.value)}
                                                    min="0"
                                                />
                                            </div>

                                            <div className="workflow-toolbar-field">
                                                <label className="workflow-toolbar-label">Procore Completion Status</label>
                                                <div style={{ fontSize: '11px', color: '#666', marginBottom: '8px', lineHeight: '1.3' }}>
                                                    When the submittal linked to this workflow is set to this status, the step will be automatically be marked complete. (Including all previous steps).
                                                </div>
                                                <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', padding: '8px' }}>
                                                    {procoreStatuses && procoreStatuses.map(status => {
                                                        const currentStatuses = Array.isArray(workflowSteps[selectedStepIndex].procoreCompletionStatus) 
                                                            ? workflowSteps[selectedStepIndex].procoreCompletionStatus 
                                                            : [];
                                                        const isChecked = currentStatuses.includes(status.name);
                                                        return (
                                                            <div key={status.id} style={{ marginBottom: '6px', display: 'flex', alignItems: 'center' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`status-${selectedStepIndex}-${status.id}`}
                                                                    checked={isChecked}
                                                                    onChange={(e) => {
                                                                        const newStatuses = e.target.checked
                                                                            ? [...currentStatuses, status.name]
                                                                            : currentStatuses.filter(s => s !== status.name);
                                                                        updateStepField(selectedStepIndex, 'procoreCompletionStatus', newStatuses);
                                                                    }}
                                                                    style={{ marginRight: '8px', cursor: 'pointer' }}
                                                                />
                                                                <label 
                                                                    htmlFor={`status-${selectedStepIndex}-${status.id}`}
                                                                    style={{ cursor: 'pointer', margin: 0, fontSize: '13px' }}
                                                                >
                                                                    {status.name}
                                                                </label>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            <div className="workflow-toolbar-actions">
                                                <div className="workflow-toolbar-section-title">Actions</div>
                                                <div className="workflow-toolbar-button-group">
                                                    <button
                                                        className="workflow-toolbar-action-btn"
                                                        onClick={() => moveStepUp(selectedStepIndex)}
                                                        disabled={selectedStepIndex === 0}
                                                        title="Move up"
                                                    >
                                                        ↑ Move Up
                                                    </button>
                                                    <button
                                                        className="workflow-toolbar-action-btn"
                                                        onClick={() => moveStepDown(selectedStepIndex)}
                                                        disabled={selectedStepIndex === workflowSteps.length - 1}
                                                        title="Move down"
                                                    >
                                                        ↓ Move Down
                                                    </button>
                                                </div>
                                                <button
                                                    className="workflow-toolbar-delete-btn"
                                                    onClick={() => deleteStep(selectedStepIndex)}
                                                >
                                                    Delete Step
                                                </button>
                                            </div>
                                        </div>
                                    ) : workflowName ? (
                                        <div className="workflow-toolbar-content">
                                            <div className="workflow-toolbar-title">Workflow Details</div>
                                            
                                            <div className="workflow-toolbar-field">
                                                <label className="workflow-toolbar-label">Workflow Name</label>
                                                <input
                                                    type="text"
                                                    className="workflow-toolbar-input"
                                                    placeholder="Enter workflow name..."
                                                    value={tempWorkflowName !== null ? tempWorkflowName : workflowName}
                                                    onChange={(e) => {
                                                        setTempWorkflowName(e.target.value);
                                                        setWorkflowNameError(null);
                                                    }}
                                                />
                                                {workflowNameError && (
                                                    <div className="workflow-name-error" style={{ marginTop: '8px' }}>
                                                        {workflowNameError}
                                                    </div>
                                                )}
                                                {tempWorkflowName !== null && tempWorkflowName !== workflowName && (
                                                    <button
                                                        className="workflow-toolbar-update-name-btn"
                                                        onClick={setWorkflowNameFromTemp}
                                                    >
                                                        Update Name
                                                    </button>
                                                )}
                                            </div>

                                            <div className="workflow-toolbar-info">
                                                <div className="workflow-toolbar-info-item">
                                                    <span className="workflow-toolbar-info-label">Total Steps:</span>
                                                    <span className="workflow-toolbar-info-value">{workflowSteps.length}</span>
                                                </div>
                                                <div className="workflow-toolbar-info-item">
                                                    <span className="workflow-toolbar-info-label">Internal Steps:</span>
                                                    <span className="workflow-toolbar-info-value">
                                                        {workflowSteps.filter(step => {
                                                            const role = roles?.find(r => r.id === parseInt(step.role));
                                                            return role?.type === 'Internal';
                                                        }).length}
                                                    </span>
                                                </div>
                                                <div className="workflow-toolbar-info-item">
                                                    <span className="workflow-toolbar-info-label">External Steps:</span>
                                                    <span className="workflow-toolbar-info-value">
                                                        {workflowSteps.filter(step => {
                                                            const role = roles?.find(r => r.id === parseInt(step.role));
                                                            return role?.type === 'External';
                                                        }).length}
                                                    </span>
                                                </div>
                                                <div className="workflow-toolbar-info-item">
                                                    <span className="workflow-toolbar-info-label">Estimated Total Lead Time (days):</span>
                                                    <span className="workflow-toolbar-info-value">
                                                        {workflowSteps.reduce((total, step) => {
                                                            const leadTime = parseInt(step.leadTime) || 0;
                                                            return total + leadTime;
                                                        }, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="workflow-toolbar-empty">
                                            <p>Select a step to edit its details</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {showCloseConfirmation && (
                                <div className="workflow-close-confirmation-overlay" onClick={cancelClose}>
                                    <div className="workflow-close-confirmation-modal" onClick={(e) => e.stopPropagation()}>
                                        <div className="workflow-close-confirmation-header">
                                            <div className="workflow-close-confirmation-title">Discard Workflow?</div>
                                        </div>
                                        <div className="workflow-close-confirmation-content">
                                            <p>Are you sure you want to close? Your workflow progress will be lost.</p>
                                        </div>
                                        <div className="workflow-close-confirmation-footer">
                                            <button className="workflow-close-confirmation-cancel-btn" onClick={cancelClose}>
                                                Cancel
                                            </button>
                                            <button className="workflow-close-confirmation-discard-btn" onClick={closeCreateWorkflowModal}>
                                                Discard
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {showDeleteWorkflowModal && (
                    <div className="workflow-delete-modal-overlay" onClick={closeDeleteWorkflowModal}>
                        <div className="workflow-delete-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="workflow-delete-modal-header">
                                <div className="workflow-delete-modal-title">Delete Workflow</div>
                                <button
                                    className="workflow-delete-modal-close"
                                    onClick={closeDeleteWorkflowModal}
                                    aria-label="Close"
                                    disabled={submittingDelete}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="workflow-delete-modal-content">
                                <p>Are you sure you want to delete the workflow <strong>{selectedWorkflow?.name}</strong>?</p>
                                <p>This action cannot be undone.</p>
                                {deleteError && (
                                    <div className="workflow-delete-error">
                                        <div className="error-icon">⚠</div>
                                        <span>{deleteError}</span>
                                    </div>
                                )}
                            </div>
                            <div className="workflow-delete-modal-footer">
                                <button
                                    className="workflow-delete-cancel-btn"
                                    onClick={closeDeleteWorkflowModal}
                                    disabled={submittingDelete}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="workflow-delete-confirm-btn"
                                    onClick={handleDeleteWorkflow}
                                    disabled={submittingDelete}
                                >
                                    {submittingDelete ? (
                                        <>
                                            <div className="pt-loading-spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }}></div>
                                            <span>Deleting...</span>
                                        </>
                                    ) : (
                                        'Delete Workflow'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const AdminRoles = () => {
        const [showCreateRoleModal, setShowCreateRoleModal] = useState(false);
        const [showEditRoleModal, setShowEditRoleModal] = useState(false);
        const [showDeleteRoleModal, setShowDeleteRoleModal] = useState(false);
        const [selectedRole, setSelectedRole] = useState(null);
        const [newRoleName, setNewRoleName] = useState('');
        const [newRoleType, setNewRoleType] = useState('Internal');
        const [submittingUpdate, setSubmittingUpdate] = useState(false);
        const [updateError, setUpdateError] = useState(null);

        const handleCreateRole = () => {
            // Check for duplicate names
            if (roles) {
                const isDuplicate = roles.some(
                    r => r.name.toLowerCase() === newRoleName.trim().toLowerCase() && r.active
                );
                
                if (isDuplicate) {
                    setUpdateError('A role with this name already exists');
                    return;
                }
            }
            
            setSubmittingUpdate(true);
            setUpdateError(null);
            const roleData = { name: newRoleName, type: newRoleType, createdBy: user.name };
            createProcurementRole(roleData, apiToken, (success) => {
                refreshProcurementRoles();
                setShowCreateRoleModal(false);
                setNewRoleName('');
                setNewRoleType('Internal');
                setSubmittingUpdate(false);
            }, (failure) => {
                console.error('Error creating role:', failure);
                setUpdateError(failure);
                setSubmittingUpdate(false);
            });
        };

        const handleUpdateRole = () => {
            if (!selectedRole) return;
            setSubmittingUpdate(true);
            setUpdateError(null);
            const roleData = { name: newRoleName, type: newRoleType, updatedBy: user.name };
            editProcurementRole(selectedRole.id, roleData, apiToken, (success) => {
                refreshProcurementRoles();
                setShowEditRoleModal(false);
                setSelectedRole(null);
                setNewRoleName('');
                setNewRoleType('Internal');
                setSubmittingUpdate(false);
            }, (failure) => {
                console.error('Error updating role:', failure);
                setUpdateError(failure);
                setSubmittingUpdate(false);
            });
        };

        const handleDeleteRole = () => {
            if (!selectedRole) return;
            setSubmittingUpdate(true);
            setUpdateError(null);
            const roleData = { updatedBy: user.name };
            deleteProcurementRole(selectedRole.id, roleData, apiToken, (success) => {
                refreshProcurementRoles();
                setShowDeleteRoleModal(false);
                setSelectedRole(null);
                setSubmittingUpdate(false);
            }, (failure) => {
                console.error('Error deleting role:', failure);
                setUpdateError(failure);
                setSubmittingUpdate(false);
            });
        };

        const closeCreateRoleModal = () => {
            setShowCreateRoleModal(false);
            setNewRoleName('');
            setNewRoleType('Internal');
            setUpdateError(null);
        };

        const openEditRoleModal = (role) => {
            setSelectedRole(role);
            setNewRoleName(role.name);
            setNewRoleType(role.type);
            setUpdateError(null);
            setShowEditRoleModal(true);
        };

        const closeEditRoleModal = () => {
            setShowEditRoleModal(false);
            setSelectedRole(null);
            setNewRoleName('');
            setNewRoleType('Internal');
            setUpdateError(null);
        };

        const openDeleteRoleModal = (role) => {
            setSelectedRole(role);
            setUpdateError(null);
            setShowDeleteRoleModal(true);
        };

        const closeDeleteRoleModal = () => {
            setShowDeleteRoleModal(false);
            setSelectedRole(null);
            setUpdateError(null);
        };

        return (
            <div className="admin-panel-content-roles">
                <div className='admin-panel-content-roles-toolbar'>
                    <div className='admin-panel-content-roles-title'>Workflow Roles</div>
                    <div className='admin-panel-content-roles-instructions'>
                        Create and manage Workflow Roles which are used in Company and Project workflows to define step responsibilities.
                    </div>
                    <button className='admin-panel-content-roles-create-btn' onClick={() => setShowCreateRoleModal(true)}>Create Role</button>
                </div>
                <div className='admin-panel-content-roles-list'>
                    {   rolesError &&
                        <div className="admin-panel-error-message">
                            <div className="error-icon">⚠</div>
                            <h3>Unable to Load Roles</h3>
                            <p>{rolesError}</p>
                        </div>
                    }
                    {   !roles && !rolesError &&
                        <div className="admin-panel-loading-message">
                            <div className="pt-loading-spinner"></div>
                            <p>Loading roles...</p>
                        </div>
                    }
                    {   roles && roles.length === 0 &&
                        <div className="admin-panel-no-data-message">
                            <p>No roles found. Click "Create Role" to add your first role.</p>
                        </div>
                    }
                    {   roles && roles.length > 0 &&
                        <table className='admin-panel-roles-table'>
                            <thead>
                                <tr>
                                    <th>Role Name</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Created By</th>
                                    <th>Created Date</th>
                                    <th>Updated By</th>
                                    <th>Updated Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {roles.map(role => (
                                    <tr key={role.id} className={!role.active ? 'deleted-role' : ''}>
                                        <td>{role.name}</td>
                                        <td>{role.type}</td>
                                        <td>
                                            {role.active ? (
                                                <span className="role-status-active">Active</span>
                                            ) : (
                                                <span className="role-status-deleted">Deleted</span>
                                            )}
                                        </td>
                                        <td>{role.createdBy || '-'}</td>
                                        <td>{role.createdDate ? new Date(role.createdDate).toLocaleDateString() : '-'}</td>
                                        <td>{role.updatedBy || '-'}</td>
                                        <td>{role.updatedDate ? new Date(role.updatedDate).toLocaleDateString() : '-'}</td>
                                        <td>
                                            <button 
                                                className='admin-panel-roles-edit-btn'
                                                onClick={() => openEditRoleModal(role)}
                                                disabled={submittingUpdate || !role.active}
                                            >
                                                Edit
                                            </button>
                                            <button 
                                                className='admin-panel-roles-delete-btn'
                                                onClick={() => openDeleteRoleModal(role)}
                                                disabled={submittingUpdate || !role.active}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                </div>

                {showCreateRoleModal && (
                    <div className="role-create-modal-overlay" onClick={closeCreateRoleModal}>
                        <div className="role-create-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="role-create-modal-header">
                                <div className="role-create-modal-title">Create Role</div>
                                <button
                                    className="role-create-modal-close"
                                    onClick={closeCreateRoleModal}
                                    aria-label="Close"
                                >
                                    ×
                                </button>
                            </div>
                            <div className="role-create-modal-content">
                                {updateError && (
                                    <div className="role-create-modal-error">
                                        <div className="error-icon">⚠</div>
                                        <span>{updateError}</span>
                                    </div>
                                )}
                                <div className="role-create-modal-field">
                                    <label className="role-create-modal-label">Role Name</label>
                                    <input
                                        type="text"
                                        className="role-create-modal-input"
                                        placeholder="Enter role name..."
                                        value={newRoleName}
                                        onChange={(e) => {
                                            setNewRoleName(e.target.value);
                                            setUpdateError(null);
                                        }}
                                        disabled={submittingUpdate}
                                    />
                                </div>
                                <div className="role-create-modal-field">
                                    <label className="role-create-modal-label">Type</label>
                                    <div className="role-create-modal-type-options">
                                        <button
                                            className={`role-create-modal-type-btn ${newRoleType === 'Internal' ? 'active' : ''}`}
                                            onClick={() => setNewRoleType('Internal')}
                                            disabled={submittingUpdate}
                                        >
                                            Internal
                                        </button>
                                        <button
                                            className={`role-create-modal-type-btn ${newRoleType === 'External' ? 'active' : ''}`}
                                            onClick={() => setNewRoleType('External')}
                                            disabled={submittingUpdate}
                                        >
                                            External
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="role-create-modal-footer">
                                <button 
                                    className="role-create-modal-cancel-btn" 
                                    onClick={closeCreateRoleModal}
                                    disabled={submittingUpdate}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="role-create-modal-save-btn"
                                    onClick={handleCreateRole}
                                    disabled={!newRoleName.trim() || submittingUpdate}
                                >
                                    {submittingUpdate ? (
                                        <>
                                            <div className="pt-loading-spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }}></div>
                                            <span>Saving...</span>
                                        </>
                                    ) : (
                                        'Save'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showEditRoleModal && selectedRole && (
                    <div className="role-create-modal-overlay" onClick={closeEditRoleModal}>
                        <div className="role-create-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="role-create-modal-header">
                                <div className="role-create-modal-title">Edit Role</div>
                                <button
                                    className="role-create-modal-close"
                                    onClick={closeEditRoleModal}
                                    aria-label="Close"
                                >
                                    ×
                                </button>
                            </div>
                            <div className="role-create-modal-content">
                                {updateError && (
                                    <div className="role-create-modal-error">
                                        <div className="error-icon">⚠</div>
                                        <span>{updateError}</span>
                                    </div>
                                )}
                                <div className="role-create-modal-field">
                                    <label className="role-create-modal-label">Role Name</label>
                                    <input
                                        type="text"
                                        className="role-create-modal-input"
                                        placeholder="Enter role name..."
                                        value={newRoleName}
                                        onChange={(e) => {
                                            setNewRoleName(e.target.value);
                                            setUpdateError(null);
                                        }}
                                        disabled={submittingUpdate}
                                    />
                                </div>
                                <div className="role-create-modal-field">
                                    <label className="role-create-modal-label">Type</label>
                                    <div className="role-create-modal-type-options">
                                        <button
                                            className={`role-create-modal-type-btn ${newRoleType === 'Internal' ? 'active' : ''}`}
                                            onClick={() => setNewRoleType('Internal')}
                                            disabled={submittingUpdate}
                                        >
                                            Internal
                                        </button>
                                        <button
                                            className={`role-create-modal-type-btn ${newRoleType === 'External' ? 'active' : ''}`}
                                            onClick={() => setNewRoleType('External')}
                                            disabled={submittingUpdate}
                                        >
                                            External
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="role-create-modal-footer">
                                <button 
                                    className="role-create-modal-cancel-btn" 
                                    onClick={closeEditRoleModal}
                                    disabled={submittingUpdate}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="role-create-modal-save-btn"
                                    onClick={handleUpdateRole}
                                    disabled={!newRoleName.trim() || submittingUpdate}
                                >
                                    {submittingUpdate ? (
                                        <>
                                            <div className="pt-loading-spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }}></div>
                                            <span>Saving...</span>
                                        </>
                                    ) : (
                                        'Save'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showDeleteRoleModal && selectedRole && (
                    <div className="role-create-modal-overlay" onClick={closeDeleteRoleModal}>
                        <div className="role-create-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="role-create-modal-header">
                                <div className="role-create-modal-title">Delete Role</div>
                                <button
                                    className="role-create-modal-close"
                                    onClick={closeDeleteRoleModal}
                                    aria-label="Close"
                                >
                                    ×
                                </button>
                            </div>
                            <div className="role-create-modal-content">
                                {updateError && (
                                    <div className="role-create-modal-error">
                                        <div className="error-icon">⚠</div>
                                        <span>{updateError}</span>
                                    </div>
                                )}
                                <div className="role-delete-modal-message">
                                    <p>Are you sure you want to delete the role <strong>{selectedRole.name}</strong>?</p>
                                    <p className="role-delete-modal-warning">This action cannot be undone.</p>
                                </div>
                            </div>
                            <div className="role-create-modal-footer">
                                <button 
                                    className="role-create-modal-cancel-btn" 
                                    onClick={closeDeleteRoleModal}
                                    disabled={submittingUpdate}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="role-delete-modal-delete-btn"
                                    onClick={handleDeleteRole}
                                    disabled={submittingUpdate}
                                >
                                    {submittingUpdate ? (
                                        <>
                                            <div className="pt-loading-spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }}></div>
                                            <span>Deleting...</span>
                                        </>
                                    ) : (
                                        'Delete'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const AdminContent = () => {
        return (
            <div className="admin-panel-content">
                {navigationSelection === 'Home' && <AdminHome />}
                {navigationSelection === 'Workflows' && <AdminWorkflows />}
                {navigationSelection === 'Roles' && <AdminRoles />}
            </div>
        );
    };

    return (
        <div className="admin-panel">
            <AdminHeader />
            <AdminContent />
        </div>
    );
};

const ProcurementTracker = () => {
    const contextValue = useContext(Context);
    const [ workflows, setWorkflows ] = useState([]);
    const [ projects, setProjects] = useState(null);
    const [ vendorMap, setVendorMap ] = useState(null);
    const [ vendors, setVendors ] = useState(null);
    const [ projectSearch, setSearch ] = useState('');
    const [ filteredProjects, setFilteredProjects ] = useState(null);
    const [ filteredVendors, setFilteredVendors ] = useState(null);
    const [ projectsError, setProjectsError ] = useState(null);
    const [ selectedProject, setSelectedProject ] = useState(null);
    const [ branchFilters, setBranchFilters ] = useState([]);
    const [ projectFilters, setProjectFilters ] = useState([]);
    const [ timeStamp, setTimestamp ] = useState(null);
    const [ projectSubmittals, setProjectSubmittals ] = useState(null);
    const [ projectSubmittalsError, setProjectSubmittalsError ] = useState(null);
    const [ viewMode, setViewMode ] = useState('Project'); // 'Project' or 'Vendor'
    const [ stepTypeFilter, setStepTypeFilter ] = useState('Both'); // 'Both', 'Internal', or 'External'
    const [ statusFilter, setStatusFilter ] = useState([]); // Array of selected statuses

    const [adminMode, setAdminMode] = useState(false);

    const refreshProjectsList = () => {
        setProjects(null);
        setFilteredProjects(null);
        setProjectsError(null);
        getAllProjects(contextValue.apiToken, setProjects, setVendorMap, setProjectsError, setTimestamp);
    };

    useEffect(() => {
        refreshProjectsList();
        if(!vendors) getVendors(contextValue.apiToken, setVendors, (error) => console.error(error));
        if(!workflows || workflows.length === 0) getAllProcurementWorkflows(contextValue.apiToken, setWorkflows, (errors) => console.log(errors));
    }, []);


    useEffect(() => {
        if (!filteredProjects) setFilteredProjects(projects);
        if (!filteredVendors) setFilteredVendors(vendorMap);
        if (projects && vendorMap) {
            if (selectedProject) {
                const updatedProject = Object.values(projects || {}).flat().find(p => p.id === selectedProject.id);
                setSelectedProject(updatedProject || null);
            };
        }
    }, [projects, vendorMap]);

    useEffect(() => {
        if (selectedProject) {
            setProjectSubmittals(null);
            setProjectSubmittalsError(null);
            getProjectSubmittals(selectedProject.id, contextValue.apiToken, setProjectSubmittals, setProjectSubmittalsError);
            getAllProcurementWorkflows(contextValue.apiToken, setWorkflows, (errors) => console.log(errors));
        };
    }, [selectedProject]);

    useEffect(() => {
        if (viewMode === 'Project' && projects) {
            const lowerSearch = projectSearch.toLowerCase();
            const filtered = {};
            for (const branch in projects) {
                filtered[branch] = projects[branch].filter(project => {
                    const matchesSearch = project.displayName.toLowerCase().includes(lowerSearch);
                    const matchesProjectFilter = projectFilters.length === 0 || projectFilters.includes(project.project_number);
                    return matchesSearch && matchesProjectFilter;
                });
            }
            setFilteredProjects(filtered);
        } else if (viewMode === 'Vendor' && vendorMap) {
            const lowerSearch = projectSearch.toLowerCase();
            const filtered = {};
            for (const vendorName in vendorMap) {
                const matchesSearch = vendorName.toLowerCase().includes(lowerSearch);
                if (matchesSearch) {
                    filtered[vendorName] = vendorMap[vendorName];
                }
            }
            setFilteredVendors(filtered);
        }
    }, [projectSearch, projectFilters, viewMode, projects, vendorMap]);

    const availableBranches = projects ? Object.keys(projects).sort((a, b) => parseInt(a) - parseInt(b)) : [];

    const closeProjectDetails = () => {
        setSelectedProject(null);
        setProjectSubmittals(null);
        setProjectSubmittalsError(null);
    };

    const projectHeaderProps = {
        apiToken: contextValue.apiToken,
        search: projectSearch,
        setSearch,
        refreshProjectsList,
        timestamp: timeStamp,
        setAdminMode,
        viewMode,
        setViewMode,
        stepTypeFilter,
        setStepTypeFilter,
        statusFilter,
        setStatusFilter,
        vendorMap,
    };

    const projectsDisplayProps = {
        apiToken: contextValue.apiToken,
        filteredProjects,
        filteredVendors,
        projectsError,
        setSelectedProject,
        branchFilters,
        viewMode,
        stepTypeFilter,
        statusFilter,
        workflows,
        vendors,
        userName: contextValue.activeUser.name,
        refreshData: refreshProjectsList,
    };

    const projectDetailsProps = {
        apiToken: contextValue.apiToken,
        workflows,
        vendors,
        userName: contextValue.activeUser.name,
        refreshData: refreshProjectsList,
        selectedProject,
        closeProjectDetails,
        projectSubmittals,
    };

    const adminPanelProps = {
        apiToken: contextValue.apiToken,
        user: contextValue.activeUser,
        closeAdminPanel: () => setAdminMode(false),
    };

    return (
        <div className="procurement-tracker">
            {   !adminMode &&
                <>
                    <ProcurementTrackerHeader {...projectHeaderProps} />
                    <ProjectsDisplay {...projectsDisplayProps} />

                    {selectedProject && (
                        <ProjectDetails {...projectDetailsProps} />
                    )}
                </>
            }
            {   adminMode &&
                <AdminPanel {...adminPanelProps} />
            }
        </div>
    );
};

export default ProcurementTracker; 